(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
window.Backbone = require('backbone');

window.Backbone.$ = window.$;

require('../../modules/tracking/frontend/initializer');

require('../../modules/buy_button/frontend/buy_button');

require('../../modules/buy_button/frontend/multi_option_modal');

require('../../modules/cash_back/frontend/cash_back');

require('../../modules/deal/frontend/channel_tabs');

require('../../modules/deal/frontend/controller');

require('../../modules/deal/frontend/external_links');

require('../../modules/deal_types/frontend/deal_type');

require('../../modules/gift_button/frontend/gift');

require('../../modules/g_map/frontend/main');

require('../../modules/external_deal/frontend/external_deal');

require('../../modules/sharing/frontend/facebook');

require('../../modules/deal/frontend/deal_lazy_loader');

require('../../modules/header/frontend/main');

require('../../modules/variations/frontend/variations-widget');

require('../../modules/inline_variations/frontend/inline_variations');

require('../../modules/doubleclick/frontend/dfp_ads');

require('../../modules/deal_widget/frontend/deal_widgets');

require('../../modules/urgency_messaging/frontend/countdown_timer');

require('../../modules/urgency_messaging/frontend/urgency_messaging');

require('../../modules/ad_unit/frontend/ad_unit_lazy_loader');

require('groupon-iframe-login');

require('../../node_modules/widget-layout-assets/coffee/wls');

require('../../modules/groupon-deal-timer/common/helpers');

require('../../modules/groupon-deal-timer/frontend/models/countdown_timer');

require('../../modules/groupon-deal-timer/frontend/views/countdown_timer');

require('../../modules/groupon-deal-timer/frontend/countdown_timer');

require('hogan.js');

require('../../modules/groupon-deal-carousel/frontend/swfobject-2.2');

require('../../modules/groupon-deal-carousel/frontend/detect-flash');

require('../../modules/groupon-deal-carousel/frontend/templates/main');

require('../../modules/groupon-deal-carousel/frontend/helpers');

require('../../modules/groupon-deal-carousel/frontend/models/media');

require('../../modules/groupon-deal-carousel/frontend/views/carousel');

require('../../modules/groupon-deal-carousel/frontend/carousel');

$(window).load(function() {
  var ref, ref1;
  Groupon.Performance.pageReady();
  if ((ref = Groupon.DFPAds) != null) {
    if (typeof ref.load === "function") {
      ref.load();
    }
  }
  if ((ref1 = Groupon.DFPAds) != null) {
    if (typeof ref1.showAds === "function") {
      ref1.showAds();
    }
  }
  return typeof AdUnitLazyLoader !== "undefined" && AdUnitLazyLoader !== null ? AdUnitLazyLoader.load() : void 0;
});



},{"../../modules/ad_unit/frontend/ad_unit_lazy_loader":3,"../../modules/buy_button/frontend/buy_button":4,"../../modules/buy_button/frontend/multi_option_modal":5,"../../modules/cash_back/frontend/cash_back":8,"../../modules/deal/frontend/channel_tabs":9,"../../modules/deal/frontend/controller":10,"../../modules/deal/frontend/deal_lazy_loader":11,"../../modules/deal/frontend/external_links":13,"../../modules/deal_types/frontend/deal_type":14,"../../modules/deal_widget/frontend/deal_widgets":17,"../../modules/doubleclick/frontend/dfp_ads":21,"../../modules/external_deal/frontend/external_deal":22,"../../modules/g_map/frontend/main":24,"../../modules/gift_button/frontend/gift":27,"../../modules/groupon-deal-carousel/frontend/carousel":29,"../../modules/groupon-deal-carousel/frontend/detect-flash":30,"../../modules/groupon-deal-carousel/frontend/helpers":31,"../../modules/groupon-deal-carousel/frontend/models/media":32,"../../modules/groupon-deal-carousel/frontend/swfobject-2.2":33,"../../modules/groupon-deal-carousel/frontend/templates/main":34,"../../modules/groupon-deal-carousel/frontend/views/carousel":35,"../../modules/groupon-deal-timer/common/helpers":36,"../../modules/groupon-deal-timer/frontend/countdown_timer":37,"../../modules/groupon-deal-timer/frontend/models/countdown_timer":38,"../../modules/groupon-deal-timer/frontend/views/countdown_timer":39,"../../modules/header/frontend/main":41,"../../modules/inline_variations/frontend/inline_variations":44,"../../modules/sharing/frontend/facebook":73,"../../modules/tracking/frontend/initializer":76,"../../modules/urgency_messaging/frontend/countdown_timer":78,"../../modules/urgency_messaging/frontend/urgency_messaging":80,"../../modules/variations/frontend/variations-widget":85,"../../node_modules/widget-layout-assets/coffee/wls":99,"backbone":90,"groupon-iframe-login":91,"hogan.js":95}],2:[function(require,module,exports){
require('./base');

require('../../modules/delivery_estimates/frontend/delivery_estimates');

require('../../modules/shipping/frontend/free_shipping');

require('../../node_modules/grpn-instagram-photo-widget/frontend/coffeescripts/instagram-photo-widgets');

require('../../modules/offers/frontend/offers_timer');

require('../../modules/goods_v2/frontend/read_more');

require('../../modules/product_video/frontend/product_video');

require('../../modules/product_reviews/frontend/product_reviews');

require('../../modules/wishlist_button/frontend/wishlist');



},{"../../modules/delivery_estimates/frontend/delivery_estimates":18,"../../modules/goods_v2/frontend/read_more":28,"../../modules/offers/frontend/offers_timer":50,"../../modules/product_reviews/frontend/product_reviews":55,"../../modules/product_video/frontend/product_video":72,"../../modules/shipping/frontend/free_shipping":74,"../../modules/wishlist_button/frontend/wishlist":89,"../../node_modules/grpn-instagram-photo-widget/frontend/coffeescripts/instagram-photo-widgets":93,"./base":1}],3:[function(require,module,exports){
var AdUnitLazyLoader;

AdUnitLazyLoader = window.AdUnitLazyLoader = {
  load: function() {
    return $('.ad-widget iframe').attr('src', function() {
      return $(this).attr('data-src');
    });
  }
};

module.exports = AdUnitLazyLoader;



},{}],4:[function(require,module,exports){
var BuyButton, MagicEventBus, resetMultiOptionLink;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

MagicEventBus = require('magic-event-bus/lib/frizzle.js');

BuyButton.View = require('./views/buy_button');

resetMultiOptionLink = function() {
  return $(window).on('pageshow', function() {
    var $buyLink, $wrapper;
    if ($('.multi-option-breakout').length) {
      $wrapper = '.multi-option-breakout';
      $buyLink = $('#buy-link').attr('href');
    } else {
      $wrapper = '#options';
      $buyLink = $('#options a.buy-button').attr('href');
    }
    return $($wrapper + ' input[value="' + $buyLink + '"]').prop('checked', true);
  });
};

BuyButton.init = function(arg, done) {
  var buyButton, handleBuyButton, iframeLogin;
  buyButton = arg.buyButton, iframeLogin = arg.iframeLogin;
  this.eventBus = new MagicEventBus();
  if ((iframeLogin != null) && !iframeLogin.authenticated && !iframeLogin.disabledOnBuyButton) {
    handleBuyButton = function() {
      IframeLogin.openModal(BuyButton.view.$buyButton.attr('href'));
      return {
        stopTheBus: true
      };
    };
    this.eventBus.board('buy_button_clicked', handleBuyButton)(999);
  }
  return $((function(_this) {
    return function() {
      if (buyButton.multiOptionEnabled) {
        resetMultiOptionLink();
      }
      _this.view = new BuyButton.View({
        multiOptionEnabled: buyButton.multiOptionEnabled,
        multiOptionInline: buyButton.multiOptionInline
      });
      return done();
    };
  })(this));
};

module.exports = BuyButton;



},{"./views/buy_button":6,"magic-event-bus/lib/frizzle.js":97}],5:[function(require,module,exports){
var GIFT_MODAL_OFFSET, Gift, MODAL_OFFSET, OFFERS_MODAL_OFFSET, TABLET_MQ_WIDTH;

Gift = require('../../gift_button/frontend/gift');

MODAL_OFFSET = {
  left: 112,
  top: -130
};

GIFT_MODAL_OFFSET = {
  left: 60,
  top: -145
};

OFFERS_MODAL_OFFSET = {
  left: 136,
  top: -118
};

TABLET_MQ_WIDTH = 768;

if (window.MultiOptionModal == null) {
  window.MultiOptionModal = {};
}

MultiOptionModal.init = function(payload, done) {
  var openMultiOptionModal;
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : void 0)) {
    return done();
  }
  openMultiOptionModal = function(e) {
    var $modal, $otherTooltip, $tooltipTrigger, firstAvailableOption, modalSelector;
    if (e != null) {
      e.preventDefault();
    }
    modalSelector = BuyButton.view.offersClicked ? '#offer-options' : '#options';
    $modal = $(modalSelector);
    if (!$modal.length) {
      return;
    }
    if ($modal.hasClass('tooltip')) {
      $otherTooltip = modalSelector === '#options' ? $('#offer-options') : $('#options');
      if ($otherTooltip.is(':visible')) {
        $otherTooltip.find('.tooltip-close').click();
      }
      $tooltipTrigger = BuyButton.view.offersClicked ? $('.offer-buy-button') : Gift.cookieCreated ? $('.gift-button') : $('.buy-button');
      $tooltipTrigger.attr({
        'data-position': 'bottom',
        'data-tooltip-id': modalSelector.slice(1),
        'data-trigger-event': 'js-trigger'
      });
      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom');
      GIG.Tooltip.helpers.tooltip.apply($tooltipTrigger[0], [
        {
          preventDefault: function() {}
        }
      ]);
    } else {
      if ($modal.hasClass('show-modal')) {
        return;
      }
      if ($(".header-row-sticky").is(":visible") && !payload.buyButton.multiOptionInline) {
        return;
      }
      if (!BuyButton.view.$multiOptions.filter('.selected').length) {
        firstAvailableOption = BuyButton.view.$multiOptions.not(function(i, el) {
          return $(el).parents('.multi-option-overlay-item-disabled').length;
        })[0];
        BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: firstAvailableOption
        });
      }
      GIG.Modal.open({
        el: $modal
      });
    }
    return {
      stopTheBus: true
    };
  };
  if (payload.buyButton.multiOptionInline) {
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998);
  }
  return $(function() {
    var $body, $triggers;
    $triggers = $(".show-multi-option-modal");
    $triggers.click(openMultiOptionModal);
    $body = $(document.body);
    GIG.Modal.onClose(Gift.removeCookie, 'options');
    GIG.Modal.onClose(Gift.removeCookie, 'offer-options');
    $('#options, #offer-options').on('click', '.tooltip-close', Gift.removeCookie);
    return done();
  });
};

module.exports = MultiOptionModal;



},{"../../gift_button/frontend/gift":27}],6:[function(require,module,exports){
var BuyButton, DealEventPipe;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

BuyButton.View = Backbone.View.extend({
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster",
  events: {
    "click a.buy-button:not(.external-buy)": "buyButtonClicked",
    "click .view-options a": "viewAllOptions",
    "click a.offer-buy-button": "offersBuyButtonClicked",
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton",
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton"
  },
  initialize: function(arg) {
    var multiOptionEnabled, multiOptionInline, processLink;
    multiOptionEnabled = arg.multiOptionEnabled, multiOptionInline = arg.multiOptionInline;
    this.$buyContainer = this.$(".buy");
    this.$buyButton = this.$("a.buy-button");
    this.$offersBuyButton = this.$("a.offer-buy-button");
    this.$dealHeroPrice = this.$("#deal-hero-price, .multi-option-overlay-cluster-price");
    this.$mainBtnPrice = this.$("#main-button-formatted-price");
    this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price");
    this.$priceLabel = this.$(".price-label, .multi-option-overlay-cluster-price-label");
    this.$value = this.$("#discount-value, .discount-value");
    this.$smallPrice = this.$('.price-small, .discount-value');
    this.$multiOptionBreakout = this.$('.multi-option-breakout, .modal-body');
    this.$multiOptionOverlay = this.$el.filter('.multi-option-overlay');
    this.$multiOptions = this.$('.multi-option-breakout input, .multi-option-overlay-item input');
    this.$buyButtonLoader = this.$buyButton.siblings('.order-processing-loader');
    this.$finePrintDesc = $(".fine-print-description");
    this.$headerTitles = $(".header-title-item");
    this.$headerUrgencyPrice = $(".header-urgency-pricing");
    if (this.$multiOptionOverlay.length) {
      this.$discountPercent = this.$('#discount-percent, .discount-percent');
      this.$discountYouSave = this.$('#discount-you-save, .discount-you-save');
      this.$qtyBought = this.$('.qty-bought');
      this.fixPossiblePriceOverflow();
    }
    this.hasBeenClicked = false;
    this.variationsSelected = false;
    this.multiOptionEnabled = multiOptionEnabled;
    this.multiOptionInline = multiOptionInline;
    if (this.multiOptionInline) {
      this.restoreOptionSelection();
    }
    processLink = (function(_this) {
      return function() {
        return _this.processLink();
      };
    })(this);
    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000);
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        _this.variationsSelected = priceData.variationsSelected;
        _this.$buyButton.removeClass("login-disabled");
        _this.updatePrice(priceData);
        _this.updateValue(priceData);
        return _this.updateBuyButton(priceData);
      };
    })(this));
  },
  buyButtonClicked: function(e) {
    this.offersClicked = false;
    this.giftButtonClicked = false;
    e.preventDefault();
    return BuyButton.eventBus.go('buy_button_clicked');
  },
  offersBuyButtonClicked: function(e) {
    this.offersClicked = true;
    this.giftButtonClicked = false;
    e.preventDefault();
    return BuyButton.eventBus.go('buy_button_clicked');
  },
  shouldShowPriceInTwoRows: function() {
    var includeMargin;
    includeMargin = true;
    return this.$priceBox.outerWidth(includeMargin) + this.$smallPrice.outerWidth(includeMargin) > this.$dealHeroPrice.outerWidth(includeMargin);
  },
  setPriceWithSale: function(newPrice, regularPrice) {
    this.$priceBox.text(newPrice);
    this.$priceBox.after("<span class='price-small'>" + regularPrice + "</span>");
    this.$smallPrice = this.$dealHeroPrice.find('.price-small');
    return this.fixPossiblePriceOverflow();
  },
  setOfferLabel: function(offerLabel) {
    if (!offerLabel) {
      return;
    }
    offerLabel = "<span class='urgency-pricing-label'>" + offerLabel + "</span>";
    if (this.$headerUrgencyPrice.length) {
      return this.$headerUrgencyPrice.append(offerLabel);
    } else {
      return this.$dealHeroPrice.append(offerLabel);
    }
  },
  cleanPriceBox: function() {
    this.$priceBox.removeClass('two-rows');
    this.$dealHeroPrice.find('.price-small').remove();
    this.$dealHeroPrice.removeClass('urgency-pricing');
    return this.$('.urgency-pricing-label').remove();
  },
  setPriceBox: function(price, sale) {
    var ref;
    this.cleanPriceBox();
    if ((sale != null ? sale.urgencyPricing : void 0) != null) {
      this.$dealHeroPrice.addClass('urgency-pricing');
      this.setPriceWithSale(sale.urgencyPricing.newPrice, sale.urgencyPricing.regularPrice);
      return this.setOfferLabel((ref = sale.urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0);
    } else if ((sale != null ? sale.offer : void 0) != null) {
      this.$mainBtnPrice.text(sale.offer.formattedNewPrice);
      return this.setPriceWithSale(sale.offer.formattedOldPrice, sale.offer.formattedValue);
    } else {
      return this.$priceBox.text(price);
    }
  },
  updatePrice: function(arg) {
    var lengthClass, price, sale, variationsSelected;
    variationsSelected = arg.variationsSelected, price = arg.price, sale = arg.sale, lengthClass = arg.lengthClass;
    if (this.currentPriceClass) {
      this.$buyContainer.removeClass(this.currentPriceClass);
    }
    if (lengthClass) {
      this.$buyContainer.addClass(lengthClass);
    }
    this.setPriceBox(price, sale);
    this.currentPriceClass = lengthClass;
    if (variationsSelected) {
      return this.$priceLabel.hide();
    } else {
      return this.$priceLabel.show();
    }
  },
  updateValue: function(arg) {
    var hideOriginalPriceAndDiscount, value;
    value = arg.value, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    return this.$value.html(hideOriginalPriceAndDiscount ? "" : value);
  },
  updateBuyButton: function(arg) {
    var buyUrl, sale, variationsSelected;
    variationsSelected = arg.variationsSelected, buyUrl = arg.buyUrl, sale = arg.sale;
    if (variationsSelected) {
      this.$buyButton.attr("href", buyUrl);
      if ((sale != null ? sale.offer : void 0) != null) {
        return this.$offersBuyButton.attr("href", sale.offer.buyUrl);
      }
    }
  },
  disableBuyButton: function() {
    this.hasBeenClicked = true;
    this.$buyButton.removeClass("state-buy");
    this.$offersBuyButton.removeClass("state-buy");
    this.$buyButton.addClass("state-disabled");
    this.$offersBuyButton.addClass("state-disabled");
    return this.$buyButtonLoader.show();
  },
  enableBuyButton: function() {
    this.hasBeenClicked = false;
    this.$buyButton.removeClass("state-disabled");
    this.$offersBuyButton.removeClass("state-disabled");
    this.$buyButton.addClass("state-buy");
    this.$offersBuyButton.addClass("state-buy");
    return this.$buyButtonLoader.hide();
  },
  processLink: function() {
    var button;
    if (!this.hasBeenClicked) {
      button = this.offersClicked ? this.$offersBuyButton : this.$buyButton;
      window.location = button.attr("href");
    }
    return this.disableBuyButton();
  },
  updateMultiOptionBreakoutButton: function(e) {
    var $option, offerLabel, value;
    $option = this.$multiOptions.filter(e.currentTarget);
    if (!$option.length || $option.hasClass('selected')) {
      return;
    }
    this.$multiOptions.removeClass('selected');
    $option.addClass('selected');
    value = $option.val();
    this.$buyButton.attr('href', value);
    if (this.$multiOptionOverlay.length) {
      this.updateClusterOptionPrice($option);
      this.syncDealOptions($option);
      this.cleanPriceBox();
      offerLabel = $option.attr('data-offer-label');
      this.setOfferLabel(offerLabel);
      if (offerLabel) {
        this.$dealHeroPrice.addClass('urgency-pricing');
      }
      this.fixPossiblePriceOverflow();
    } else {
      this.updateHeaderPrice($option);
    }
    this.updateHeaderTitle($option);
    if ($option.parent('a').length) {
      return BuyButton.eventBus.go('buy_button_clicked');
    }
  },
  updateHeaderPrice: function($option) {
    var formattedPrice, formattedValue;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    this.$priceBox.text(formattedPrice);
    return this.$smallPrice.text(formattedValue);
  },
  updateHeaderTitle: function($option) {
    var breakoutOptionID, selectedTitle, targetTitleId;
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    this.$headerTitles.removeClass('checked');
    targetTitleId = "#header-title-" + breakoutOptionID;
    selectedTitle = this.$headerTitles.filter(targetTitleId);
    return selectedTitle.addClass('checked');
  },
  updateClusterOptionPrice: function($option) {
    var breakoutOptionID, finePrintDesc, formattedPrice, formattedValue, offerLabel, soldMessage;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    offerLabel = $option.attr('data-offer-label') || '';
    soldMessage = $option.attr('data-sold-message') || '';
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    finePrintDesc = $option.attr('data-description') || '';
    this.$priceBox.text(formattedPrice);
    this.$smallPrice.text(formattedValue);
    this.fixPossiblePriceOverflow();
    this.updateClusterOptionDiscount($option);
    this.$('.urgency-pricing-label').text(offerLabel);
    this.updateUrgencyPricingMetaData(offerLabel, breakoutOptionID);
    this.$qtyBought.text(soldMessage);
    return this.updateFinePrint(finePrintDesc);
  },
  updateClusterOptionDiscount: function($option) {
    var discountPercentage, savings;
    discountPercentage = $option.attr('data-discount-percentage') || '';
    savings = $option.attr('data-savings') || '';
    if (discountPercentage) {
      this.$discountPercent.text(discountPercentage);
      this.$discountYouSave.text(savings);
      return $('.deal-discount').show();
    } else {
      return $('.deal-discount').hide();
    }
  },
  updateUrgencyPricingMetaData: function(offerLabel, breakoutOptionID) {
    if (offerLabel) {
      this.$dealHeroPrice.addClass('urgency-pricing');
      this.$dealHeroPrice.addClass('tooltip-trigger');
      this.$dealHeroPrice.attr('data-bhw', 'UrgencyPrice');
      this.$dealHeroPrice.attr('data-tooltip-id', "urgency-pricing-tooltip-" + breakoutOptionID);
      return this.$dealHeroPrice.attr('data-position', "left");
    } else {
      this.$dealHeroPrice.removeClass('urgency-pricing');
      this.$dealHeroPrice.removeClass('tooltip-trigger');
      this.$dealHeroPrice.removeAttr('data-bhw');
      this.$dealHeroPrice.removeAttr('data-tooltip-id');
      return this.$dealHeroPrice.removeAttr('data-position');
    }
  },
  fixPossiblePriceOverflow: function() {
    this.$priceBox.removeClass('two-rows');
    this.$smallPrice.removeClass('two-rows');
    if (this.shouldShowPriceInTwoRows()) {
      this.$priceBox.addClass('two-rows');
      return this.$smallPrice.addClass('two-rows');
    }
  },
  viewAllOptions: function(e) {
    e.preventDefault();
    return BuyButton.eventBus.go('view_options_clicked');
  },
  restoreOptionSelection: function() {
    return this.$el.find('.multi-option-breakout li input:first').trigger('click');
  },
  syncDealOptions: function($option) {
    var breakoutOptionId, optionId;
    optionId = $option.attr('id');
    if (optionId.indexOf('overlay') !== -1) {
      breakoutOptionId = "#" + (this.getPurchaseClusterOptionId(optionId));
      this.reorderDealOptions(breakoutOptionId);
    } else {
      breakoutOptionId = "#overlay-" + optionId;
    }
    return $(breakoutOptionId).prop('checked', true);
  },
  getPurchaseClusterOptionId: function(optionId) {
    if (optionId == null) {
      return '';
    }
    if (optionId.indexOf('overlay-') === -1) {
      return optionId;
    }
    return optionId.replace('overlay-', '');
  },
  reorderDealOptions: function(breakoutOptionId) {
    var $optionElem;
    $optionElem = $(breakoutOptionId).parents('li');
    if ($optionElem.is(':visible')) {
      return;
    }
    $optionElem.insertBefore($optionElem.siblings('li').first());
    $optionElem.parent().find('li:visible:last').hide();
    return $optionElem.show();
  },
  updateFinePrint: function(finePrintDesc) {
    var $body, finePrintLines, tempLines;
    if (!(finePrintDesc != null ? finePrintDesc.length : void 0)) {
      return;
    }
    $body = $(document.body);
    if ($body.hasClass('getaways') || $body.hasClass('getaways-booking')) {
      finePrintLines = (typeof I18n !== "undefined" && I18n !== null ? I18n.country : void 0) === "US" ? (tempLines = _.filter(finePrintDesc.split(". "), function(line) {
        return line.replace(/<[^>]*>/g, '').trim().length > 0;
      }), tempLines = _.map(tempLines, function(line) {
        return "<li class='fine-print-description'>" + line + "</li>";
      }), tempLines.join('')) : "<span class='fine-print-description'>" + (finePrintDesc.replace(/\n/g, '<br/>')) + "</span>";
      $(finePrintLines).insertBefore(this.$finePrintDesc.first());
      this.$finePrintDesc.remove();
      return this.$finePrintDesc = $('.fine-print-description');
    } else {
      return this.$finePrintDesc.html(finePrintDesc);
    }
  }
});

module.exports = BuyButton.View;



},{"../../../deal/frontend/event_pipe":12}],7:[function(require,module,exports){
var generateCartUrl;

generateCartUrl = function(optionuuid, dealuuid) {
  return "/cart/add/" + optionuuid + "?deal_id=" + dealuuid;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.Cart == null) {
    window.Cart = {};
  }
  if (Cart.Helpers == null) {
    Cart.Helpers = {};
  }
  Cart.Helpers.generateCartUrl = generateCartUrl;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    generateCartUrl: generateCartUrl
  };
}



},{}],8:[function(require,module,exports){
var TUTORIAL_SHOWN_COOKIE_NAME, TWENTY_YEARS_IN_SEC;

TWENTY_YEARS_IN_SEC = 630720000;

TUTORIAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-shown';

if (window.CashBack == null) {
  window.CashBack = {};
}

CashBack.init = function(payload, done) {
  return $(function() {
    var cashBack, cookieDomain, tooltipDelay, tutorialLauncher;
    cashBack = payload.cashBack, cookieDomain = payload.cookieDomain;
    if (cashBack != null ? cashBack.showTutorialOnLoad : void 0) {
      tooltipDelay = $('#ls-in-app-messages:not(.hide)').length ? (cashBack != null ? cashBack.tooltipDelay : void 0) || 2000 : 0;
      tutorialLauncher = (function(_this) {
        return function() {
          return CashBack.showTutorial(cookieDomain);
        };
      })(this);
      setTimeout(tutorialLauncher, tooltipDelay);
    }
    return done();
  });
};

CashBack.showTutorial = function(cookieDomain) {
  var $tooltip, $trigger, onTooltipClose;
  if (Cookie.get(TUTORIAL_SHOWN_COOKIE_NAME)) {
    return;
  }
  if (cookieDomain == null) {
    cookieDomain = window.location.hostname;
  }
  $tooltip = $('#cash-back-tutorial-tooltip');
  if (!$tooltip.length) {
    return;
  }
  onTooltipClose = function() {
    return Cookie.set(TUTORIAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain);
  };
  $tooltip.one('click', '.tooltip-close', onTooltipClose);
  $trigger = $('.cash-back .tooltip-trigger');
  return GIG.Tooltip.helpers.tooltip.apply($trigger, [
    {
      preventDefault: function() {}
    }
  ]);
};

module.exports = CashBack;



},{}],9:[function(require,module,exports){
var ChannelTabs;

ChannelTabs = window.ChannelTabs != null ? window.ChannelTabs : window.ChannelTabs = {};

ChannelTabs.init = function(arg, done) {
  var categoriesBaseUrl;
  categoriesBaseUrl = arg.categoriesBaseUrl;
  return $(function() {
    $(".primary-nav").find("a[href='" + categoriesBaseUrl + "']").parent().addClass('active');
    return done();
  });
};

module.exports = ChannelTabs;



},{}],10:[function(require,module,exports){
var DealController, Discount;

DealController = window.DealController != null ? window.DealController : window.DealController = {};

Discount = require('../../discount/frontend/views/discount');

DealController.init = function(payload, done) {
  return $(function() {
    new Discount.View;
    return done();
  });
};

module.exports = DealController;



},{"../../discount/frontend/views/discount":20}],11:[function(require,module,exports){
var DealLazyLoader;

DealLazyLoader = window.DealLazyLoader = {
  sleepyLoadImages: function() {
    return $('.sleepy-load').lazyload({
      skip_invisible: false
    });
  },
  init: function(payload, done) {
    return $(function() {
      $(document.body).on('modal-open', function(e, data) {
        return $('#' + data.id).find('.lazy-load').lazyload();
      });
      $(window).load(function() {
        Groupon.Utils.lazyLoadImages();
        return DealLazyLoader.sleepyLoadImages();
      });
      return done();
    });
  }
};

module.exports = DealLazyLoader;



},{}],12:[function(require,module,exports){
var DealEventPipe;

DealEventPipe = window.DealEventPipe != null ? window.DealEventPipe : window.DealEventPipe = _(Backbone.Events).clone();

module.exports = DealEventPipe;



},{}],13:[function(require,module,exports){
var ExternalLinks, isBlackListedLink, isLinkToEmptyUrl, isLinkToExternalUrl, isLinkToJs, isLinkToPdf, isMailToLink, isWhiteListedLink;

ExternalLinks = window.ExternalLinks != null ? window.ExternalLinks : window.ExternalLinks = {};

isMailToLink = function(obj) {
  return obj.href.match(/^mailto\:/);
};

isLinkToPdf = function(obj) {
  return /.pdf$/.test(obj.href);
};

isLinkToJs = function(obj) {
  return obj.href.match(/^javascript\:/);
};

isLinkToEmptyUrl = function(obj) {
  return obj.href.match(/^$/);
};

isLinkToExternalUrl = function(obj) {
  return obj.hostname !== location.hostname && obj.hostname.indexOf("groupon.com") === -1;
};

isWhiteListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

isBlackListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

$.expr[":"].external = function(obj, index, meta, stack) {
  return (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) && !(isMailToLink(obj) || isLinkToJs(obj) || isLinkToEmptyUrl(obj) || isBlackListedLink(obj));
};

ExternalLinks.init = function(payload, done) {
  return $(function() {
    $("a:external").click(function(e) {
      e.preventDefault();
      return window.open($(this).attr('href'), "_blank");
    });
    return done();
  });
};

module.exports = ExternalLinks;



},{}],14:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.Model = require('./models/deal_type');

DealTypes.View = require('./views/deal_type');

DealTypes.init = function(arg, done) {
  var consumerId, csrf, dealTypes, rootUrl;
  dealTypes = arg.dealTypes, consumerId = arg.consumerId, csrf = arg.csrf, rootUrl = arg.rootUrl;
  if (!((consumerId != null ? consumerId.length : void 0) > 0 && (dealTypes != null ? dealTypes.length : void 0) > 0)) {
    return done();
  }
  return $(function() {
    var el, i, id, len, model, ref, value;
    for (i = 0, len = dealTypes.length; i < len; i++) {
      ref = dealTypes[i], id = ref.id, value = ref.value, el = ref.el;
      model = new DealTypes.Model({
        id: id,
        value: value,
        consumerId: consumerId,
        csrf: csrf,
        rootUrl: rootUrl
      });
      new DealTypes.View({
        el: el,
        model: model
      });
    }
    return done();
  });
};

module.exports = DealTypes;



},{"./models/deal_type":15,"./views/deal_type":16}],15:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.Model = Backbone.Model.extend({
  urlRoot: function() {
    return this.get('rootUrl');
  },
  url: function() {
    return (this.urlRoot()) + "/proxy/v2/consumers/" + (this.get('consumerId')) + "/feedback";
  },
  toJSON: function() {
    return {
      _csrf: this.get('csrf'),
      deal_types: [
        {
          id: this.get('id'),
          value: this.get('value')
        }
      ]
    };
  },
  isNew: function() {
    return true;
  },
  toggle: function() {
    if (this.get('value') === 'positive') {
      return this.set('value', 'neutral');
    } else {
      return this.set('value', 'positive');
    }
  }
});

module.exports = DealTypes.Model;



},{}],16:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.View = Backbone.View.extend({
  events: {
    'click a': '_toggle'
  },
  initialize: function() {
    return this.model.on('change:value', (function(_this) {
      return function() {
        return _this._updateClass();
      };
    })(this));
  },
  _toggle: function(e) {
    if (e != null) {
      e.preventDefault();
    }
    this.model.toggle();
    return this.model.save();
  },
  _updateClass: function() {
    if (this.model.get('value') === 'positive') {
      return this.$('a').addClass('matching');
    } else {
      return this.$('a').removeClass('matching');
    }
  }
});

module.exports = DealTypes.View;



},{}],17:[function(require,module,exports){
var DealWidgets, ProductReviews, base;

DealWidgets = window.DealWidgets != null ? window.DealWidgets : window.DealWidgets = {};

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

ProductReviews.Views.Widget.ReviewRating = require('../../product_reviews/frontend/views/product_reviews_widget_review_rating');

DealWidgets.lazyLoadImages = function($widgets) {
  return $widgets.find('.lazy-load').each(function(position, imageElement) {
    var $image;
    $image = $(imageElement);
    return $image.attr('src', $image.attr('data-original'));
  });
};

DealWidgets.ajax_success = function(data, productReviews, done) {
  var $aboveReviewsSlot, $bottomSlot, $featuredTopSlot, $widgets, hasWidgets, ref, ref1, ref2, ref3;
  if (data == null) {
    $('#featuredtopslot-widget-placeholder').remove();
    $('#bottomslot-widget-placeholder').remove();
    $('#abovereviewsslot-widget-placeholder').remove();
    return done();
  }
  hasWidgets = false;
  $featuredTopSlot = $('#featuredtopslot-widget-placeholder');
  $bottomSlot = $('#bottomslot-widget-placeholder');
  $aboveReviewsSlot = $('#abovereviewsslot-widget-placeholder');
  if ((ref = data.FeaturedTopSlot) != null ? ref.length : void 0) {
    hasWidgets = true;
    $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr class='dotted-border' id='top-slot-border'/>");
  } else {
    $featuredTopSlot.remove();
  }
  if ((ref1 = data.BottomSlot) != null ? ref1.length : void 0) {
    hasWidgets = true;
    $bottomSlot.replaceWith(data.BottomSlot);
  } else {
    $bottomSlot.remove();
  }
  if ((ref2 = data.AboveReviewsSlot) != null ? ref2.length : void 0) {
    hasWidgets = true;
    $aboveReviewsSlot.replaceWith(data.AboveReviewsSlot);
  } else {
    $aboveReviewsSlot.remove();
  }
  if (hasWidgets) {
    if ((ref3 = Groupon.Utils) != null) {
      if (typeof ref3.lazyLoadImages === "function") {
        ref3.lazyLoadImages();
      }
    }
    new ProductReviews.Views.Widget.ReviewRating({
      productReviews: productReviews
    });
    if ($widgets = $('.mm-widget, .fake-wls-widget .widget-deals')) {
      WLS.init($widgets.parent());
      DealWidgets.lazyLoadImages($widgets);
      GIG.Utils.truncateElements($widgets);
    }
  }
  return done();
};

DealWidgets.init = function(arg, done) {
  var clientDealWidgets, productReviews;
  clientDealWidgets = arg.clientDealWidgets, productReviews = arg.productReviews;
  if (clientDealWidgets == null) {
    new ProductReviews.Views.Widget.ReviewRating({
      productReviews: productReviews
    });
    return done();
  }
  return $(function() {
    return $(window).load(function() {
      return $.ajax({
        url: clientDealWidgets.formattedUrl,
        dataType: 'json',
        success: function(data) {
          return DealWidgets.ajax_success(data, productReviews, done);
        },
        error: function(err) {
          $('#featuredtopslot-widget-placeholder').remove();
          $('#bottomslot-widget-placeholder').remove();
          $('#abovereviewsslot-widget-placeholder').remove();
          return done();
        }
      });
    });
  });
};

module.exports = DealWidgets;



},{"../../product_reviews/frontend/views/product_reviews_widget_review_rating":64}],18:[function(require,module,exports){
var DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

DeliveryEstimates.View = require('./views/delivery_estimates');

DeliveryEstimates.init = function(arg, done) {
  var deliveryEstimates;
  deliveryEstimates = arg.deliveryEstimates;
  if (deliveryEstimates == null) {
    return done();
  }
  return $(function() {
    new DeliveryEstimates.View({
      deliveryEstimates: deliveryEstimates
    });
    return done();
  });
};

module.exports = DeliveryEstimates;



},{"./views/delivery_estimates":19}],19:[function(require,module,exports){
var DealEventPipe, DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

DeliveryEstimates.View = Backbone.View.extend({
  el: "#purchase-cluster .delivery-estimates-container",
  initialize: function(arg) {
    var deliveryEstimates;
    deliveryEstimates = arg.deliveryEstimates;
    this.deliveryEstimates = deliveryEstimates;
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateDeliveryEstimatesMessage(priceData);
      };
    })(this));
  },
  updateDeliveryEstimatesMessage: function(arg) {
    var estimates, ref, uuid;
    uuid = arg.uuid;
    if (estimates = (ref = this.deliveryEstimates) != null ? ref[uuid] : void 0) {
      this.$el.removeClass('hide');
      return this.$el.html("<span class='icon-truck'></span>" + estimates);
    } else {
      return this.$el.addClass('hide');
    }
  }
});

module.exports = DeliveryEstimates.View;



},{"../../../deal/frontend/event_pipe":12}],20:[function(require,module,exports){
var DealEventPipe;

if (window.Discount == null) {
  window.Discount = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Discount.View = Backbone.View.extend({
  el: "#discount-data, .discount-data",
  initialize: function() {
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateTiles(priceData);
      };
    })(this));
  },
  updateTiles: function(arg) {
    var hideOriginalPriceAndDiscount, percent, savings, value;
    value = arg.value, percent = arg.percent, savings = arg.savings, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    this.$("#discount-value, .discount-value").html(value);
    this.$("#discount-percent, .discount-percent").html(percent);
    this.$("#discount-you-save, .discount-you-save").html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents(".deal-discount").hide();
    } else {
      return this.$el.parents(".deal-discount").show();
    }
  }
});

module.exports = Discount;



},{"../../../deal/frontend/event_pipe":12}],21:[function(require,module,exports){
var DfpAds;

DfpAds = window.DfpAds != null ? window.DfpAds : window.DfpAds = {};

DfpAds.init = function(arg, done) {
  var dfpHeader;
  dfpHeader = arg.dfpHeader;
  if (!dfpHeader) {
    return done();
  }
  return $(window).load(function() {
    Groupon.DFPAds || (Groupon.DFPAds = {});
    Groupon.DFPAds.showAds = function() {
      return $('.dfp-footer, .dfp-side-rail').map(function() {
        return this.id;
      }).each(function(i, id) {
        return googletag.cmd.push(function() {
          return googletag.display(id);
        });
      });
    };
    return done();
  });
};

module.exports = DfpAds;



},{}],22:[function(require,module,exports){
if (window.ExternalDeal == null) {
  window.ExternalDeal = {};
}

ExternalDeal.init = function(arg, done) {
  var externalDeal;
  externalDeal = arg.externalDeal;
  if (!externalDeal) {
    return done();
  }
  return $(function() {
    var $externalBuyButton;
    $externalBuyButton = $('.external-buy');
    $externalBuyButton.click(function(e) {
      e.preventDefault();
      window.open($(this).attr('href'));
      return setTimeout(GIG.Modal.close, 3000);
    });
    return done();
  });
};

module.exports = ExternalDeal;



},{}],23:[function(require,module,exports){
var _start, vent;

if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = vent = _(Backbone.Events).clone();

GMap._start = _start = function() {
  return GMap.vent.trigger('start');
};

module.exports = {
  vent: vent,
  _start: _start
};



},{}],24:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.View = require('./views/g_map');

GMap.init = function(arg, done) {
  var dynamicMaps, multipleLocations, staticMaps;
  dynamicMaps = arg.dynamicMaps, multipleLocations = arg.multipleLocations, staticMaps = arg.staticMaps;
  if (dynamicMaps == null) {
    return done();
  }
  return $(function() {
    var i, len, map, view;
    if (staticMaps != null ? staticMaps.shouldLazyLoadControls : void 0) {
      return $(window).load(function() {
        var i, len, map, view;
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          view = new GMap.View(_.extend(map, {
            staticMaps: staticMaps
          }));
        }
        return done();
      });
    } else {
      for (i = 0, len = dynamicMaps.length; i < len; i++) {
        map = dynamicMaps[i];
        view = new GMap.View(map);
      }
      return done();
    }
  });
};

module.exports = GMap;



},{"./views/g_map":26}],25:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.Markers = function(googleMaps) {
  return {
    googleMaps: googleMaps,
    makeMarkers: function(markerData) {
      var icon, j, k, len, len1, locationMarker, marker, markerOptions, ref, results;
      this.markers = [];
      results = [];
      for (j = 0, len = markerData.length; j < len; j++) {
        marker = markerData[j];
        locationMarker = {
          currentIndex: 0,
          coloredMarkers: []
        };
        ref = marker.icons;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          icon = ref[k];
          markerOptions = {
            position: new this.googleMaps.LatLng(marker.lat, marker.lng),
            icon: {
              url: icon.url,
              scaledSize: marker.size ? new this.googleMaps.Size(marker.size.width, marker.size.height) : void 0
            }
          };
          locationMarker.coloredMarkers.push({
            color: icon.color,
            dynamicMarker: new this.googleMaps.Marker(markerOptions)
          });
        }
        results.push(this.markers.push(locationMarker));
      }
      return results;
    },
    createBounds: function(markers) {
      var bounds, j, len, marker;
      bounds = new this.googleMaps.LatLngBounds();
      for (j = 0, len = markers.length; j < len; j++) {
        marker = markers[j];
        bounds.extend(marker.getPosition());
      }
      return bounds;
    },
    connectMapToMarkers: function(map, markers) {
      var j, len, marker, results;
      results = [];
      for (j = 0, len = markers.length; j < len; j++) {
        marker = markers[j];
        results.push(marker.setMap(map));
      }
      return results;
    },
    addMarkersToMap: function(map) {
      var activeMarkers, bounds, j, len, marker, ref;
      activeMarkers = [];
      ref = this.markers;
      for (j = 0, len = ref.length; j < len; j++) {
        marker = ref[j];
        activeMarkers.push(marker.coloredMarkers[0].dynamicMarker);
      }
      this.connectMapToMarkers(map, activeMarkers);
      if (activeMarkers.length > 1) {
        bounds = this.createBounds(activeMarkers);
        return map.fitBounds(bounds);
      }
    },
    toggleMarkerColor: function(i) {
      var map, marker, newMarker, oldMarker;
      if (i < 0) {
        return;
      }
      marker = this.markers[i];
      oldMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker;
      marker.currentIndex = (marker.currentIndex + 1) % marker.coloredMarkers.length;
      newMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker;
      map = oldMarker.getMap();
      oldMarker.setMap(null);
      return newMarker.setMap(map);
    }
  };
};

module.exports = GMap.Markers;



},{}],26:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = require('../helpers/events').vent;

GMap.Markers = require('../markers');

GMap.View = Backbone.View.extend({
  events: {
    'click .static-map': 'changeToDynamic'
  },
  initialize: function() {
    var $body, ref;
    ref = this.options, this.mapOptions = ref.mapOptions, this.markerData = ref.markerData, this.staticMaps = ref.staticMaps;
    $body = $(document.body);
    this.$locationsModal = $('#locations');
    this.$staticMap = this.$el.find('.static-map').add(this.$locationsModal.find('static-map'));
    this.$dynamicMap = this.$el.find('.dynamic-map').add(this.$locationsModal.find('dynamic-map'));
    GMap.vent.on('start', (function(_this) {
      return function() {
        return _this.start();
      };
    })(this));
    this.isLocationsPopupWasActivated = false;
    this.isDynamicMapsWasActivated = false;
    return $body.on("modal-open:locations", (function(_this) {
      return function() {
        return _this.onLocationsPopupOpen();
      };
    })(this));
  },
  changeToDynamic: function() {
    Groupon.Utils.GoogleMaps.load(function(err) {
      if (err != null) {
        return;
      }
      return GMap._start();
    });
    return false;
  },
  start: function() {
    var map;
    GMap.vent.off('start');
    if (this.googleMaps == null) {
      this.googleMaps = window.google.maps;
    }
    if (!this.$locationsModal.hasClass('show-modal')) {
      this.$locationsModal.css({
        display: 'block',
        visibility: 'hidden'
      });
    }
    if (map = this.createDynamicMap(this.mapOptions)) {
      this.markerHandler = new GMap.Markers(this.googleMaps);
      this.markerHandler.makeMarkers(this.markerData);
      this.markerHandler.addMarkersToMap(map);
      this.revealDynamicMap();
      if (!this.$locationsModal.hasClass('show-modal')) {
        this.$locationsModal.css({
          display: '',
          visibility: ''
        });
      }
      return this.isDynamicMapsWasActivated = true;
    }
  },
  createDynamicMap: function(options) {
    var mapOptions;
    mapOptions = this.buildMapOptions(options);
    return new this.googleMaps.Map(this.$dynamicMap[0], mapOptions);
  },
  revealDynamicMap: function() {
    this.$dynamicMap.each(function() {
      var $dynamicMap, $staticMap;
      $dynamicMap = $(this);
      $staticMap = $dynamicMap.siblings('.static-map');
      if ($staticMap.length) {
        return $dynamicMap.css({
          height: $staticMap.height(),
          width: $staticMap.width()
        });
      }
    });
    this.$staticMap.hide();
    this.$dynamicMap.show();
    return GMap.vent.trigger('dynamicMapRevealed');
  },
  buildMapOptions: function(mapOptions) {
    mapOptions.center = new this.googleMaps.LatLng(mapOptions.center.lat, mapOptions.center.lng);
    mapOptions.mapTypeId = this.googleMaps.MapTypeId.ROADMAP;
    return mapOptions;
  },
  onLocationsPopupOpen: function() {
    if (!this.isLocationsPopupWasActivated && this.isDynamicMapsWasActivated) {
      this.isLocationsPopupWasActivated = true;
      GMap.vent.once('start', (function(_this) {
        return function() {
          return _this.start();
        };
      })(this));
      return this.changeToDynamic();
    }
  }
});

module.exports = GMap.View;



},{"../helpers/events":23,"../markers":25}],27:[function(require,module,exports){
if (window.Gift == null) {
  window.Gift = {};
}

Gift.init = function(payload, done) {
  return $(function() {
    Gift.bindGiftButton();
    return done();
  });
};

Gift.bindGiftButton = function() {
  var $gift_button;
  $gift_button = $('.gift-button');
  if ($gift_button.length > 0) {
    return $gift_button.on('click', function(e) {
      e.preventDefault();
      Gift.createCookie();
      BuyButton.view.giftButtonClicked = true;
      return BuyButton.eventBus.go('buy_button_clicked');
    });
  }
};

Gift.createCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.set('modalForGiftOnLoad', 'true', 60, cookieDomain);
  return Gift.cookieCreated = true;
};

Gift.removeCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.unset('modalForGiftOnLoad', cookieDomain);
  return Gift.cookieCreated = false;
};

module.exports = Gift;



},{}],28:[function(require,module,exports){
var ReadMore, _readLess, _readMore;

ReadMore = window.ReadMore != null ? window.ReadMore : window.ReadMore = {};

_readMore = function(pitch, readMoreSection, targetHeight) {
  pitch.css('max-height', targetHeight + "px");
  readMoreSection.find('.read-less').css('display', 'inline');
  readMoreSection.find('.read-more').css('display', 'none');
  return readMoreSection.find('.gradient-finish').css('display', 'none');
};

_readLess = function(pitch, readMoreSection, targetHeight) {
  pitch.css('max-height', targetHeight + "px");
  readMoreSection.find('.read-less').css('display', 'none');
  readMoreSection.find('.read-more').css('display', 'inline');
  return readMoreSection.find('.gradient-finish').css('display', 'inline');
};

ReadMore.init = function(payload, done) {
  return $(function() {
    var $pitch, $readMoreSection, lessHeight, moreHeight, readLess, readMore, readMoreHtml;
    $pitch = $('.pitch-container');
    moreHeight = $('#deal-info').height() + 100;
    lessHeight = $('.purchase-cluster-bottom').height() + 80;
    $pitch.css('max-height', lessHeight + "px");
    readMore = I18n.translate('.modules.goods_v2.read_more');
    readLess = I18n.translate('.modules.goods_v2.read_less');
    readMoreHtml = "<div id='read-more-section' > <div class='gradient-finish'></div> <div class='read-more-container'> <span class='read-more' data-height='" + moreHeight + "' data-bhw='ReadMore'> " + readMore + " <span class='icon-arrow-down'></span></span> <span class='read-less' data-height='" + lessHeight + "' data-bhw='ReadLess'> " + readLess + " <span class='icon-arrow-up'></span></span> </div> </div>";
    $readMoreSection = $(readMoreHtml).insertAfter($pitch);
    $('.read-more').click(function() {
      return _readMore($pitch, $readMoreSection, $(this).data('height'));
    });
    $('.read-less').click(function() {
      return _readLess($pitch, $readMoreSection, $(this).data('height'));
    });
    return done();
  });
};

module.exports = ReadMore;



},{}],29:[function(require,module,exports){
var getMedia, loadScripts, loadVideoScripts, prepareCarouselOptions, ref, setVideoLoaderFlags;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.carouselViews = {};

DealCarousel.dealMedia = {};

DealCarousel.current = {};

ref = DealCarousel.Helpers, getMedia = ref.getMedia, prepareCarouselOptions = ref.prepareCarouselOptions, setVideoLoaderFlags = ref.setVideoLoaderFlags, loadVideoScripts = ref.loadVideoScripts, loadScripts = ref.loadScripts;

DealCarousel.init = function(arg, done) {
  var carousel, carouselOptions, currentCarouselView, currentDealMedia, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return typeof done === "function" ? done() : void 0;
  }
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  if (this.i18n == null) {
    this.i18n = I18n.scoped('modules.groupon-deal-carousel');
  }
  this.dealMedia[dealId] = currentDealMedia = new Backbone.Collection(media, {
    model: DealCarousel.Media
  });
  this.current.currentDealMedia = currentDealMedia;
  carouselOptions = prepareCarouselOptions(carousel, currentDealMedia, featuredImage, this.i18n);
  this.carouselViews[dealId] = currentCarouselView = new DealCarousel.View(carouselOptions);
  this.current.currentCarouselView = currentCarouselView;
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  return $((function(_this) {
    return function() {
      loadVideoScripts(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
      loadScripts(carouselOptions);
      currentCarouselView.render();
      return typeof done === "function" ? done() : void 0;
    };
  })(this));
};

DealCarousel.updateCurrent = function(arg) {
  var carousel, carouselOptions, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  if (!(this.current.currentDealMedia && this.current.currentCarouselView)) {
    return;
  }
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return;
  }
  delete this.dealMedia[this.current.currentDealMedia.uuid];
  delete this.carouselViews[this.current.currentDealMedia.uuid];
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  this.current.currentDealMedia.reset(media, {
    model: DealCarousel.Media
  });
  carouselOptions = prepareCarouselOptions(carousel, this.current.currentDealMedia, featuredImage, this.i18n);
  this.current.currentCarouselView.options = carouselOptions;
  this.current.currentCarouselView.initialize();
  this.current.currentCarouselView.updateCollection(this.current.currentDealMedia);
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  return $((function(_this) {
    return function() {
      return loadVideoScripts(carousel, _this.current.currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
    };
  })(this));
};



},{}],30:[function(require,module,exports){
if (window.DetectFlash == null) {
  window.DetectFlash = {};
}

DetectFlash.hasFlash = swfobject.hasFlashPlayerVersion('1');



},{}],31:[function(require,module,exports){
var DEFAULT_EL;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DEFAULT_EL = '.featured-image';

DealCarousel.Helpers = {
  getMedia: function(carousel) {
    var dealImages, dealVideos, forceVideos, media, showVideos, videoPosition;
    dealImages = carousel.dealImages, forceVideos = carousel.forceVideos, dealVideos = carousel.dealVideos, videoPosition = carousel.videoPosition;
    media = dealImages.slice(0);
    showVideos = forceVideos || DetectFlash.hasFlash || !!(typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.video : void 0);
    if (showVideos && (dealVideos != null ? dealVideos.length : void 0) > 0) {
      media.splice(videoPosition, 0, dealVideos[0]);
    }
    return {
      media: media,
      showVideos: showVideos
    };
  },
  prepareCarouselOptions: function(carousel, currentDealMedia, featuredImage, i18n) {
    var carouselOptions, dealId, el, imageQuality, imageZoomState, lazyLoadFeatured, lazyLoadThumbs, mediaHeight, prefetchImages, showProductSizing, showThumbs, zoomMessage;
    dealId = carousel.dealId, el = carousel.el, imageQuality = carousel.imageQuality, imageZoomState = carousel.imageZoomState, mediaHeight = carousel.mediaHeight, prefetchImages = carousel.prefetchImages, showProductSizing = carousel.showProductSizing, showThumbs = carousel.showThumbs, lazyLoadThumbs = carousel.lazyLoadThumbs, lazyLoadFeatured = carousel.lazyLoadFeatured;
    switch (imageZoomState) {
      case "hover":
        zoomMessage = i18n.t('.hoverZoom');
        break;
      case "click":
        zoomMessage = i18n.t('.clickZoom');
        break;
      default:
        zoomMessage = false;
    }
    carouselOptions = {
      collection: currentDealMedia,
      el: el || DEFAULT_EL,
      imageQuality: imageQuality,
      imageZoomState: imageZoomState,
      mediaHeight: mediaHeight,
      prefetchImages: prefetchImages,
      showThumbs: showThumbs,
      uuid: dealId,
      zoomMessage: zoomMessage,
      showProductSizing: showProductSizing,
      lazyLoadThumbs: lazyLoadThumbs,
      lazyLoadFeatured: lazyLoadFeatured
    };
    if (showProductSizing) {
      carouselOptions.compareSizeMessage = i18n.t('.compareSize');
    }
    if (featuredImage != null) {
      carouselOptions.featured = currentDealMedia.findWhere({
        baseURL: featuredImage
      });
    }
    return carouselOptions;
  },
  setVideoLoaderFlags: function(showVideos, carousel) {
    var i, len, loadKaltura, loadOoyala, loadYoutube, ref, video;
    loadKaltura = false;
    loadOoyala = false;
    loadYoutube = false;
    if (showVideos && ((typeof kWidget === "undefined" || kWidget === null) || (typeof OO === "undefined" || OO === null) || (typeof YT === "undefined" || YT === null))) {
      ref = carousel.dealVideos || [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        if (!loadKaltura && video.provider === "KALTURA") {
          loadKaltura = true;
        }
        if (!loadOoyala && video.provider === "OOYALA") {
          loadOoyala = true;
        }
        if (!loadYoutube && video.provider === "YOUTUBE") {
          loadYoutube = true;
        }
      }
    }
    return {
      loadKaltura: loadKaltura,
      loadOoyala: loadOoyala,
      loadYoutube: loadYoutube
    };
  },
  loadVideoScripts: function(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube) {
    if (loadKaltura && (typeof kWidget === "undefined" || kWidget === null)) {
      $.getScript(carousel.kalturaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "KALTURA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadOoyala && (typeof OO === "undefined" || OO === null)) {
      $.getScript(carousel.ooyalaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "OOYALA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadYoutube && (typeof YT === "undefined" || YT === null)) {
      return $.getScript(carousel.youtubeScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "YOUTUBE"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
  },
  loadScripts: function(carouselOptions) {
    var caller, initTangiblee, rootPath, showProductSizing, tangibleeTimeoutId;
    showProductSizing = carouselOptions.showProductSizing;
    if (showProductSizing) {
      rootPath = document.location.protocol === 'https:' ? 'https://az646174.vo.msecnd.net/tangiblee-static' : 'http://wcdn.tangiblee.com/tangiblee-static';
      caller = document.createElement('script');
      caller.src = rootPath + "/caller.min.js?v=3ujn9jg82";
      caller.id = 'tangiblee-caller';
      document.body.appendChild(caller);
      tangibleeTimeoutId = void 0;
      initTangiblee = function() {
        var TangibleeScript;
        if (typeof Tangiblee === 'function') {
          if (tangibleeTimeoutId) {
            clearInterval(tangibleeTimeoutId);
          }
          TangibleeScript = new Tangiblee();
          return TangibleeScript.init({
            clientDomain: 'www.groupon.com',
            widgetLoadingMode: 'onButtonClick'
          });
        } else {
          return tangibleeTimeoutId = setTimeout(initTangiblee, 100);
        }
      };
      return initTangiblee();
    }
  }
};



},{}],32:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.Media = Backbone.Model.extend({
  initialize: function(arg) {
    var ref;
    ref = arg != null ? arg : {}, this.id = ref.id, this.type = ref.type, this.media = ref.media, this.thumb = ref.thumb, this.provider = ref.provider, this.baseURL = ref.baseURL, this.alt = ref.alt;
    return this.id != null ? this.id : this.id = this.cid;
  },
  isFeatured: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.view.currentFeatured : void 0) === this;
  },
  isLast: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.last() : void 0) === this;
  },
  isVideo: function() {
    return this.type === "video";
  }
});



},{}],33:[function(require,module,exports){
window.swfobject = (function() {
  var EXPRESS_INSTALL_ID, FLASH_MIME_TYPE, OBJECT, ON_READY_STATE_CHANGE, SHOCKWAVE_FLASH, SHOCKWAVE_FLASH_AX, UNDEF, abstractAltContent, addDomLoadEvent, addListener, addLoadEvent, autoHideShow, callDomLoadFunctions, canExpressInstall, cleanup, createCSS, createElement, createObjParam, createSWF, displayAltContent, doc, domLoadFnArr, dynamicStylesheet, dynamicStylesheetMedia, getElementById, getObjectById, hasPlayerVersion, isDomLoaded, isExpressInstallActive, listenersArr, main, matchVersions, nav, objIdArr, onDomLoad, plugin, regObjArr, removeObjectInIE, removeSWF, setVisibility, showExpressInstall, storedAltContent, storedAltContentId, storedCallbackFn, storedCallbackObj, testPlayerVersion, ua, urlEncodeIfNecessary, win;
  UNDEF = "undefined";
  OBJECT = "object";
  SHOCKWAVE_FLASH = "Shockwave Flash";
  SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash";
  FLASH_MIME_TYPE = "application/x-shockwave-flash";
  EXPRESS_INSTALL_ID = "SWFObjectExprInst";
  ON_READY_STATE_CHANGE = "onreadystatechange";
  win = window;
  doc = document;
  nav = navigator;
  plugin = false;
  regObjArr = [];
  objIdArr = [];
  listenersArr = [];
  isDomLoaded = false;
  isExpressInstallActive = false;
  autoHideShow = true;
  storedAltContent = storedAltContentId = storedCallbackFn = storedCallbackObj = dynamicStylesheet = dynamicStylesheetMedia = null;
  callDomLoadFunctions = function() {
    var dl, dlFn, e, i, len, ref, results, t, w;
    if (isDomLoaded) {
      return;
    }
    try {
      t = doc.getElementsByTagName("body")[0].appendChild(createElement("span"));
      t.parentNode.removeChild(t);
    } catch (_error) {
      e = _error;
      return;
    }
    isDomLoaded = true;
    dl = domLoadFnArr;
    ref = domLoadFnArr || [];
    results = [];
    for (i = w = 0, len = ref.length; w < len; i = ++w) {
      dlFn = ref[i];
      results.push(dlFn());
    }
    return results;
  };
  addDomLoadEvent = function(fn) {
    if (isDomLoaded) {
      return fn();
    } else {
      return domLoadFnArr[domLoadFnArr.length] = fn;
    }
  };
  addLoadEvent = function(fn) {
    var fnOld;
    if (typeof win.addEventListener !== UNDEF) {
      return win.addEventListener("load", fn, false);
    } else if (typeof doc.addEventListener !== UNDEF) {
      return doc.addEventListener("load", fn, false);
    } else if (typeof win.attachEvent !== UNDEF) {
      return addListener(win, "onload", fn);
    } else if (typeof win.onload === "function") {
      fnOld = win.onload;
      return win.onload = function() {
        fnOld();
        return fn();
      };
    } else {
      return win.onload = fn;
    }
  };
  main = function() {
    if (plugin) {
      return testPlayerVersion();
    } else {
      return matchVersions();
    }
  };
  domLoadFnArr = [main];
  testPlayerVersion = function() {
    var b, counter, o, t;
    b = doc.getElementsByTagName("body")[0];
    o = createElement(OBJECT);
    o.setAttribute("type", FLASH_MIME_TYPE);
    t = b.appendChild(o);
    if (t) {
      counter = 0;
      return (function() {
        var d;
        if (typeof t.GetVariable !== UNDEF) {
          d = t.GetVariable("$version");
          if (d) {
            d = d.split(" ")[1].split(",");
            ua.pv = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        } else if (counter < 10) {
          counter++;
          setTimeout(arguments.callee, 10);
          return;
        }
        b.removeChild(o);
        t = null;
        return matchVersions();
      })();
    } else {
      return matchVersions();
    }
  };
  matchVersions = function() {
    var att, cb, cbObj, i, id, len, len1, o, obj, p, pair, par, pl, ref, regObj, results, rl, w, x;
    rl = regObjArr.length;
    if (regObjArr.length) {
      results = [];
      for (i = w = 0, len = regObjArr.length; w < len; i = ++w) {
        regObj = regObjArr[i];
        id = regObj.id;
        cb = regObj.callbackFn;
        cbObj = {
          success: false,
          id: id
        };
        if (ua.pv[0] > 0) {
          obj = getElementById(id);
          if (obj) {
            if (hasPlayerVersion(regObj.swfVersion) && !(ua.wk && ua.wk < 312)) {
              setVisibility(id, true);
              if (cb) {
                cbObj.success = true;
                cbObj.ref = getObjectById(id);
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            } else if (regObj.expressInstall && canExpressInstall()) {
              att = {};
              att.data = regObj.expressInstall;
              att.width = obj.getAttribute("width") || "0";
              att.height = obj.getAttribute("height") || "0";
              if (obj.getAttribute("class")) {
                att.styleclass = obj.getAttribute("class");
              }
              if (obj.getAttribute("align")) {
                att.align = obj.getAttribute("align");
              }
              par = {};
              p = obj.getElementsByTagName("param");
              pl = p.length;
              ref = p || [];
              for (x = 0, len1 = ref.length; x < len1; x++) {
                pair = ref[x];
                if (pair.getAttribute("name").toLowerCase() !== "movie") {
                  par[pair.getAttribute("name")] = pair.getAttribute("value");
                }
              }
              results.push(showExpressInstall(att, par, id, cb));
            } else {
              displayAltContent(obj);
              if (cb) {
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            }
          } else {
            results.push(void 0);
          }
        } else {
          setVisibility(id, true);
          if (cb) {
            o = getObjectById(id);
            if (o && typeof o.SetVariable !== UNDEF) {
              cbObj.success = true;
              cbObj.ref = o;
            }
            results.push(cb(cbObj));
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    }
  };
  getObjectById = function(objectIdStr) {
    var n, o, r;
    r = null;
    o = getElementById(objectIdStr);
    if (o && o.nodeName === "OBJECT") {
      if (typeof o.SetVariable !== UNDEF) {
        r = o;
      } else {
        n = o.getElementsByTagName(OBJECT)[0];
        if (n) {
          r = n;
        }
      }
    }
    return r;
  };
  canExpressInstall = function() {
    return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312);
  };
  showExpressInstall = function(att, par, replaceElemIdStr, callbackFn) {
    var fv, newObj, obj, pt;
    isExpressInstallActive = true;
    storedCallbackFn = callbackFn || null;
    storedCallbackObj = {
      success: false,
      id: replaceElemIdStr
    };
    obj = getElementById(replaceElemIdStr);
    if (obj) {
      if (obj.nodeName === "OBJECT") {
        storedAltContent = abstractAltContent(obj);
        storedAltContentId = null;
      } else {
        storedAltContent = obj;
        storedAltContentId = replaceElemIdStr;
      }
      att.id = EXPRESS_INSTALL_ID;
      if (typeof att.width === UNDEF || (!/%$/.test(att.width) && parseInt(att.width, 10) < 310)) {
        att.width = "310";
      }
      if (typeof att.height === UNDEF || (!/%$/.test(att.height) && parseInt(att.height, 10) < 137)) {
        att.height = "137";
      }
      doc.title = doc.title.slice(0, 47) + " - Flash Player Installation";
      pt = ua.ie && ua.win ? "ActiveX" : "PlugIn";
      fv = "MMredirectURL=" + win.location.toString().replace(/&/g, "%26") + "&MMplayerType=" + pt + "&MMdoctitle=" + doc.title;
      if (typeof par.flashvars !== UNDEF) {
        par.flashvars += "&" + fv;
      } else {
        par.flashvars = fv;
      }
      if (ua.ie && ua.win && obj.readyState !== 4) {
        newObj = createElement("div");
        replaceElemIdStr += "SWFObjectNew";
        newObj.setAttribute("id", replaceElemIdStr);
        obj.parentNode.insertBefore(newObj, obj);
        obj.style.display = "none";
        (function() {
          if (obj.readyState === 4) {
            return obj.parentNode.removeChild(obj);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      }
      return createSWF(att, par, replaceElemIdStr);
    }
  };
  displayAltContent = function(obj) {
    var el;
    if (ua.ie && ua.win && obj.readyState !== 4) {
      el = createElement("div");
      obj.parentNode.insertBefore(el, obj);
      el.parentNode.replaceChild(abstractAltContent(obj), el);
      obj.style.display = "none";
      return (function() {
        if (obj.readyState === 4) {
          return obj.parentNode.removeChild(obj);
        } else {
          return setTimeout(arguments.callee, 10);
        }
      })();
    } else {
      return obj.parentNode.replaceChild(abstractAltContent(obj), obj);
    }
  };
  abstractAltContent = function(obj) {
    var ac, c, childNode, cl, len, nestedObj, w;
    ac = createElement("div");
    if (ua.win && ua.ie) {
      ac.innerHTML = obj.innerHTML;
    } else {
      nestedObj = obj.getElementsByTagName(OBJECT)[0];
      if (nestedObj) {
        c = nestedObj.childNodes;
        if (c) {
          cl = c.length;
          for (w = 0, len = c.length; w < len; w++) {
            childNode = c[w];
            if (!(childNode.nodeType === 1 && childNode.nodeName === "PARAM") && !(childNode.nodeType === 8)) {
              ac.appendChild(childNode.cloneNode(true));
            }
          }
        }
      }
    }
    return ac;
  };
  createSWF = function(attObj, parObj, id) {
    var att, el, i, j, m, n, o, par, r;
    r = void 0;
    el = getElementById(id);
    if (ua.wk && ua.wk < 312) {
      return r;
    }
    if (el) {
      if (typeof attObj.id === UNDEF) {
        attObj.id = id;
      }
      if (ua.ie && ua.win) {
        att = "";
        for (i in attObj) {
          if (attObj[i] !== Object.prototype[i]) {
            if (i.toLowerCase() === "data") {
              parObj.movie = attObj[i];
            } else if (i.toLowerCase() === "styleclass") {
              att += ' class="' + attObj[i] + '"';
            } else if (i.toLowerCase() !== "classid") {
              att += ' ' + i + '="' + attObj[i] + '"';
            }
          }
        }
        par = "";
        for (j in parObj) {
          if (parObj[j] !== Object.prototype[j]) {
            par += '<param name="' + j + '" value="' + parObj[j] + '" />';
          }
        }
        el.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + att + '>' + par + '</object>';
        objIdArr[objIdArr.length] = attObj.id;
        r = getElementById(attObj.id);
      } else {
        o = createElement(OBJECT);
        o.setAttribute("type", FLASH_MIME_TYPE);
        for (m in attObj) {
          if (attObj[m] !== Object.prototype[m]) {
            if (m.toLowerCase() === "styleclass") {
              o.setAttribute("class", attObj[m]);
            } else if (m.toLowerCase() !== "classid") {
              o.setAttribute(m, attObj[m]);
            }
          }
        }
        for (n in parObj) {
          if (parObj[n] !== Object.prototype[n] && n.toLowerCase() !== "movie") {
            createObjParam(o, n, parObj[n]);
          }
        }
        el.parentNode.replaceChild(o, el);
        r = o;
      }
    }
    return r;
  };
  createObjParam = function(el, pName, pValue) {
    var p;
    p = createElement("param");
    p.setAttribute("name", pName);
    p.setAttribute("value", pValue);
    return el.appendChild(p);
  };
  removeSWF = function(id) {
    var obj;
    obj = getElementById(id);
    if (obj && obj.nodeName === "OBJECT") {
      if (ua.ie && ua.win) {
        obj.style.display = "none";
        return (function() {
          if (obj.readyState === 4) {
            return removeObjectInIE(id);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      } else {
        return obj.parentNode.removeChild(obj);
      }
    }
  };
  removeObjectInIE = function(id) {
    var len, obj, thing, w;
    obj = getElementById(id);
    if (obj) {
      for (w = 0, len = obj.length; w < len; w++) {
        thing = obj[w];
        if (typeof thing === "function") {
          thing = null;
        }
      }
      return obj.parentNode.removeChild(obj);
    }
  };
  getElementById = function(id) {
    var e, el;
    el = null;
    try {
      el = doc.getElementById(id);
    } catch (_error) {
      e = _error;
    }
    return el;
  };
  createElement = function(el) {
    return doc.createElement(el);
  };
  addListener = function(target, eventType, fn) {
    target.attachEvent(eventType, fn);
    return listenersArr[listenersArr.length] = [target, eventType, fn];
  };
  hasPlayerVersion = function(rv) {
    var pv, ref, v;
    pv = ua.pv;
    v = rv.split(".");
    v[0] = parseInt(v[0], 10);
    v[1] = parseInt(v[1], 10) || 0;
    v[2] = parseInt(v[2], 10) || 0;
    return (ref = pv[0] > v[0] || (pv[0] === v[0] && pv[1] > v[1]) || (pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2])) != null ? ref : {
      "true": false
    };
  };
  createCSS = function(sel, decl, media, newStyle) {
    var h, m, ref, s;
    if (ua.ie && ua.mac) {
      return;
    }
    h = doc.getElementsByTagName("head")[0];
    if (!h) {
      return;
    }
    m = (ref = media && typeof media === "string") != null ? ref : {
      media: "screen"
    };
    if (newStyle) {
      dynamicStylesheet = null;
      dynamicStylesheetMedia = null;
    }
    if (!dynamicStylesheet || dynamicStylesheetMedia !== m) {
      s = createElement("style");
      s.setAttribute("type", "text/css");
      s.setAttribute("media", m);
      dynamicStylesheet = h.appendChild(s);
      if (ua.ie && ua.win && typeof doc.styleSheets !== UNDEF && doc.styleSheets.length > 0) {
        dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1];
      }
      dynamicStylesheetMedia = m;
    }
    if (ua.ie && ua.win) {
      if (dynamicStylesheet && typeof dynamicStylesheet.addRule === OBJECT) {
        return dynamicStylesheet.addRule(sel, decl);
      }
    } else {
      if (dynamicStylesheet && typeof doc.createTextNode !== UNDEF) {
        return dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"));
      }
    }
  };
  setVisibility = function(id, isVisible) {
    var v;
    if (!autoHideShow) {
      return;
    }
    v = isVisible != null ? isVisible : {
      "visible": "hidden"
    };
    if (isDomLoaded && getElementById(id)) {
      return getElementById(id).style.visibility = v;
    } else {
      return createCSS("#" + id, "visibility:" + v);
    }
  };
  urlEncodeIfNecessary = function(s) {
    var hasBadChars, regex;
    regex = /[\\\"<>\.;]/;
    hasBadChars = regex.exec(s) !== null;
    return hasBadChars && typeof encodeURIComponent !== (UNDEF ? encodeURIComponent(s) : s);
  };
  ua = (function() {
    var a, d, e, ie, mac, p, playerVersion, u, w3cdom, webkit, windows;
    w3cdom = typeof doc.getElementById !== UNDEF && typeof doc.getElementsByTagName !== UNDEF && typeof doc.createElement !== UNDEF;
    u = nav.userAgent.toLowerCase();
    p = nav.platform.toLowerCase();
    windows = p ? /win/.test(p) : /win/.test(u);
    mac = p ? /mac/.test(p) : /mac/.test(u);
    webkit = /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false;
    ie = !+"\v1";
    playerVersion = [0, 0, 0];
    d = null;
    if (typeof nav.plugins !== UNDEF && typeof nav.plugins[SHOCKWAVE_FLASH] === OBJECT) {
      d = nav.plugins[SHOCKWAVE_FLASH].description;
      if (d && !(typeof nav.mimeTypes !== UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) {
        plugin = true;
        ie = false;
        d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
        playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10);
        playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
        playerVersion[2] = /[a-zA-Z]/.test(d) ? parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
      }
    } else if (typeof win.ActiveXObject !== UNDEF) {
      try {
        a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
        if (a) {
          d = a.GetVariable("$version");
          if (d) {
            ie = true;
            d = d.split(" ")[1].split(",");
            playerVersion = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        }
      } catch (_error) {
        e = _error;
      }
    }
    return {
      w3: w3cdom,
      pv: playerVersion,
      wk: webkit,
      ie: ie,
      win: windows,
      mac: mac
    };
  })();
  onDomLoad = (function() {
    if (!ua.w3) {
      return;
    }
    if ((typeof doc.readyState !== UNDEF && doc.readyState === "complete") || (typeof doc.readyState === UNDEF && (doc.getElementsByTagName("body")[0] || doc.body))) {
      callDomLoadFunctions();
    }
    if (!isDomLoaded) {
      if (typeof doc.addEventListener !== UNDEF) {
        doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false);
      }
      if (ua.ie && ua.win) {
        doc.attachEvent(ON_READY_STATE_CHANGE, function() {
          if (doc.readyState === "complete") {
            doc.detachEvent(ON_READY_STATE_CHANGE, arguments.callee);
            return callDomLoadFunctions();
          }
        });
        if (win === top) {
          (function() {
            var e;
            if (isDomLoaded) {
              return;
            }
            try {
              doc.documentElement.doScroll("left");
            } catch (_error) {
              e = _error;
              setTimeout(arguments.callee, 0);
              return;
            }
            return callDomLoadFunctions();
          })();
        }
      }
      if (ua.wk) {
        (function() {
          if (isDomLoaded) {
            return;
          }
          if (!/loaded|complete/.test(doc.readyState)) {
            setTimeout(arguments.callee, 0);
            return;
          }
          return callDomLoadFunctions();
        })();
      }
      return addLoadEvent(callDomLoadFunctions);
    }
  })();
  cleanup = (function() {
    if (ua.ie && ua.win) {
      return window.attachEvent("onunload", function() {
        var k, l, len, len1, listener, obj, swfobject, w, x;
        for (w = 0, len = listenersArr.length; w < len; w++) {
          listener = listenersArr[w];
          listener[0].detachEvent(listener[1], listener[2]);
        }
        for (x = 0, len1 = objIdArr.length; x < len1; x++) {
          obj = objIdArr[x];
          removeSWF(obj);
        }
        for (k in ua) {
          ua[k] = null;
        }
        ua = null;
        for (l in swfobject) {
          swfobject[l] = null;
        }
        return swfobject = null;
      });
    }
  })();
  return {
    registerObject: function(objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) {
      var regObj;
      if (ua.w3 && objectIdStr && swfVersionStr) {
        regObj = {};
        regObj.id = objectIdStr;
        regObj.swfVersion = swfVersionStr;
        regObj.expressInstall = xiSwfUrlStr;
        regObj.callbackFn = callbackFn;
        regObjArr[regObjArr.length] = regObj;
        return setVisibility(objectIdStr, false);
      } else {
        return typeof callbackFn === "function" ? callbackFn({
          success: false,
          id: objectIdStr
        }) : void 0;
      }
    },
    getObjectById: function(objectIdStr) {
      if (ua.w3) {
        return getObjectById(objectIdStr);
      }
    },
    embedSWF: function(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
      var callbackObj;
      callbackObj = {
        success: false,
        id: replaceElemIdStr
      };
      if (ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
        setVisibility(replaceElemIdStr, false);
        return addDomLoadEvent(function() {
          var att, i, j, k, obj, par;
          widthStr += "";
          heightStr += "";
          att = {};
          if (attObj && typeof attObj === OBJECT) {
            for (i in attObj) {
              att[i] = attObj[i];
            }
          }
          att.data = swfUrlStr;
          att.width = widthStr;
          att.height = heightStr;
          par = {};
          if (parObj && typeof parObj === OBJECT) {
            for (j in parObj) {
              par[j] = parObj[j];
            }
          }
          if (flashvarsObj && typeof flashvarsObj === OBJECT) {
            for (k in flashvarsObj) {
              if (typeof par.flashvars !== UNDEF) {
                par.flashvars += "&" + k + "=" + flashvarsObj[k];
              } else {
                par.flashvars = k + "=" + flashvarsObj[k];
              }
            }
          }
          if (hasPlayerVersion(swfVersionStr)) {
            obj = createSWF(att, par, replaceElemIdStr);
            if (att.id === replaceElemIdStr) {
              setVisibility(replaceElemIdStr, true);
            }
            callbackObj.success = true;
            callbackObj.ref = obj;
          } else if (xiSwfUrlStr && canExpressInstall()) {
            att.data = xiSwfUrlStr;
            showExpressInstall(att, par, replaceElemIdStr, callbackFn);
            return;
          } else {
            setVisibility(replaceElemIdStr, true);
          }
          return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
        });
      } else {
        return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
      }
    },
    switchOffAutoHideShow: function() {
      return autoHideShow = false;
    },
    ua: ua,
    getFlashPlayerVersion: function() {
      return {
        major: ua.pv[0],
        minor: ua.pv[1],
        release: ua.pv[2]
      };
    },
    hasFlashPlayerVersion: hasPlayerVersion,
    createSWF: function(attObj, parObj, replaceElemIdStr) {
      if (ua.w3) {
        return createSWF(attObj, parObj, replaceElemIdStr);
      } else {
        return void 0;
      }
    },
    showExpressInstall: function(att, par, replaceElemIdStr, callbackFn) {
      if (ua.w3 && canExpressInstall()) {
        return showExpressInstall(att, par, replaceElemIdStr, callbackFn);
      }
    },
    removeSWF: function(objElemIdStr) {
      if (ua.w3) {
        return removeSWF(objElemIdStr);
      }
    },
    createCSS: function(selStr, declStr, mediaStr, newStyleBoolean) {
      if (ua.w3) {
        return createCSS(selStr, declStr, mediaStr, newStyleBoolean);
      }
    },
    addDomLoadEvent: addDomLoadEvent,
    addLoadEvent: addLoadEvent,
    getQueryParamValue: function(param) {
      var len, pair, pairs, q, w;
      q = doc.location.search || doc.location.hash;
      if (q) {
        if (/\?/.test(q)) {
          q = q.split("?")[1];
        }
        if (param === null) {
          return urlEncodeIfNecessary(q);
        }
        pairs = q.split("&");
        for (w = 0, len = pairs.length; w < len; w++) {
          pair = pairs[w];
          if (pair.substring(0, pair.indexOf("=")) === param) {
            return urlEncodeIfNecessary(pair.substring(pair.indexOf("=") + 1));
          }
        }
      }
      return "";
    },
    expressInstallCallback: function() {
      var obj;
      if (isExpressInstallActive) {
        obj = getElementById(EXPRESS_INSTALL_ID);
        if (obj && storedAltContent) {
          obj.parentNode.replaceChild(storedAltContent, obj);
          if (storedAltContentId) {
            setVisibility(storedAltContentId, true);
            if (ua.ie && ua.win) {
              storedAltContent.style.display = "block";
            }
          }
          if (storedCallbackFn) {
            storedCallbackFn(storedCallbackObj);
          }
        }
        return isExpressInstallActive = false;
      }
    }
  };
})();



},{}],34:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.CarouselTemplate = Hogan.compile('{{# renderFullCarousel }}\n  <div class="gallery {{ classes }}" data-bhw="PromNightGallery" data-bhc="PromNightGallery:{{ uuid }}">\n    <div class="gallery-featured">\n      <div class="click-blocker"></div>\n      {{# featured }}\n        {{# isVideo }}\n          <img src="http://cdnapi.kaltura.com/p/1302621/thumbnail/entry_id/{{ media }}/height/{{ collection.view.options.mediaHeight}}" id="gallery-video-{{ id }}" data-id="{{ id }}" />\n        {{/ isVideo }}\n        {{^ isVideo }}\n          <img src="{{ media }}" id="gallery-image-{{ id }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />\n        {{/ isVideo }}\n      {{/ featured }}\n    </div>\n\n    {{# showThumbs }}\n      <ul class="gallery-thumbs">\n        {{# models }}\n          <li class="gallery-thumbnail{{# isFeatured }} selected{{/ isFeatured }}{{# isVideo }} video{{/ isVideo }}{{^ thumb }} no-thumbnail{{/ thumb }}{{# isLast }} last{{/ isLast }}" id="gallery-thumb-{{ id }}" data-id="{{ id }}" data-bhc="thumbnail_click:{{ id }}"{{# isVideo }} data-bhd="{{ videoBHD }}"{{/ isVideo }}>\n            {{# thumb }}\n              {{# lazyLoadThumbs }}<img class="lazy-load" data-original="{{ thumb }}" />{{/ lazyLoadThumbs }}\n              {{^ lazyLoadThumbs }}<img src="{{ thumb }}" />{{/ lazyLoadThumbs }}\n            {{/ thumb }}\n          </li>\n        {{/ models }}\n      </ul>\n    {{/ showThumbs }}\n\n    <div class="gallery-controls">\n      {{# showProductSizing }}\n        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">\n          <div class="compare-size-background"></div>\n          <div class="compare-size-icon"></div>\n          <div class="compare-size-text">{{ compareSizeMessage }}</div>\n        </div>\n      {{/ showProductSizing }}\n\n      {{# showThumbs }}\n        <div class="gallery-control-back icon-arrow-left-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>\n        <div class="gallery-control-forward icon-arrow-right-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>\n      {{/ showThumbs }}\n\n      <div class="gallery-control-left icon-arrow-left-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>\n      <div class="gallery-control-right icon-arrow-right-large" data-bhc="bumper_right:{{ uuid }}"></div>\n    </div>\n  </div>\n{{/ renderFullCarousel }}\n{{^ renderFullCarousel }}\n  <div class="gallery-single">\n    <div class="gallery-featured">\n      {{# first }}\n\n         {{# lazyLoadFeatured }} <img class="featured-image sleepy-load" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} /> {{/ lazyLoadFeatured }}\n         {{^ lazyLoadFeatured }} <img class="featured-image" src="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} /> {{/ lazyLoadFeatured }}\n\n      {{/ first }}\n    </div>\n    <div class="gallery-controls">\n      {{# showProductSizing }}\n        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">\n          <div class="compare-size-background"></div>\n          <div class="compare-size-icon"></div>\n          <div class="compare-size-text">{{ compareSizeMessage }}</div>\n        </div>\n      {{/ showProductSizing }}\n    </div>\n  </div>\n{{/ renderFullCarousel }}');



},{}],35:[function(require,module,exports){
var IMAGE_ASPECT_RATIO, TABLET_MQ_WIDTH;

TABLET_MQ_WIDTH = 768;

IMAGE_ASPECT_RATIO = 0.6;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.View = Backbone.View.extend({
  events: {
    'click .gallery-control-back': 'onBackClick',
    'click .gallery-control-forward': 'onForwardClick',
    'click .gallery-control-left': 'onLeftClick',
    'click .gallery-control-right': 'onRightClick',
    'click .gallery-thumbnail': 'onThumbnailClick'
  },
  initialize: function() {
    var base;
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.currentFeatured = this.options.featured || this.collection.first();
    this.collection.classes = '';
    this.collection.view = this;
    this.collection.videoBHD = JSON.stringify({
      video: true
    });
    this.collection.featured = (function(_this) {
      return function() {
        return _this.currentFeatured;
      };
    })(this);
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = this.collection.length > 1;
    this.collection.showThumbs = this.options.showThumbs;
    this.collection.showProductSizing = this.options.showProductSizing;
    if (this.options.showProductSizing) {
      this.collection.compareSizeMessage = this.options.compareSizeMessage;
    }
    this.collection.lazyLoadThumbs = this.options.lazyLoadThumbs;
    this.collection.lazyLoadFeatured = this.options.lazyLoadFeatured;
    return (base = this.options).imageQualty != null ? base.imageQualty : base.imageQualty = '';
  },
  render: function() {
    var bodyWidth, el, featuredIndex, height, renderOptions;
    this.$el = $(this.el);
    renderOptions = _.extend({
      zoomMessage: this.options.zoomMessage
    }, this.collection);
    el = DealCarousel.CarouselTemplate.render(renderOptions);
    this.$el = $(el).replaceAll(this.$el);
    this.el = this.$el[0];
    this.$thumbs = this.$el.find(".gallery-thumbs");
    this.$thumbnails = this.$thumbs.children();
    this.$gallery = this.$el.find(".gallery-featured");
    this.$galleryMedia = this.$gallery.find("img");
    this.$clickBlocker = this.$el.find(".click-blocker");
    this.$controls = this.$el.find(".gallery-controls");
    this.$backButton = this.$controls.find(".gallery-control-back");
    this.$forwardButton = this.$controls.find(".gallery-control-forward");
    this.$leftButton = this.$controls.find(".gallery-control-left");
    this.$rightButton = this.$controls.find(".gallery-control-right");
    this.containerWidth = this.$el.width();
    this.insideContainerWidth = this.containerWidth - this.$backButton.width() - this.$forwardButton.width();
    this.$body = $(document.body);
    this.rtl = this.$body.hasClass('rtl');
    this.animateViaJS = !this.$body.parent('html').hasClass('cssanimations');
    this.thumbsWidth = this.$thumbs.width();
    this.thumbWidth = this.$thumbs.children().outerWidth();
    if (this.rtl) {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-left"));
    } else {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-right"));
    }
    this.thumbsWidth = this._calculateThumbsWidth();
    this.media = {};
    this.currentPosition = 0;
    this.hasOverflow = this.thumbsWidth > this.containerWidth;
    if (this.options.mediaHeight < this.$galleryMedia.height() || this.$galleryMedia.height() === 0) {
      bodyWidth = this.$body.width();
      if (bodyWidth > TABLET_MQ_WIDTH) {
        this.setFeaturedHeight(this.options.mediaHeight);
      } else {
        height = IMAGE_ASPECT_RATIO * this.containerWidth;
        this.setFeaturedHeight(height);
      }
    } else {
      this.setFeaturedHeight(this.$galleryMedia.height());
    }
    this.centerThumbs();
    featuredIndex = this.collection.indexOf(this.currentFeatured);
    this.fetchInitialMedia(featuredIndex);
    this._prepareGroups();
    if (featuredIndex !== 0) {
      this._adjustThumbs(featuredIndex);
    }
    return this.delegateEvents();
  },
  centerThumbs: function() {
    var direction;
    this.thumbsWidth = this._calculateThumbsWidth();
    this.$thumbs.width(this.thumbsWidth);
    if (!this.hasOverflow) {
      return this.visibleThumbs = this.$thumbnails.length;
    } else {
      direction = this.rtl ? 'right' : 'left';
      this.visibleThumbs = Math.floor(this.insideContainerWidth / this.thumbWidth);
      this.visibleThumbs--;
      this.$el.addClass("has-navigation");
      return this.$thumbs.css(direction, this.$backButton.width() + this.thumbMargin);
    }
  },
  fetchMedia: function(index) {
    var media;
    media = this.collection.at(index);
    if (this.media[media.id] != null) {
      return false;
    }
    if (media.type === "video") {
      return this.fetchVideo(media);
    } else {
      return this.fetchImage(media);
    }
  },
  fetchImage: function(image) {
    var $newImage, newImage;
    newImage = new Image();
    newImage.src = image.media;
    $newImage = $(newImage);
    $newImage.data("id", image.id);
    $newImage.attr("id", "gallery-image-" + image.id);
    if (image.alt != null) {
      $newImage.attr("alt", image.alt);
    }
    return this.media[image.id] = $newImage;
  },
  fetchVideo: function(video) {
    var playerId;
    playerId = video.provider === "KALTURA" ? "kaltura-player-1360194818" : video.provider === "OOYALA" ? "ooyala-player" : video.provider === "YOUTUBE" ? "yt-player" : void 0;
    return this.media[video.id] = $("<div/>", {
      id: "video-container"
    }).attr("data-bhw", "PromNightVideo").html("<div id=\"" + playerId + "\" style=\"width:" + this.containerWidth + "px; height:" + this.options.mediaHeight + "px; margin: 0 auto;\"></div>");
  },
  fetchInitialMedia: function(start) {
    var collectionSize, i, j, loadCount, ref, ref1, results;
    if (start == null) {
      start = 0;
    }
    loadCount = 1;
    if (this.options.prefetchImages) {
      collectionSize = this.collection.size();
      loadCount = this.visibleThumbs;
      if (start + loadCount > collectionSize) {
        loadCount = collectionSize - start;
      }
    }
    results = [];
    for (i = j = ref = start, ref1 = start + loadCount; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      results.push(this.fetchMedia(i));
    }
    return results;
  },
  onBackClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onForwardClick(null, true);
      }
    }
    if (this.activeGroup > 0) {
      this.activeGroup--;
    } else {
      this.activeGroup = this.totalGroups - 1;
    }
    return this._updateThumbsPosition();
  },
  onForwardClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onBackClick(null, true);
      }
    }
    if (this.activeGroup < this.totalGroups - 1) {
      this.activeGroup++;
    } else {
      this.activeGroup = 0;
    }
    return this._updateThumbsPosition();
  },
  onLeftClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onRightClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb > 0) {
      newMedia = this.collection.at(currentThumb - 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(this.collection.size() - 1);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onRightClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onLeftClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb < this.collection.size() - 1) {
      newMedia = this.collection.at(currentThumb + 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(0);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onThumbnailClick: function(e) {
    var $thumb, newMedia;
    $thumb = this.$thumbs.find(e.currentTarget);
    newMedia = this.collection.get($thumb.data("id"));
    if (newMedia === this.currentFeatured) {
      return;
    }
    return this.updateGallery(newMedia);
  },
  playVideo: function(media) {
    if (media.provider === "KALTURA") {
      return kWidget.embed({
        "targetId": "kaltura-player-1360194818",
        "cache_st": 1360194818,
        "wid": "_1302621",
        "uiconf_id": "11486911",
        "flashvars": {
          "autoPlay": true,
          "streamerType": "hdnetwork",
          "akamaiHD": {
            "loadingPolicy": "preInitialize",
            "asyncInit": "true"
          }
        },
        "entry_id": media.media
      });
    } else if (media.provider === "OOYALA") {
      return this.videoPlayer = OO.Player.create('ooyala-player', media.media, {
        autoplay: true
      });
    } else if (media.provider === "YOUTUBE") {
      return this.videoPlayer = new YT.Player('yt-player', {
        height: this.$el.height(),
        width: this.$el.width(),
        videoId: media.media,
        events: {
          onReady: function(e) {
            return e.target.playVideo();
          }
        }
      });
    }
  },
  setFeaturedHeight: function(mediaHeight) {
    this.$gallery.height(mediaHeight);
    if (!(this.$body.hasClass("goods") || this.$body.hasClass("getaways") || this.$body.hasClass("getaways-booking"))) {
      mediaHeight += 3;
    }
    return this.$controls.height(mediaHeight);
  },
  updateGallery: function(newMedia) {
    var $newGalleryMedia, isCurrentVideo, newGalleryMedia, newMediaIndex, onComplete, transitionCSS;
    newMediaIndex = this.collection.indexOf(newMedia);
    if (this.media[newMedia.id]) {
      newGalleryMedia = this.media[newMedia.id];
    } else {
      this.fetchMedia(newMediaIndex);
      newGalleryMedia = this.media[newMedia.id];
    }
    $newGalleryMedia = $(newGalleryMedia);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 0
      };
      $newGalleryMedia.css(transitionCSS);
    }
    $newGalleryMedia.appendTo(this.$gallery);
    if (newMediaIndex > 0) {
      this.$leftButton.removeClass("disabled");
    } else {
      this.$leftButton.addClass("disabled");
    }
    if (newMediaIndex < this.collection.size() - 1) {
      this.$rightButton.removeClass("disabled");
    } else {
      this.$rightButton.addClass("disabled");
    }
    this._adjustThumbs(this.collection.indexOf(newMedia));
    if (newMedia.type === "video") {
      this.playVideo(newMedia);
      this.$clickBlocker.hide();
      this.$controls.hide();
    } else {
      this.$clickBlocker.show();
      this.$controls.show();
    }
    isCurrentVideo = this.currentFeatured.type === "video";
    onComplete = (function(_this) {
      return function() {
        var ref;
        _this.$gallery.children("[id^='gallery-']:not(#gallery-video-" + _this.currentFeatured.id + ", #gallery-image-" + _this.currentFeatured.id + ")").remove();
        if (isCurrentVideo) {
          if ((ref = _this.videoPlayer) != null) {
            ref.destroy();
          }
          return _this.$gallery.children("#video-container").remove();
        }
      };
    })(this);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 1
      };
      $newGalleryMedia.animate(transitionCSS, {
        complete: onComplete
      }, "slow");
    } else {
      setTimeout(onComplete, 600);
    }
    this.$thumbs.find("#gallery-thumb-" + newMedia.id).addClass("selected").siblings().removeClass("selected");
    this.$galleryMedia = $newGalleryMedia;
    this.currentFeatured = newMedia;
    return this.$body.trigger("carouselUpdate", {
      image: newMedia.baseURL,
      uuid: this.options.uuid
    });
  },
  updateCollection: function(collection) {
    var currentHeight, singleImage;
    this.collection = collection;
    if (!this.collection) {
      return;
    }
    singleImage = this.collection.length === 1;
    if (singleImage) {
      currentHeight = this.$el.height();
    }
    this.undelegateEvents;
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = !singleImage;
    this.currentFeatured = this.collection.first();
    this.render();
    if (singleImage) {
      return this.$el.css("min-height", currentHeight);
    }
  },
  _calculateThumbMargins: function(marginalia) {
    if (this.visibleThumbs > 1) {
      return Math.floor(marginalia / (this.visibleThumbs - 1));
    } else {
      return Math.floor(marginalia);
    }
  },
  _calculateThumbsWidth: function() {
    return (this.thumbWidth + this.thumbMargin) * this.$thumbnails.length - this.thumbMargin;
  },
  _prepareGroups: function() {
    this.thumbGroups = [];
    this.totalGroups = 0;
    this.thumbsPerGroup = 0;
    this.activeGroup = 0;
    this.pnThumbWidth = this.thumbWidth + this.thumbMargin;
    this.pnThumbWrapWidth = this.$thumbnails.length * this.pnThumbWidth;
    if (this.hasOverflow) {
      this._setThumbsPerGroup();
      this._setTotalGroups();
      this._setThumbGroups();
      this._setLastGroupThumbsShort();
      this._setActiveGroup();
      return this._updateThumbsPosition();
    }
  },
  _scrollThumbsPosition: function() {
    var direction, options;
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = -1 * $(this.$thumbnails[this.currentPosition]).position()[direction] + this.$backButton.width();
    if (this.animateViaJS) {
      this.$thumbs.animate(options);
    } else {
      this.$thumbs.css(options);
    }
    if (this.currentPosition === 0) {
      this.$backButton.addClass("disabled");
    } else {
      this.$backButton.removeClass("disabled");
    }
    if (this.currentPosition === this.collection.size() - this.visibleThumbs) {
      return this.$forwardButton.addClass("disabled");
    } else {
      return this.$forwardButton.removeClass("disabled");
    }
  },
  _setActiveGroup: function() {
    var currentIndex, group, i, j, lastRange, len, ref, results;
    currentIndex = this.collection.indexOf(this.currentFeatured);
    lastRange = this.thumbGroups[this.totalGroups - 1];
    ref = this.thumbGroups;
    results = [];
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (currentIndex >= group[0] && currentIndex <= group[1]) {
        if (this.activeGroup !== i) {
          this.activeGroup = i;
          results.push(this._updateThumbsPosition());
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  _setLastGroupThumbsShort: function() {
    return this.thumbsShort = this.thumbsPerGroup - (this.thumbGroups[this.totalGroups - 1][1] - this.thumbGroups[this.totalGroups - 1][0] + 1);
  },
  _setThumbGroups: function() {
    var end, i, j, ref, results, start;
    results = [];
    for (i = j = 0, ref = this.totalGroups - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      start = i * this.thumbsPerGroup;
      end = start + this.thumbsPerGroup - 1;
      if (end >= this.$thumbnails.length) {
        end = this.$thumbnails.length - 1;
      }
      results.push(this.thumbGroups[i] = [start, end]);
    }
    return results;
  },
  _setThumbsPerGroup: function() {
    return this.thumbsPerGroup = Math.floor(this.insideContainerWidth / (this.thumbWidth + this.thumbMargin));
  },
  _setTotalGroups: function() {
    return this.totalGroups = Math.ceil(this.thumbsWidth / this.insideContainerWidth);
  },
  _updateThumbsPosition: function() {
    var direction, modifier, options;
    modifier = 0;
    if (this.activeGroup === this.totalGroups - 1) {
      modifier = (this.thumbWidth + this.thumbMargin) * this.thumbsShort;
    }
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = (-1 * (((this.insideContainerWidth - this.thumbMargin) * this.activeGroup) - modifier - this.$backButton.width() - this.thumbMargin)) + "px";
    if (this.animateViaJS) {
      return this.$thumbs.animate(options);
    } else {
      return this.$thumbs.css(options);
    }
  },
  _adjustThumbs: function(index) {
    var group, i, j, k, len, ref, ref1, ref2;
    ref = this.thumbGroups;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (index >= group[0] && index <= group[1] && this.activeGroup !== i) {
        this.activeGroup = i;
        this._updateThumbsPosition();
        for (i = k = ref1 = group[0], ref2 = group[1]; ref1 <= ref2 ? k <= ref2 : k >= ref2; i = ref1 <= ref2 ? ++k : --k) {
          this.fetchMedia(i);
        }
        break;
      }
    }
  }
});



},{}],36:[function(require,module,exports){
var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, shouldShowTimerForGoods, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, ignoreCap) {
  if (ignoreCap == null) {
    ignoreCap = false;
  }
  switch (false) {
    case !(timeLeft.days >= 15 && !ignoreCap):
      return "";
    case !(timeLeft.days > 1):
      return ".countdown_time_many_days";
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

shouldShowTimerForGoods = function(dealTimer, timeLeft) {
  switch (dealTimer) {
    case 'lessThanEqualTo7Days':
      return timeLeft.days < 7 || (timeLeft.days === 7 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo3Days':
      return timeLeft.days < 3 || (timeLeft.days === 3 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo1Day':
      return timeLeft.days < 1 || (timeLeft.days === 1 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo12Hrs':
      return (timeLeft.days === 0 && timeLeft.hours < 12) || (timeLeft.days === 0 && timeLeft.hours === 12 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    default:
      return true;
  }
};

if (typeof window !== "undefined" && window !== null) {
  if (window.CountdownTimer == null) {
    window.CountdownTimer = {};
  }
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
  CountdownTimer.Helpers.shouldShowTimerForGoods = shouldShowTimerForGoods;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp,
    shouldShowTimerForGoods: shouldShowTimerForGoods
  };
}



},{}],37:[function(require,module,exports){
var base;

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

if ((base = window.CountdownTimer).current == null) {
  base.current = {};
}

CountdownTimer.init = function(arg, done) {
  var endAt, ref, timerData, timerModel;
  timerData = arg.timerData;
  if (done == null) {
    done = function() {};
  }
  endAt = timerData != null ? (ref = timerData.expiringSoon) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new CountdownTimer.Model({
    endAt: endAt
  });
  window.CountdownTimer.current.timerModel = timerModel;
  window.CountdownTimer.current.timerView = new CountdownTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: timerData != null ? timerData.el : void 0
  });
  return $(function() {
    window.CountdownTimer.current.timerView.render();
    return done();
  });
};



},{}],38:[function(require,module,exports){
if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.get('endAt'));
    return CountdownTimer.Helpers.timeRemaining(millisLeft);
  }
});



},{}],39:[function(require,module,exports){
var DEFAULT_EL;

DEFAULT_EL = '.limited-time > .counter li.countdown-timer';

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    return this.el = this.options.el || DEFAULT_EL;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("js.modules.groupon-deal-timer" + (CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timerIcon: '<span class="icon-now"></span>',
      timestamp: CountdownTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});



},{}],40:[function(require,module,exports){
var ShortcutHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ShortcutHeader = window.ShortcutHeader = {};

ShortcutHeader.EventHandler = (function() {
  var TOP_BUFFER;

  TOP_BUFFER = 10;

  function EventHandler(config, eventExtends) {
    this.updateShortcutSelection = bind(this.updateShortcutSelection, this);
    var animationConfig;
    if (eventExtends) {
      this.onSectionScroll = eventExtends.onSectionScroll, this.onShortcutClick = eventExtends.onShortcutClick;
    }
    this.stickyWatchElements = config.stickyWatchElements, this.shortcutMap = config.shortcutMap, this.stickyClass = config.stickyClass, animationConfig = config.animationConfig;
    this.$headers = $('#shortcut-header');
    this.setDefaults(animationConfig);
  }

  EventHandler.prototype.setDefaults = function(config) {
    this.tickInterval = (config != null ? config.tickInterval : void 0) || 15;
    this.visibleFactor = (config != null ? config.visibleFactor : void 0) || 100;
    this.scrollDelay = (config != null ? config.scrollDelay : void 0) || 20;
    if (this.stickyClass == null) {
      this.stickyClass = 'fixed';
    }
    return this.elemSelected = false;
  };

  EventHandler.prototype._getTopPosition = function(target) {
    var $target;
    $target = $(target);
    if ($target.length) {
      return $target.offset().top - this._offsetHeight() + TOP_BUFFER;
    }
  };

  EventHandler.prototype._isSectionInViewport = function(el) {
    var offset, rect, ref;
    rect = (ref = el[0]) != null ? ref.getBoundingClientRect() : void 0;
    offset = this._offsetHeight() + this.visibleFactor;
    return (rect != null ? rect.bottom : void 0) >= offset;
  };

  EventHandler.prototype._offsetHeight = function() {
    var bottom, height, index, len, stickyElements;
    height = 0;
    index = 0;
    stickyElements = $("." + this.stickyClass);
    len = stickyElements.length;
    while (index < len) {
      bottom = stickyElements[index].getBoundingClientRect().bottom;
      if (bottom > height) {
        height = bottom;
      }
      index++;
    }
    return height;
  };

  EventHandler.prototype.navigateTargetSection = function(target, callback) {
    var current, difference, duration, final, increment, initial, stepAnimator;
    initial = $(window).scrollTop();
    final = this._getTopPosition(target);
    difference = Math.abs(final - initial);
    duration = difference / 10 + 100;
    increment = Math.ceil(difference * this.tickInterval / duration);
    current = initial;
    stepAnimator = (function(_this) {
      return function() {
        if (Math.abs(current - final) < increment) {
          current = final;
        } else if (current < final) {
          current = current + increment;
        } else {
          current = current - increment;
        }
        window.scrollTo(0, current);
        if (current !== final) {
          final = _this._getTopPosition(target) || final;
          return setTimeout(stepAnimator, _this.tickInterval);
        } else {
          return callback();
        }
      };
    })(this);
    return stepAnimator();
  };

  EventHandler.prototype.processShortcutSelection = function(el, ev) {
    var $el, ref, targetSection;
    $el = $(el);
    targetSection = (ref = this.shortcutMap) != null ? ref[$el.attr('id')] : void 0;
    this.elemSelected = true;
    this.navigateTargetSection(targetSection, (function(_this) {
      return function() {
        return _this.elemSelected = false;
      };
    })(this));
    this.$headers.find('.shortcut-group li').removeClass("selected");
    $el.addClass("selected");
    if (typeof this.onShortcutClick === "function") {
      this.onShortcutClick($el);
    }
    return ev != null ? ev.preventDefault() : void 0;
  };

  EventHandler.prototype.stickHeader = function(watchElement) {
    var $watchElement, isFixed, offset, offsetTop, processStickHeader, throttled, watchParentOffset;
    offset = 0;
    isFixed = false;
    if (_.isObject(watchElement)) {
      $watchElement = $(watchElement.elem);
      watchParentOffset = $(watchElement.parent).height();
    } else {
      $watchElement = $(watchElement);
    }
    if (!($watchElement && $watchElement.offset())) {
      return;
    }
    offsetTop = $watchElement.offset().top - offset;
    processStickHeader = function() {
      var scrollTop, shouldBeFixed;
      scrollTop = $(window).scrollTop();
      if (watchParentOffset == null) {
        watchParentOffset = $(watchElement.parent).height();
      }
      if (!isFixed) {
        offsetTop = $watchElement.offset().top - (watchParentOffset != null ? watchParentOffset : 0);
      }
      shouldBeFixed = scrollTop > offsetTop;
      if (shouldBeFixed && !isFixed) {
        isFixed = true;
        return $watchElement.trigger("stickElement", {
          offset: watchParentOffset != null ? watchParentOffset : 0
        });
      } else if (!shouldBeFixed && isFixed) {
        isFixed = false;
        return $watchElement.trigger("unstickElement", []);
      }
    };
    throttled = _.throttle(processStickHeader, this.scrollDelay);
    return $(window).on("scroll", throttled);
  };

  EventHandler.prototype.updateShortcutSelection = function() {
    var $el, contentId, shortcutId;
    for (shortcutId in this.shortcutMap) {
      contentId = this.shortcutMap[shortcutId];
      $el = $(contentId);
      if (!this.elemSelected && $el.length === 1 && this._isSectionInViewport($el)) {
        this.$headers.find('.shortcut-group li').removeClass("selected");
        this.$headers.find("." + shortcutId).addClass("selected");
        if (typeof this.onSectionScroll === "function") {
          this.onSectionScroll($el);
        }
        break;
      }
    }
  };

  EventHandler.prototype.activate = function() {
    var elem, layout, processShortcutSelection;
    if (this.$headers.find('.shortcut-group li.selected').length === 0) {
      this.$headers.find('.shortcut-group li:first').addClass("selected");
    }
    layout = this;
    this.$headers.find('.shortcut-group li').on("click", function(ev) {
      return layout.processShortcutSelection($(this), ev);
    });
    for (elem in this.stickyWatchElements) {
      this.stickHeader(this.stickyWatchElements[elem]);
    }
    processShortcutSelection = _.throttle(this.updateShortcutSelection, this.scrollDelay);
    return $(window).on("resize scroll", processShortcutSelection);
  };

  return EventHandler;

})();

module.exports = ShortcutHeader;



},{}],41:[function(require,module,exports){
var ShortcutHeader, StickyHeader, _getTargetsOnce, _handleWindowResize;

StickyHeader = window.StickyHeader != null ? window.StickyHeader : window.StickyHeader = {};

ShortcutHeader = require('./header');

_handleWindowResize = function() {
  var $purchaseCluster;
  $purchaseCluster = $('#purchase-cluster');
  return $(window).on('resize', function() {
    var $buyElement, ref;
    $buyElement = $purchaseCluster.find('.buy.fixed');
    return $buyElement.css({
      left: $purchaseCluster != null ? (ref = $purchaseCluster.offset()) != null ? ref.left : void 0 : void 0
    });
  });
};

_getTargetsOnce = function(shortcutMap) {
  var key, target, targets;
  targets = {};
  for (key in shortcutMap) {
    target = shortcutMap[key];
    targets[key] = $(shortcutMap[key]);
  }
  return targets;
};

StickyHeader.init = function(arg, done) {
  var config, header, options, pageType, shortcutMap, stickyHeader, watchElements;
  header = arg.header, stickyHeader = arg.stickyHeader;
  shortcutMap = header.shortcutMap, watchElements = header.watchElements, pageType = header.pageType, options = header.options;
  config = {
    stickyWatchElements: watchElements,
    shortcutMap: shortcutMap
  };
  return $(function() {
    var $carouselElem, $headerSticky, $rowElem, $writeUp, carouselBottomPosition, carouselHeight, carouselOffset, targets;
    $headerSticky = $('.header-row-sticky');
    if (pageType === 'local') {
      $carouselElem = $('.gallery, .gallery-single, .featured-image');
      carouselOffset = $carouselElem.offset();
      carouselHeight = $carouselElem.outerHeight();
      carouselBottomPosition = carouselHeight + carouselOffset.top;
      StickyHeader.elements = {
        pageType: pageType,
        top: carouselBottomPosition,
        headerSticky: $headerSticky
      };
      if ($(".multi-option-overlay-items").children().length) {
        $(".header-options a").click(function(e) {
          var $modal;
          e.preventDefault();
          $modal = $("#options");
          return GIG.Modal.open({
            el: $modal
          });
        });
      }
    } else if (pageType === 'goods') {
      $rowElem = $('.header-row');
      $writeUp = $('#deal-info');
      targets = _getTargetsOnce(shortcutMap);
      StickyHeader.elements = {
        pageType: pageType,
        row: $rowElem,
        headerSticky: $headerSticky,
        targets: targets,
        watchElements: watchElements,
        gap: 100,
        shouldShowSticky: stickyHeader,
        shouldShowQuicklinks: options.shouldShowQuicklinks,
        shouldShowGoodsV2Sticky: options.shouldShowGoodsV2Sticky,
        stickyTopV2SlideUpTime: options.stickyTopV2SlideUpTime,
        stickyTopV2SlideDownTime: options.stickyTopV2SlideDownTime
      };
      if ($rowElem.length) {
        _.extend(StickyHeader.elements, {
          rowParent: $rowElem.parent(),
          top: $rowElem.offset().top,
          height: $rowElem.outerHeight()
        });
      }
      if ($writeUp.length) {
        _.extend(StickyHeader.elements, {
          stickyTop: $writeUp.offset().top
        });
      }
    }
    if (options.shouldShowQuicklinks) {
      StickyHeader.quicklinks = $('#shorcuts-container li');
      StickyHeader.quicklinks.on('click', function(ev) {
        return StickyHeader.animateQuicklink($(this), ev);
      });
    }
    if (stickyHeader) {
      $(window).scroll(_.throttle(StickyHeader.scrollAction, 20));
    }
    return done();
  });
};

StickyHeader.updateCssClass = function(clicked) {
  var current;
  current = StickyHeader.quicklinks.filter('.selected');
  if (clicked !== current) {
    current.removeClass('selected');
    return clicked.addClass('selected');
  }
};

StickyHeader.animateQuicklink = function(clicked, ev) {
  var current, gap, ref, row, shouldShowSticky, target, targets, top;
  ref = StickyHeader.elements, row = ref.row, gap = ref.gap, shouldShowSticky = ref.shouldShowSticky, targets = ref.targets;
  current = StickyHeader.quicklinks.filter('.selected');
  if (clicked !== current) {
    target = targets[clicked.attr('id')];
    top = target.offset().top;
    if (shouldShowSticky) {
      top -= row.outerHeight();
      if (!row.hasClass('header-row-sticked')) {
        top -= gap;
      }
    }
    $('body,html').animate({
      scrollTop: top
    }, 500, function() {
      return StickyHeader.updateCssClass(clicked);
    });
    return ev != null ? ev.preventDefault() : void 0;
  }
};

StickyHeader.scrollAction = function() {
  var belowThreshold, gap, headerSticky, height, pageType, position, ref, ref1, ref2, row, rowParent, shouldShowGoodsV2Sticky, shouldShowQuicklinks, stickyTop, stickyTopV2SlideDownTime, stickyTopV2SlideUpTime, target, targetTop, targets, top, watchElements, yPosition;
  ref = StickyHeader.elements, row = ref.row, rowParent = ref.rowParent, headerSticky = ref.headerSticky, targets = ref.targets, watchElements = ref.watchElements, gap = ref.gap, top = ref.top, height = ref.height, stickyTop = ref.stickyTop, shouldShowQuicklinks = ref.shouldShowQuicklinks, shouldShowGoodsV2Sticky = ref.shouldShowGoodsV2Sticky, pageType = ref.pageType, stickyTopV2SlideUpTime = ref.stickyTopV2SlideUpTime, stickyTopV2SlideDownTime = ref.stickyTopV2SlideDownTime;
  yPosition = $(window).scrollTop();
  if (pageType === 'local') {
    belowThreshold = yPosition > top;
    if (belowThreshold && !headerSticky.is(":animated")) {
      return headerSticky.slideDown(280);
    } else if (!belowThreshold && headerSticky.is(":visible") && !headerSticky.is(":animated")) {
      return headerSticky.slideUp(280);
    }
  } else if (pageType === 'goods') {
    if (shouldShowGoodsV2Sticky) {
      belowThreshold = yPosition > stickyTop;
      if (belowThreshold) {
        headerSticky.stop().slideDown(stickyTopV2SlideDownTime);
        if (shouldShowQuicklinks) {
          position = watchElements.length - 1;
          while (position >= 0) {
            target = targets[watchElements[position]];
            targetTop = target != null ? (ref1 = target.offset()) != null ? ref1.top : void 0 : void 0;
            if ((targetTop != null) && (yPosition + gap) >= targetTop) {
              break;
            }
            position--;
          }
          return StickyHeader.updateCssClass(StickyHeader.quicklinks.eq(position));
        }
      } else if (!belowThreshold && headerSticky.is(":visible")) {
        return headerSticky.stop().slideUp(stickyTopV2SlideUpTime);
      }
    } else {
      if (row.hasClass('header-row-static')) {
        top = StickyHeader.elements.top = row.offset().top;
      }
      if (yPosition > top) {
        row.removeClass('header-row-static');
        row.addClass('header-row-sticked');
        rowParent.css({
          paddingTop: height
        });
        if (shouldShowQuicklinks) {
          position = watchElements.length - 1;
          while (position >= 0) {
            target = targets[watchElements[position]];
            targetTop = target != null ? (ref2 = target.offset()) != null ? ref2.top : void 0 : void 0;
            if ((targetTop != null) && (yPosition + gap) >= targetTop) {
              break;
            }
            position--;
          }
          return StickyHeader.updateCssClass(StickyHeader.quicklinks.eq(position));
        }
      } else {
        row.removeClass('header-row-sticked');
        row.addClass('header-row-static');
        return rowParent.css({
          paddingTop: 0
        });
      }
    }
  }
};

module.exports = StickyHeader;



},{"./header":40}],42:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = require('../models/option');

InlineVariations.Collections.Options = Backbone.Collection.extend({
  model: InlineVariations.Models.Option
});

module.exports = InlineVariations.Collections.Options;



},{"../models/option":45}],43:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Trait = require('../models/trait');

InlineVariations.Collections.Traits = Backbone.Collection.extend({
  model: InlineVariations.Models.Trait,
  selectedTraitValues: {},
  initialize: function() {
    return this.on('change:selectedTraitValue', this.changeSelectedTraitValue, this);
  },
  changeSelectedTraitValue: function(model, val) {
    if (val) {
      return this.selectedTraitValues[model.get('name')] = val;
    } else {
      return delete this.selectedTraitValues[model.get('name')];
    }
  },
  someTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length > 0;
  },
  allTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length === this.models.length;
  },
  closeDropdowns: function() {
    var i, len, ref, results, trait;
    ref = this.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.closeDropdown());
    }
    return results;
  }
});

module.exports = InlineVariations.Collections.Traits;



},{"../models/trait":46}],44:[function(require,module,exports){
var InlineVariations, _scrollToBuyButton, _scrollToTouchInlineVariation;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

InlineVariations.Collections.Options = require('./collections/options');

InlineVariations.Collections.Traits = require('./collections/traits');

InlineVariations.Views.Main = require('./views/main');

_scrollToBuyButton = function() {
  if (!$('#purchase-cluster .buy.fixed, .header-row-sticked, .header-row-sticky').length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $('.main').position().top - 100
  }, 500);
};

_scrollToTouchInlineVariation = function() {
  var $inlineVariationContainer;
  $inlineVariationContainer = $('#inline-variations-container');
  if (!$inlineVariationContainer.length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $inlineVariationContainer.position().top
  }, 500);
};

InlineVariations.init = function(arg, done) {
  var buyButton, carouselViews, dealMedia, dealOptionUuid, dealUuid, deliveryEstimates, inlineVariations, isCart, isTouch, mappings, offer, options, preSelectTraits, ref, ref1, stickyHeader, traits;
  buyButton = arg.buyButton, deliveryEstimates = arg.deliveryEstimates, inlineVariations = arg.inlineVariations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (!((inlineVariations != null ? (ref = inlineVariations.options) != null ? ref.length : void 0 : void 0) && ((ref1 = inlineVariations.traits) != null ? ref1.length : void 0))) {
    return done();
  }
  dealOptionUuid = inlineVariations.dealOptionUuid, dealUuid = inlineVariations.dealUuid, isTouch = inlineVariations.isTouch, mappings = inlineVariations.mappings, options = inlineVariations.options, preSelectTraits = inlineVariations.preSelectTraits, traits = inlineVariations.traits;
  if (typeof DealCarousel !== "undefined" && DealCarousel !== null) {
    carouselViews = DealCarousel.carouselViews, dealMedia = DealCarousel.dealMedia;
  }
  isCart = (isTouch && (buyButton != null ? buyButton.cartIcon : void 0)) || (!isTouch && (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0));
  options = new InlineVariations.Collections.Options(options);
  traits = new InlineVariations.Collections.Traits(traits, {
    isTouch: isTouch
  });
  if (isTouch) {
    TouchBuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (_this.main.variationsSelected()) {
          return;
        }
        _this.main.showErrorMessages();
        _scrollToTouchInlineVariation();
        return {
          stopTheBus: true
        };
      };
    })(this))(-300);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (BuyButton.view.variationsSelected) {
          return;
        }
        _this.main.showErrorMessages();
        if (stickyHeader) {
          _scrollToBuyButton();
        }
        BuyButton.view.enableBuyButton();
        return {
          stopTheBus: true
        };
      };
    })(this));
  }
  return $((function(_this) {
    return function() {
      var ref2;
      _this.main = new InlineVariations.Views.Main({
        carouselViews: carouselViews,
        dealMedia: dealMedia,
        dealOptionUuid: dealOptionUuid,
        dealUuid: dealUuid,
        deliveryEstimates: deliveryEstimates,
        isCart: isCart,
        isTouch: isTouch,
        mappings: mappings,
        offer: offer,
        options: options,
        preSelectTraits: preSelectTraits,
        traits: traits,
        _scrollToTouchInlineVariation: _scrollToTouchInlineVariation
      });
      traits.view = _this.main;
      if (options != null ? (ref2 = options[0]) != null ? ref2.hideOriginalPriceAndDiscount : void 0 : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html('');
      }
      $(document.body).on('carouselUpdate', function(e, arg1) {
        var image;
        image = arg1.image;
        return _this.main.updateInlineVariationSelections(image);
      });
      return done();
    };
  })(this));
};

module.exports = InlineVariations;



},{"./collections/options":42,"./collections/traits":43,"./views/main":47}],45:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = Backbone.Model.extend({});

module.exports = InlineVariations.Models.Option;



},{}],46:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = require('../views/trait');

InlineVariations.Models.Trait = Backbone.Model.extend({
  initialize: function(arg, arg1) {
    var id, isTouch;
    id = arg.id;
    isTouch = arg1.isTouch;
    return this.view = new InlineVariations.Views.Trait({
      model: this,
      el: "#" + id,
      isTouch: isTouch
    });
  },
  setSelectedTraitValueById: function(id) {
    var selectedTraitValue;
    if (id) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        id: id
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  getTraitValueById: function(id) {
    return _.findWhere(this.get('values'), {
      id: id
    });
  },
  setSelectedTraitValueByName: function(name) {
    var selectedTraitValue;
    if (name) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        name: name
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  updateTraitValue: function(selectedTraitValue) {
    if (selectedTraitValue && !selectedTraitValue.isSoldOut && !selectedTraitValue.isPlaceholder) {
      return this.set({
        selectedTraitValueId: selectedTraitValue.id,
        selectedTraitValue: selectedTraitValue.name,
        selectedTraitValueHtml: selectedTraitValue.html
      });
    } else {
      return this.set({
        selectedTraitValueId: false,
        selectedTraitValue: false,
        selectedTraitValueHtml: false
      });
    }
  }
});

module.exports = InlineVariations.Models.Trait;



},{"../views/trait":48}],47:[function(require,module,exports){
var Cart, DealEventPipe, InlineVariations;

Cart = window.Cart != null ? window.Cart : window.Cart = {};

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Cart.Helpers = require('../../../cart/common/helpers');

InlineVariations.Views.Main = Backbone.View.extend({
  el: '#inline-variations-container',
  body: 'body',
  inlineVariationsTraits: '.inline-variation-trait',
  inlineVariationsDropdowns: '.inline-variation-layout-generic-dropdown',
  touch: {
    main: '.t-main',
    featuredImg: '#featured-image',
    featuredImgSize: 't300x182.jpg',
    buyButton: '#buy',
    priceBuy: '#price-buy, #price-buy-v2',
    values: '#price-buy .value, #price-buy-v2 .value',
    prices: '#price-buy .price, #price-buy-v2 .price, #inline-variations-filters-header .price',
    urgencyPrice: '#price-buy .urgency-pricing-value-unit strong, #price-buy-v2 .urgency-pricing-value-unit strong',
    urgencyOfferLabel: '#price-buy .urgency-pricing-value-unit .urgency-pricing-offer-label, #price-buy-v2 .urgency-pricing-value-unit .urgency-pricing-offer-label',
    deliveryEstimate: '.delivery-estimates-container',
    discount: '#discount-percent span, .discount-percentage',
    savings: '#discount-savings span'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    this.$inlineVariationsDropdowns = this.$el.find(this.inlineVariationsDropdowns);
    this.$inlineVariationsTraits = this.$el.find(this.inlineVariationsTraits);
    this.$body = $(this.body);
    if (this.isTouch) {
      this.$body = $(this.touch.main);
      this.$touchFeaturedImg = $(this.touch.featuredImg);
      this.$touchBuyButton = $(this.touch.buyButton);
      this.$touchPriceBuy = $(this.touch.priceBuy);
      this.$touchPrices = $(this.touch.prices);
      this.$touchValues = $(this.touch.values);
      this.$touchUrgencyPrice = $(this.touch.urgencyPrice);
      this.$touchUrgencyOfferLabel = $(this.touch.urgencyOfferLabel);
      this.$touchDeliveryEstimate = $(this.touch.deliveryEstimate);
      this.$touchDiscount = $(this.touch.discount);
      this.$touchSavings = $(this.touch.savings);
      this.touchOriginalFeaturedImg = this.$touchFeaturedImg.attr('src');
    }
    this.attachBackdropEventListener();
    return this.makeSelectionsViaPreselection();
  },
  attachBackdropEventListener: function() {
    return this.$body.click((function(_this) {
      return function(e) {
        if (!_this.$body.hasClass('inline-variation-backdrop')) {
          return e.stopPropagation();
        }
        if (_this.$body.hasClass('stop-propagation')) {
          _this.$body.removeClass('stop-propagation');
          return e.stopPropagation();
        } else {
          _this.traits.closeDropdowns();
          _this.$body.removeClass('inline-variation-backdrop');
          if (_this.isTouch) {
            return _this._scrollToTouchInlineVariation();
          }
        }
      };
    })(this));
  },
  makeSelectionsViaPreselection: function() {
    var i, len, option, ref, ref1, selections, trait, value;
    if (!((ref = this.preSelectTraits) != null ? ref.length : void 0)) {
      return;
    }
    if (!(option = this.options.findWhere({
      uuid: this.dealOptionUuid
    }))) {
      return;
    }
    selections = {};
    ref1 = this.preSelectTraits;
    for (i = 0, len = ref1.length; i < len; i++) {
      trait = ref1[i];
      if (value = option.get(trait)) {
        selections[trait] = value;
      }
    }
    this.updateSelections(selections);
    return this.render();
  },
  render: function(updateCarouselOrFeaturedImage) {
    if (updateCarouselOrFeaturedImage == null) {
      updateCarouselOrFeaturedImage = true;
    }
    this.updateSoldout();
    this.updatePriceAndBuyButton();
    if (updateCarouselOrFeaturedImage) {
      this.updateCarouselOrFeaturedImage();
    }
    return this.hideErrorMessages();
  },
  updateSoldout: function() {
    var currentValue, filteredSelection, i, len, ref, results, trait, traitValue;
    if (this.traits.models.length < 2) {
      return;
    }
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      filteredSelection = _.omit(this.traits.selectedTraitValues, trait.get('name'));
      results.push((function() {
        var j, len1, ref1, results1;
        ref1 = trait.get('values') || [];
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          traitValue = ref1[j];
          if (traitValue.isPlaceholder) {
            continue;
          }
          currentValue = {};
          currentValue[traitValue.traitName] = traitValue.name;
          results1.push(traitValue.$el.toggleClass('sold-out', this.options.where(_.extend(filteredSelection, currentValue)).length === 0));
        }
        return results1;
      }).call(this));
    }
    return results;
  },
  updatePriceAndBuyButton: function() {
    var cheapestOption, optionInfo, qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    if (!qualifiedOptions.length) {
      return;
    }
    if (!(cheapestOption = _.min(qualifiedOptions, function(option) {
      return option.get('amount');
    }))) {
      return;
    }
    if (cheapestOption === Infinity) {
      return;
    }
    optionInfo = {
      buyUrl: this.buyButtonUrl(cheapestOption),
      hideOriginalPriceAndDiscount: cheapestOption.get('hideOriginalPriceAndDiscount'),
      id: cheapestOption.get('id'),
      lengthClass: cheapestOption.get('lengthClass'),
      percent: cheapestOption.get('discount'),
      price: cheapestOption.get('newPrice'),
      savings: cheapestOption.get('savePrice'),
      uuid: cheapestOption.get('uuid'),
      value: cheapestOption.get('oldPrice'),
      variationsSelected: qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected()
    };
    this.overridePrice(optionInfo, cheapestOption);
    if (this.isTouch) {
      this.updateTouchDealInfo(optionInfo);
      return this.updateTouchBuyButton(optionInfo);
    } else {
      return DealEventPipe.trigger("priceUpdate", optionInfo);
    }
  },
  updateTouchDealInfo: function(arg) {
    var deliveryEstimate, id, percent, price, ref, ref1, ref2, sale, savings, urgencyPricing, uuid, value;
    id = arg.id, percent = arg.percent, price = arg.price, sale = arg.sale, savings = arg.savings, uuid = arg.uuid, value = arg.value;
    this.$touchValues.text(value);
    this.$touchDiscount.html(percent);
    this.$touchSavings.text(savings);
    this.$touchPriceBuy.attr('data-option-id', id);
    if (urgencyPricing = sale != null ? sale.urgencyPricing : void 0) {
      this.$touchPrices.text(urgencyPricing.regularPrice);
      this.$touchUrgencyPrice.show().text(urgencyPricing.newPrice);
      this.$touchPriceBuy.addClass('urgency-pricing-cluster');
      if ((ref = urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0) {
        this.$touchUrgencyOfferLabel.show().text(urgencyPricing.pricingMetadata.offerLabel);
      } else {
        this.$touchUrgencyOfferLabel.hide();
      }
    } else {
      this.$touchPrices.text(price);
      this.$touchPriceBuy.removeClass('urgency-pricing-cluster');
    }
    if (deliveryEstimate = ((ref1 = this.deliveryEstimates) != null ? ref1[uuid] : void 0) || ((ref2 = this.deliveryEstimates) != null ? ref2["default"] : void 0)) {
      return this.$touchDeliveryEstimate.show().text(deliveryEstimate);
    } else {
      return this.$touchDeliveryEstimate.hide();
    }
  },
  updateTouchBuyButton: function(arg) {
    var buyUrl, id, variationsSelected;
    buyUrl = arg.buyUrl, id = arg.id, variationsSelected = arg.variationsSelected;
    if (variationsSelected) {
      this.$touchBuyButton.attr('href', buyUrl);
      if (this.isCart) {
        return this.$touchBuyButton.attr('data-option', id);
      }
    } else {
      this.$touchBuyButton.removeAttr('href');
      if (this.isCart) {
        return this.$touchBuyButton.removeAttr('data-option');
      }
    }
  },
  getQualifiedOptions: function() {
    if (this.traits.someTraitValuesSelected()) {
      return this.options.where(this.traits.selectedTraitValues);
    } else {
      return this.options.models;
    }
  },
  variationsSelected: function() {
    var qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    return qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected();
  },
  buyButtonUrl: function(option) {
    var ref;
    switch (false) {
      case !((ref = option.get('externalUrl')) != null ? ref.length : void 0):
        return option.get('externalUrl');
      case !this.isCart:
        return Cart.Helpers.generateCartUrl(option.get('uuid'), this.dealUuid);
      default:
        return option.get('url');
    }
  },
  overridePrice: function(optionInfo, option) {
    var offer, ref, ref1, ref2, ref3, sale;
    if (!((option.get('regularPrice') != null) || ((ref = this.offer) != null ? (ref1 = ref.offerOptions) != null ? ref1.length : void 0 : void 0))) {
      return;
    }
    sale = {};
    if (option.get('regularPrice')) {
      sale.urgencyPricing = {
        newPrice: option.get('newPrice'),
        pricingMetadata: option.get('pricingMetadata'),
        regularPrice: option.get('regularPrice')
      };
    }
    if (offer = _.findWhere((ref2 = this.offer) != null ? ref2.offerOptions : void 0, {
      id: option.get('uuid')
    })) {
      if (offer.buyUrl && !((ref3 = this.offer.offerModal) != null ? ref3.isSoldOut : void 0)) {
        optionInfo.buyUrl = offer.buyUrl;
      }
      _.extend(sale, {
        offer: offer
      });
    }
    if (sale !== {}) {
      return _.extend(optionInfo, {
        sale: sale
      });
    }
  },
  updateCarouselOrFeaturedImage: function() {
    var currentBaseUrl, image, imageUrl;
    if (this.isTouch) {
      if (imageUrl = this.findFeaturedImageUrl()) {
        return this.$touchFeaturedImg.attr('src', imageUrl);
      }
    } else if (image = this.findCarouselImage()) {
      currentBaseUrl = this.carouselViews[this.dealUuid].currentFeatured.baseURL;
      if (currentBaseUrl !== image.baseURL) {
        return this.carouselViews[this.dealUuid].updateGallery(image);
      }
    }
  },
  findFeaturedImageUrl: function() {
    var image, ref;
    if (!(image = (ref = this.options.findWhere(this.traits.selectedTraitValues)) != null ? ref.get('image') : void 0)) {
      return this.touchOriginalFeaturedImg;
    }
    return "" + image + this.touch.featuredImgSize;
  },
  findCarouselImage: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.dealMedia[this.dealUuid].models[0];
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        this.carouselImage = imageUrl;
        return this.dealMedia[this.dealUuid].findWhere({
          baseURL: imageUrl
        });
      }
    }
  },
  updateInlineVariationSelections: function(image) {
    var key, ref, selections, value;
    if (!image) {
      return;
    }
    if (image === this.carouselImage) {
      return;
    }
    this.carouselImage = image;
    selections = {};
    if (this.mappings[image]) {
      ref = this.mappings[image];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections[key] = value[0];
        }
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateSelections: function(selections) {
    var i, len, ref, results, trait;
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.setSelectedTraitValueByName(selections[trait.get('name')]));
    }
    return results;
  },
  showErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.addClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      if (!trait.get('selectedTraitValue')) {
        results.push(trait.view.$el.addClass('error'));
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  hideErrorMessages: function() {
    this.$el.removeClass('error');
    return this.$inlineVariationsTraits.removeClass('error');
  },
  showBackdrop: function() {
    return this.$body.addClass('inline-variation-backdrop stop-propagation');
  }
});

module.exports = InlineVariations.Views.Main;



},{"../../../cart/common/helpers":7,"../../../deal/frontend/event_pipe":12}],48:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = Backbone.View.extend({
  dropdownSelection: '.inline-variation-dropdown-selection',
  traitValues: '.inline-variation-trait-value',
  inlineTitleHtml: '.inline-variation-trait-title',
  body: 'body',
  touch: {
    main: '.t-main'
  },
  events: {
    'click .inline-variation-dropdown-selection': 'toggleDropdown',
    'click .inline-variation-trait-value': 'traitValueSelection'
  },
  webSwatchEvents: {
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait',
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'
  },
  initialize: function() {
    this.layout = this.model.get('layout');
    this.title = this.model.get('title');
    this.isSwatchImageDropdown = this.layout.isImageSwatch && this.layout.isGenericDropdown;
    this.isTouch = this.options.isTouch;
    this.$body = $(this.body);
    this.$traitValues = this.$el.find(this.traitValues);
    if (this.layout.isGenericDropdown) {
      this.placeholderHtml = this.model.get('title');
      this.placeholderValue = this.model.get('placeholderValue');
      this.placeholderValueId = this.model.get('placeholderValueId');
      this.$titleHtml = this.$el.find(this.dropdownSelection);
    } else {
      this.$titleHtml = this.$el.find(this.inlineTitleHtml);
    }
    if (this.layout.enableFilterSheet) {
      this.$body = $(this.touch.main);
    }
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    if (!(this.isTouch || !this.layout.isSwatch)) {
      _.extend(this.events, this.webSwatchEvents);
    }
    return this.processTraitValues();
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  toggleDropdown: function(e) {
    var isOpen;
    isOpen = this.$el.hasClass('open');
    this.model.collection.closeDropdowns();
    if (!isOpen) {
      this.model.collection.view.showBackdrop();
      this.$el.addClass('open');
      return this.sendDropdownTrackingEvent(isOpen);
    }
  },
  sendDropdownTrackingEvent: function(isOpen) {
    var status;
    status = isOpen ? 'close' : 'open';
    return OptimizeSuite.TrackingHub.add("inline-variations-dropdown-" + status);
  },
  closeDropdown: function() {
    var isOpen;
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    if (!(isOpen = this.$el.hasClass('open'))) {
      return;
    }
    this.sendDropdownTrackingEvent(isOpen);
    return this.$el.removeClass('open');
  },
  traitValueSelection: function(e) {
    var $target, selected;
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return e.stopPropagation();
    }
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    selected = $target.hasClass('selected');
    if (selected && this.layout.isGenericDropdown && !this.layout.isSwatch) {
      return;
    }
    this.$traitValues.removeClass('selected');
    if (selected) {
      this.model.setSelectedTraitValueById();
    } else {
      this.model.setSelectedTraitValueById($target.attr('id'));
    }
    return this.model.collection.view.render();
  },
  updateTitleToHoveredTrait: function(e) {
    var $target, currentTraitValue;
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return;
    }
    if (currentTraitValue = this.model.getTraitValueById($target.attr('id'))) {
      return this.$titleHtml.html(currentTraitValue.html);
    }
  },
  updateTitleToOriginalTrait: function(e) {
    if ($(e.currentTarget).hasClass('sold-out')) {
      return;
    }
    return this.$titleHtml.html(this.model.get('selectedTraitValueHtml') || this.title);
  },
  setTraitValue: function() {
    var selectedTraitValue, selectedTraitValueId;
    if (!this.layout.enableFilterSheet) {
      this.closeDropdown();
    }
    selectedTraitValue = this.model.get('selectedTraitValueHtml');
    selectedTraitValueId = this.model.get('selectedTraitValueId');
    if (this.layout.isGenericDropdown || this.layout.isSwatch) {
      if (!selectedTraitValue) {
        if (this.layout.isSwatch) {
          selectedTraitValue = this.title;
        } else {
          selectedTraitValue = this.placeholderHtml;
          selectedTraitValueId = this.placeholderValueId;
        }
      }
      this.$titleHtml.html(selectedTraitValue);
    }
    return this.$traitValues.each(function() {
      var $traitValue;
      $traitValue = $(this);
      return $traitValue.toggleClass('selected', $traitValue.attr('id') === selectedTraitValueId);
    });
  }
});

module.exports = InlineVariations.Views.Trait;



},{}],49:[function(require,module,exports){
var CountdownTimer, OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

CountdownTimer = window.CountdownTimer != null ? window.CountdownTimer : window.CountdownTimer = {};

CountdownTimer.Helpers = require('../../../groupon-deal-timer/common/helpers');

OffersTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.get('endAt'));
    return {
      timeLeft: CountdownTimer.Helpers.timeRemaining(millisLeft),
      millisLeft: millisLeft
    };
  },
  buyUrlHash: function() {
    var urlHash;
    urlHash = {};
    _.each(this.get('offerOptions'), function(option) {
      return urlHash[option.buyUrl] = option.originalBuyUrl;
    });
    return urlHash;
  }
});

module.exports = OffersTimer.Model;



},{"../../../groupon-deal-timer/common/helpers":36}],50:[function(require,module,exports){
var OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

OffersTimer.Model = require('./models/offers_timer');

OffersTimer.View = require('./views/offers_timer');

OffersTimer.init = function(arg, done) {
  var offer, ref, ref1, timerModel, timerView;
  offer = arg.offer;
  if (done == null) {
    done = function() {};
  }
  if (!(offer != null ? (ref = offer.offerModal) != null ? ref.expiresAt : void 0 : void 0)) {
    return done();
  }
  timerModel = new OffersTimer.Model({
    endAt: offer != null ? (ref1 = offer.offerModal) != null ? ref1.expiresAt : void 0 : void 0,
    offerOptions: offer != null ? offer.offerOptions : void 0
  });
  timerView = new OffersTimer.View({
    model: timerModel,
    i18n: I18n.scoped()
  });
  return $(function() {
    timerView.render();
    return done();
  });
};

module.exports = OffersTimer;



},{"./models/offers_timer":49,"./views/offers_timer":51}],51:[function(require,module,exports){
var CountdownTimer, OFFERS_TIME_EL, OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

CountdownTimer = window.CountdownTimer != null ? window.CountdownTimer : window.CountdownTimer = {};

CountdownTimer.Helpers = require('../../../groupon-deal-timer/common/helpers');

OFFERS_TIME_EL = "#offers-time-left";

OffersTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  isSoldOut: false,
  initialize: function() {
    return this.i18n = this.options.i18n;
  },
  render: function() {
    var ref;
    this.$el = $(OFFERS_TIME_EL);
    if (((ref = this.model.timeLeft()) != null ? ref.millisLeft : void 0) <= 0) {
      return;
    }
    return setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var buyUrlHash, countdownTime, offersTimer, ref, txnKey;
    if (this.isSoldOut) {
      return;
    }
    offersTimer = this.model.timeLeft();
    if ((offersTimer != null ? offersTimer.millisLeft : void 0) <= 0) {
      this.isSoldOut = true;
      this.$el.html(this.t("js.modules.offers.sold_out"));
      this.$el.addClass('sold-out');
      buyUrlHash = this.model.buyUrlHash();
      return _.each($('.btn-buy-big.buy-button, .options-content tr a'), function(element) {
        var originalBuyUrl;
        if (element.href !== (window.location.href + "#")) {
          originalBuyUrl = buyUrlHash[element.href];
          return element.href = originalBuyUrl;
        }
      });
    } else {
      txnKey = CountdownTimer.Helpers.countdownTimeKey(offersTimer != null ? offersTimer.timeLeft : void 0);
      if (!txnKey) {
        return;
      }
      countdownTime = this.t("js.modules.offers" + txnKey, {
        days: offersTimer != null ? (ref = offersTimer.timeLeft) != null ? ref.days : void 0 : void 0,
        timestamp: CountdownTimer.Helpers.countdownTimestamp(offersTimer != null ? offersTimer.timeLeft : void 0)
      });
      return this.$el.html(countdownTime);
    }
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});

module.exports = OffersTimer.View;



},{"../../../groupon-deal-timer/common/helpers":36}],52:[function(require,module,exports){
(function (global){
var averageRatingText, buildHistogram, extend, extractDisplayNames, extractHelpfulUpvote, extractRatingDistribution, extractReviews, extractStats, formatButtonText, formatDate, formatHelpfulText, indexOf, map, object, placement, processReview, processUserReview, ratingToStars, ref, reviewIds, roundAverageRating, starToHtml, trim;

if (typeof window !== "undefined" && window !== null) {
  extend = _.extend, map = _.map, indexOf = _.indexOf, object = _.object;
  trim = $.trim;
}

if (typeof module !== "undefined" && module !== null) {
  ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), extend = ref.extend, map = ref.map, indexOf = ref.indexOf, object = ref.object;
}

averageRatingText = function(averageRating, ratingCount, reviewCount, reviewsSorting, i18n) {
  var readReview;
  readReview = (function() {
    switch (false) {
      case !(reviewCount.value <= 1):
        return '';
      case reviewsSorting !== 'most_recent':
        return i18n.t('.histogram.read_review_message', {
          divider: '<br>',
          formattedRatingCount: reviewCount.formatted
        });
      default:
        return i18n.t('.histogram.read_review_message_no_count');
    }
  })();
  return {
    bhc: "deal-review-rating:" + averageRating.value,
    rating: averageRating.formatted,
    ratingCount: ratingCount.value,
    readReview: readReview,
    text: ratingCount.value > 1 ? i18n.t('.histogram.average_message', {
      formattedRatingCount: ratingCount.formatted
    }) : ''
  };
};

buildHistogram = function(ratingCount, ratingDistribution, i18n) {
  var histogram, i, key, ref1, star, value;
  if (!ratingCount.value) {
    return;
  }
  histogram = [];
  for (star = i = 1; i <= 5; star = ++i) {
    key = "rating" + star + "Count";
    value = ((ref1 = ratingDistribution[key]) != null ? ref1.value : void 0) || 0;
    histogram.unshift({
      bhc: "deal-review-rating-distribution:" + key + "_" + value,
      count: i18n.toNumber(value),
      label: i18n.t('.histogram.star_label', {
        star: star
      }),
      widthPercentage: Math.floor(value * 100 / ratingCount.value)
    });
  }
  return histogram;
};

extractRatingDistribution = function(ratingDistribution, i18n) {
  if (!ratingDistribution) {
    return {};
  }
  return object(map(ratingDistribution, function(value, key) {
    return [
      key, {
        formatted: i18n.toNumber(value),
        value: value
      }
    ];
  }));
};

extractStats = function(productReviews, i18n) {
  var averageRating, ratingCount, ref1, ref2, ref3, ref4, reviewCount;
  if (productReviews == null) {
    productReviews = {};
  }
  ratingCount = ((ref1 = productReviews.product) != null ? ref1.ratingCount : void 0) || 0;
  reviewCount = ((ref2 = productReviews.product) != null ? ref2.reviewCount : void 0) || 0;
  averageRating = ((ref3 = productReviews.product) != null ? ref3.averageRating : void 0) || 0;
  return {
    averageRating: {
      formatted: roundAverageRating(averageRating).toFixed(1),
      value: averageRating
    },
    ratingCount: {
      formatted: i18n.toNumber(ratingCount),
      value: ratingCount
    },
    ratingDistribution: extractRatingDistribution((ref4 = productReviews.product) != null ? ref4.ratingDistribution : void 0, i18n),
    reviewCount: {
      formatted: i18n.toNumber(reviewCount),
      value: reviewCount
    }
  };
};

formatButtonText = function(upvoteCount, userVoted, displayOptions, i18n) {
  if (displayOptions.isTouch) {
    if (displayOptions.votingEnabled) {
      return i18n.p(upvoteCount, 'js.modules.product_reviews.review_card.helpful.touch_message', {
        formattedUpvoteCount: i18n.toNumber(upvoteCount)
      });
    }
  } else {
    if (userVoted) {
      return i18n.t('js.modules.product_reviews.review_card.helpful.undo');
    } else {
      return i18n.t('js.modules.product_reviews.review_card.helpful.yes');
    }
  }
};

formatHelpfulText = function(upvoteCount, displayOptions, i18n) {
  if (displayOptions.votingEnabled || !upvoteCount) {
    return '';
  }
  return i18n.p(upvoteCount, 'js.modules.product_reviews.review_card.helpful.message', {
    formattedUpvoteCount: i18n.toNumber(upvoteCount)
  });
};

formatDate = function(dateString, datetime, i18n) {
  var date;
  date = datetime(dateString);
  if (date != null ? date.isValid() : void 0) {
    return date.format(i18n.t('js.modules.product_reviews.review_card.date_format_string'));
  } else {
    return '';
  }
};

starToHtml = function(starType, position, userInput) {
  if (userInput == null) {
    userInput = false;
  }
  if (userInput) {
    return "<span class='review-star icon-star-filled " + starType + "' id='review-star-" + position + "' data-star-rating='" + position + "' data-bhw='ProductReviewUserRatingStar" + position + "'></span>";
  } else {
    return "<span class='icon-star-filled " + starType + "'></span>";
  }
};

ratingToStars = function(rating, userInput) {
  var bhc, formattedAverageRating, i, position, starType, stars;
  stars = [];
  formattedAverageRating = roundAverageRating(rating);
  bhc = "deal-review-rating:" + formattedAverageRating;
  for (position = i = 1; i <= 5; position = ++i) {
    starType = (function() {
      switch (false) {
        case !(rating > 7 / 8):
          return 'full-star';
        case !(rating > 5 / 8):
          return 'three-fourth-star';
        case !(rating > 3 / 8):
          return 'half-star';
        case !(rating > 1 / 8):
          return 'fourth-star';
        default:
          return 'empty-star';
      }
    })();
    stars.push(starToHtml(starType, position, userInput));
    rating--;
  }
  return {
    stars: stars,
    bhc: bhc
  };
};

roundAverageRating = function(averageRating) {
  if (!averageRating) {
    return 0;
  }
  return Math.round(averageRating * 10) / 10;
};

placement = function(review) {
  if (review.isUserReview) {
    return 'user';
  } else if (review.isHelpfulReview) {
    return 'helpful';
  } else {
    return 'list';
  }
};

reviewIds = function(review) {
  var prefix;
  prefix = review.placement === 'list' ? '' : review.placement + "-";
  return {
    card: prefix + "review-card-" + review.uuid,
    notification: prefix + "review-notification-" + review.uuid,
    rating: prefix + "review-rating-" + review.uuid,
    vote: prefix + "review-vote-" + review.uuid,
    voteText: prefix + "review-vote-text-" + review.uuid
  };
};

extractHelpfulUpvote = function(review, displayOptions, i18n) {
  var userVoted;
  if (review.byCurrentUser) {
    return;
  }
  if (userVoted = indexOf((displayOptions != null ? displayOptions.userUpvotedReviews : void 0) || [], review.uuid) > -1) {
    review.upvoteCount++;
  }
  return {
    buttonClass: userVoted ? 'upvoted' : void 0,
    buttonText: formatButtonText(review.upvoteCount, userVoted, displayOptions, i18n),
    text: formatHelpfulText(review.upvoteCount, displayOptions, i18n),
    userVoted: userVoted
  };
};

extractDisplayNames = function(review, i18n) {
  var displayName, username;
  displayName = review.displayName;
  if (displayName != null ? displayName.length : void 0) {
    if (review.byCurrentUser) {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.current_user', {
        displayName: displayName
      });
    } else {
      username = displayName;
    }
  } else {
    displayName = i18n.t('js.modules.product_reviews.review_card.display_name.anonymous_user');
    if (review.byCurrentUser) {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.current_user_missing_name');
    } else {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.anonymous_user');
    }
  }
  return {
    username: username,
    displayName: displayName
  };
};

processReview = function(review, displayOptions, i18n, datetime) {
  var displayName, ref1, username;
  review.byCurrentUser = indexOf((displayOptions != null ? displayOptions.userReviewIds : void 0) || [], review.uuid) > -1;
  review.placement = placement(review);
  ref1 = extractDisplayNames(review, i18n), username = ref1.username, displayName = ref1.displayName;
  return extend(review, {
    date: formatDate(review.submittedAt, datetime, i18n),
    helpfulUpvote: extractHelpfulUpvote(review, displayOptions, i18n),
    ratingStars: ratingToStars(review.rating),
    reviewIds: reviewIds(review),
    username: username,
    displayName: displayName
  });
};

extractReviews = function(productReviews, displayOptions, i18n, datetime) {
  var ref1;
  if (displayOptions == null) {
    displayOptions = {};
  }
  if (!(productReviews != null ? (ref1 = productReviews.reviews) != null ? ref1.length : void 0 : void 0)) {
    return;
  }
  return map(productReviews.reviews, function(review) {
    return processReview(review, displayOptions, i18n, datetime);
  });
};

processUserReview = function(userReview, displayOptions, i18n, datetime) {
  var isRatingOnly, userReviewText;
  userReviewText = userReview.text || '';
  userReviewText = trim ? trim(userReviewText) : userReviewText.trim();
  isRatingOnly = !userReviewText.length;
  extend(userReview, {
    isPending: userReview.status === 'PENDING',
    isRatingOnly: isRatingOnly,
    isRejected: userReview.status === 'REJECTED',
    isUserReview: true,
    text: isRatingOnly ? i18n.t('js.modules.product_reviews.review_card.rating_only_review') : userReview.text
  });
  return processReview(userReview, displayOptions, i18n, datetime);
};

if (typeof window !== "undefined" && window !== null) {
  if (window.ProductReviews == null) {
    window.ProductReviews = {};
  }
  if (ProductReviews.Helpers == null) {
    ProductReviews.Helpers = {};
  }
  ProductReviews.Helpers.averageRatingText = averageRatingText;
  ProductReviews.Helpers.buildHistogram = buildHistogram;
  ProductReviews.Helpers.extractStats = extractStats;
  ProductReviews.Helpers.extractReviews = extractReviews;
  ProductReviews.Helpers.formatButtonText = formatButtonText;
  ProductReviews.Helpers.formatHelpfulText = formatHelpfulText;
  ProductReviews.Helpers.processUserReview = processUserReview;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    averageRatingText: averageRatingText,
    buildHistogram: buildHistogram,
    extractStats: extractStats,
    formatButtonText: formatButtonText,
    formatHelpfulText: formatHelpfulText,
    formatDate: formatDate,
    starToHtml: starToHtml,
    ratingToStars: ratingToStars,
    roundAverageRating: roundAverageRating,
    placement: placement,
    reviewIds: reviewIds,
    extractHelpfulUpvote: extractHelpfulUpvote,
    extractDisplayNames: extractDisplayNames,
    processReview: processReview,
    extractReviews: extractReviews,
    processUserReview: processUserReview
  };
}


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],53:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

window.moment = require('../../../../node_modules/moment/moment.js');

ProductReviews.Views.ReviewList = require('../views/product_reviews_review_list');

ProductReviews.Model = require('../models/product_review');

ProductReviews.Helpers = require('../../common/helpers');

ProductReviews.Collection = Backbone.Collection.extend({
  model: ProductReviews.Model,
  initialize: function(models, options1) {
    this.options = options1;
    this.page = 1;
    this.locale = 'en_US';
    this.showParams = '';
    this.sortBy = 'most_recent';
    _.extend(this, this.options);
    return _.bindAll(this, 'paginationSuccess', 'paginationError');
  },
  _prepareModel: function(model, options) {
    _.extend(options, this.options);
    delete options.parse;
    return Backbone.Collection.prototype._prepareModel.call(this, model, options);
  },
  url: function() {
    return this.rootUrl + "/product_review_proxy/reviews.json?deal_uuid=" + this.dealUuid + "&locale=" + this.locale + "&sort=" + this.sortBy + "&limit=" + (this.limit()) + "&offset=" + (this.offset()) + "&show=" + this.showParams;
  },
  sync: function(method, collection, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout;
    return Backbone.Collection.prototype.sync.call(this, method, collection, options);
  },
  limit: function() {
    return this.pageSize;
  },
  offset: function() {
    return (this.page - 1) * this.pageSize;
  },
  parse: function(response) {
    var user;
    if (!response.reviewable) {
      return;
    }
    if (this.displayOptions.isTouch && (user = response.user)) {
      this.displayOptions.userUpvotedReviews = user.upvotes || [];
    }
    return ProductReviews.Helpers.extractReviews(response, this.displayOptions, I18n, moment);
  },
  nextPage: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page++;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'nextPage';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      remove: false
    });
  },
  resortReviews: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page = 1;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'resortReviews';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      reset: true
    });
  },
  paginationSuccess: function(response) {
    return this.view.render(new ProductReviews.Views.ReviewList({
      collection: this
    }));
  },
  paginationError: function(response) {
    this.page = this.previousPage;
    this.sortBy = this.previousSortBy;
    return this.view.showPaginationError(this.action);
  },
  recordUpvote: function(id) {
    return this.displayOptions.userUpvotedReviews.push(id);
  },
  recordUnvote: function(id) {
    return this.displayOptions.userUpvotedReviews = _.without(this.displayOptions.userUpvotedReviews, id);
  },
  fetchedReviews: function() {
    return this.models.slice(this.offset());
  }
});

module.exports = ProductReviews.Collection;



},{"../../../../node_modules/moment/moment.js":98,"../../common/helpers":52,"../models/product_review":54,"../views/product_reviews_review_list":60}],54:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

window.moment = require('../../../../node_modules/moment/moment.js');

ProductReviews.Helpers = require('../../common/helpers');

ProductReviews.Views.UserReview = require('../views/product_reviews_user_review');

ProductReviews.Model = Backbone.Model.extend({
  idAttribute: 'uuid',
  defaults: {
    rating: 0
  },
  initialize: function(attrs, options) {
    this.set('locale', I18n.locale);
    _.extend(this, options);
    return _.bindAll(this, 'reviewSuccess', 'reviewError', 'upvoteSuccess', 'upvoteError', 'unvoteSuccess', 'unvoteError', 'deleteSuccess', 'deleteError');
  },
  url: function(action) {
    if (action == null) {
      action = '';
    }
    return this.rootUrl + "/product_review_proxy/reviews" + action + "?_csrf=" + this.csrf;
  },
  sync: function(method, model, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout;
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  },
  review: function() {
    var data;
    data = {
      deal_uuid: this.dealUuid,
      locale: this.get('locale'),
      rating: this.get('rating'),
      text: $.trim(this.get('text'))
    };
    return this.save(data, {
      type: 'POST',
      wait: true,
      success: this.reviewSuccess,
      error: this.reviewError,
      url: this.url()
    });
  },
  reviewSuccess: function(model, response) {
    if (response.error != null) {
      return this.reviewError(model, response);
    }
    this.displayOptions.userReviewIds.push(response.review.uuid);
    this.set(ProductReviews.Helpers.processUserReview(response.review, this.displayOptions, I18n, moment));
    return this.view.showReviewSuccess(new ProductReviews.Views.UserReview({
      model: this
    }));
  },
  reviewError: function(model, response) {
    return this.view.showReviewError();
  },
  upvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.upvoteSuccess,
      error: this.upvoteError,
      url: this.url("/" + this.id + "/upvote")
    });
  },
  upvoteSuccess: function(model, response) {
    var upvoteCount;
    upvoteCount = this.get('upvoteCount') + 1;
    this.set({
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonClass: 'upvoted',
        buttonText: ProductReviews.Helpers.formatButtonText(upvoteCount, true, this.displayOptions, I18n),
        text: ProductReviews.Helpers.formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      }
    });
    this.collection.recordUpvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  upvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.upvoteSuccess(model, response);
    }
    this.set({
      helpfulUpvote: {
        buttonClass: ''
      }
    });
    return this.view.showVoteError(this);
  },
  isDuplicateError: function(response) {
    return (response.readyState === 4) && (response.status === 409);
  },
  unvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.unvoteSuccess,
      error: this.unvoteError,
      url: this.url("/" + this.id + "/unvote")
    });
  },
  unvoteSuccess: function(model, response) {
    var upvoteCount;
    upvoteCount = this.get('upvoteCount') > 0 ? this.get('upvoteCount') - 1 : 0;
    this.set({
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonClass: '',
        buttonText: ProductReviews.Helpers.formatButtonText(upvoteCount, false, this.displayOptions, I18n),
        text: ProductReviews.Helpers.formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      }
    });
    this.collection.recordUnvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  unvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.unvoteSuccess(model, response);
    }
    this.set({
      helpfulUpvote: {
        buttonClass: 'upvoted'
      }
    });
    return this.view.showVoteError(this);
  },
  "delete": function() {
    return this.destroy({
      wait: true,
      success: this.deleteSuccess,
      error: this.deleteError,
      url: this.url("/" + this.id)
    });
  },
  deleteSuccess: function(response) {
    return this.view.showDeleteSuccess(this);
  },
  deleteError: function(response) {
    return this.view.showDeleteError(this);
  }
});

module.exports = ProductReviews.Model;



},{"../../../../node_modules/moment/moment.js":98,"../../common/helpers":52,"../views/product_reviews_user_review":62}],55:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Collection = require('./collections/product_reviews');

ProductReviews.Views.Main = require('./views/product_reviews');

ProductReviews.Model = require('./models/product_review');

ProductReviews.init = function(arg, done) {
  var collection, csrf, dealTitle, dealUrl, dealUuid, displayOptions, helpfulCollection, maximumReviewLength, minimumReviewLength, model, pageSize, productReviews, ref, reviewCount, reviewable, rootUrl;
  csrf = arg.csrf, rootUrl = arg.rootUrl, productReviews = arg.productReviews;
  if (!productReviews.dealUuid) {
    return done();
  }
  reviewable = productReviews.reviewable, dealUuid = productReviews.dealUuid, dealUrl = productReviews.dealUrl, dealTitle = productReviews.dealTitle, pageSize = productReviews.pageSize, reviewCount = productReviews.reviewCount, minimumReviewLength = productReviews.minimumReviewLength, maximumReviewLength = productReviews.maximumReviewLength, displayOptions = productReviews.displayOptions;
  ProductReviews.timeout = 3000;
  collection = new ProductReviews.Collection(productReviews.reviews, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions,
    pageSize: pageSize
  });
  helpfulCollection = new ProductReviews.Collection((ref = productReviews.helpful) != null ? ref.reviews : void 0, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions
  });
  model = new ProductReviews.Model(productReviews.userReview, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions
  });
  return $((function(_this) {
    return function() {
      var main;
      main = new ProductReviews.Views.Main({
        reviewable: reviewable,
        dealUrl: dealUrl,
        dealTitle: dealTitle,
        collection: collection,
        helpfulCollection: helpfulCollection,
        model: model,
        reviewCount: reviewCount,
        minimumReviewLength: minimumReviewLength,
        maximumReviewLength: maximumReviewLength
      });
      collection.view = main;
      helpfulCollection.view = main;
      model.view = main;
      $('.product-reviews-anchor').click(function(e) {
        e.preventDefault();
        return $('html,body').animate({
          scrollTop: $('#product-reviews').offset().top
        }, 'slow');
      });
      return done();
    };
  })(this));
};

module.exports = ProductReviews;



},{"./collections/product_reviews":53,"./models/product_review":54,"./views/product_reviews":56}],56:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Views.AddReview = require('./product_reviews_add_review');

ProductReviews.Views.Histogram = require('./product_reviews_histogram');

ProductReviews.Views.ReviewList = require('./product_reviews_review_list');

ProductReviews.Views.UserReview = require('./product_reviews_user_review');

ProductReviews.Model = require('../models/product_review');

ProductReviews.Views.Main = Backbone.View.extend({
  el: '#product-reviews',
  body: 'body',
  touch: {
    main: '.t-main',
    productRatings: '#product-ratings',
    productReviewsPane: '#product-reviews-pane',
    addReviewPane: '#product-reviews-add-pane',
    addReviewButton: '#product-reviews-add-review'
  },
  events: {
    'mouseover #user-rating.allow-submission .review-star': 'hoverStar',
    'click #user-rating.allow-submission .review-star': 'clickStar',
    'mouseout #user-rating': 'clearHoverStar',
    'keyup #product-reviews-form-extension textarea': 'updateMinimumLengthNotification',
    'click #product-reviews-form-extension button': 'submitReview',
    'click #product-reviews-form-extension a': 'resetForm',
    'click .review-vote button.allow-submission': 'voteReview',
    'click #review-delete.allow-submission': 'deleteReview',
    'click .review-share': 'showShareTooltip',
    'click #product-reviews-pagination-button': 'showMoreReviews',
    'change #product-reviews-sort-filter select': 'resortReviews',
    'click .t-back-link': 'hideTouchReviewsPane',
    'click #product-reviews-add-review': 'addNewReview'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    if (this.isTouch) {
      return this.initializeTouchReviewsPane();
    }
    this.listenTo(this.model, 'change:rating', this.updateStars);
    this.$el.find('textarea[placeholder]').PlaceholderField();
    this.initializeTooltip();
    this.$userRating = this.$el.find('#user-rating');
    this.$userStars = this.$el.find('#user-rating .review-star');
    this.$userReviewNotification = this.$el.find('#user-review-notification');
    this.$reviewFormExtension = this.$el.find('#product-reviews-form-extension');
    this.$reviewLengthNotification = this.$el.find('#product-reviews-review-length-notification');
    this.$reviewText = this.$el.find('#product-reviews-form-extension textarea');
    this.$reviewSubmit = this.$el.find('#product-reviews-form-extension button');
    this.$reviewCancel = this.$el.find('#product-reviews-form-extension a');
    this.$sortNotification = this.$el.find('#product-reviews-sort-notification');
    this.$paginationNotification = this.$el.find('#product-reviews-pagination-notification');
    this.$paginationLoader = this.$el.find('#product-reviews-pagination-loader');
    this.$paginationButton = this.$el.find('#product-reviews-pagination');
    this.$reviewFilter = this.$el.find('#product-reviews-sort-filter select');
    this.$reviewList = this.$el.find('#product-reviews-list');
    this.$loginRequiredTooltip = $('#product-reviews-login-required-tooltip');
    this.$shareTooltip = $('#product-reviews-share-tooltip');
    this.countdownOpen = '<span id="review-character-countdown">';
    return this.countdownClose = '</span>';
  },
  initializeTooltip: function() {
    this.$quickViewTooltipTrigger = $('#product-reviews-quick-view.tooltip-trigger');
    this.$formRatingTooltipTrigger = $('#product-reviews-form-rating.tooltip-trigger');
    this.$quickViewTooltip = $('#product-reviews-quick-view-tooltip');
    this.$quickViewTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-quick-view');
      };
    })(this));
    return this.$formRatingTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-form-rating');
      };
    })(this));
  },
  initializeTouchReviewsPane: function() {
    this.$body = $(this.body);
    this.$el = $(this.touch.productReviewsPane);
    this.$mainTouchPane = $(this.touch.main);
    this.$productRatings = $(this.touch.productRatings);
    this.$addReviewButton = $(this.touch.addReviewButton);
    (new ProductReviews.Views.Histogram({
      product: this.product
    })).render();
    (new ProductReviews.Views.ReviewList({
      collection: this.collection
    })).render();
    if (this.userReview) {
      this.$addReviewButton.hide();
      this.renderUserReview();
    } else {
      this.renderAddReviewPane();
    }
    if (this.displayOptions.paginationEnabled) {
      this.listenTo(this.collection, 'sync', this.paginationListener);
    }
    this.$mainTouchPane.hide();
    this.$el.show();
    return this.$body.animate({
      scrollTop: 0
    }, 'slow');
  },
  render: function(reviewList) {
    this.resetNotifications();
    reviewList.render();
    this.reloadBindings();
    this.updatePagination();
    if (!this.isTouch) {
      this.$paginationLoader.hide();
      return this.$reviewList.show();
    }
  },
  renderUserReview: function() {
    this.userReviewModel = new ProductReviews.Model(this.userReview, this.collection.options);
    this.userReviewModel.view = this;
    return (new ProductReviews.Views.UserReview({
      model: this.userReviewModel
    })).render();
  },
  renderAddReviewPane: function() {
    var addReviewModel, addReviewView;
    if (!this.displayOptions.addReviewEnabled) {
      return;
    }
    this.$addReviewPane = $(this.touch.addReviewPane);
    addReviewModel = new ProductReviews.Model(this.collection.options, this.collection.options);
    addReviewView = new ProductReviews.Views.AddReview({
      addReviewModel: addReviewModel,
      productReviewsView: this
    });
    return addReviewModel.view = addReviewView;
  },
  addNewReview: function() {
    if (this.isTouch && !this.reviewable) {
      return this.httpsRedirect();
    }
    if (this.$addReviewButton.hasClass('review-submitted')) {
      return;
    }
    this.$el.hide();
    return this.$addReviewPane.show();
  },
  paginationListener: function() {
    return Touch.Scrolling.detectBottom((function(_this) {
      return function() {
        return _this.showMoreReviews();
      };
    })(this));
  },
  resetNotifications: function() {
    return this.$el.find(".review-notification").hide();
  },
  httpsRedirect: function(element) {
    var redirectUrl, ref;
    if (this.isTouch) {
      redirectUrl = (ref = this.displayOptions.loginRequired) != null ? ref.redirectUrl : void 0;
      if (redirectUrl) {
        return window.location.href = redirectUrl;
      }
    } else {
      return window.location.assign("" + this.dealUrl + element);
    }
  },
  hideTooltips: function() {
    this.$loginRequiredTooltip.find('.tooltip-close').click();
    return this.$shareTooltip.find('.tooltip-close').click();
  },
  showShareTooltip: function(e) {
    var $reviewCard, emailBody, emailSubject, hrefText, text, username;
    $reviewCard = $(e.currentTarget).closest(".review-card");
    if ($reviewCard.length) {
      username = $reviewCard.find('.review-display-name').data('display-name');
      text = $reviewCard.find('.review-text').text();
      emailSubject = encodeURIComponent(I18n.t('js.modules.product_reviews.share_review.email_subject', {
        dealTitle: this.dealTitle,
        username: username
      }));
      emailBody = encodeURIComponent(this.dealTitle + "\n" + this.dealUrl + "\n\n\"" + text + "\"\n- " + username);
      hrefText = "mailto:?subject=" + emailSubject + "&body=" + emailBody + "&utm_campaign=UserReferral&utm_medium=email&utm_source=uu";
      return this.$shareTooltip.find('.icon-email').attr('href', hrefText);
    }
  },
  updateMinimumLengthNotification: function() {
    var remainder, reviewLength, text;
    reviewLength = this.$reviewText.val().length;
    remainder = this.minimumReviewLength - reviewLength;
    if (remainder <= 0) {
      this.$reviewLengthNotification.removeClass('warning').addClass('success');
      remainder = 0;
    } else {
      this.$reviewLengthNotification.removeClass('success').addClass('warning');
    }
    if (this.maximumReviewLength - reviewLength < 0) {
      text = this.$reviewText.val().substring(0, this.maximumReviewLength);
      this.$reviewText.val(text);
    }
    return this.$reviewLengthNotification.html(I18n.p(remainder, 'js.modules.product_reviews.review_form.review_length', {
      minimumLength: this.minimumReviewLength,
      countdownOpen: this.countdownOpen,
      countdownClose: this.countdownClose
    }));
  },
  showMoreReviews: function() {
    this.resetNotifications();
    if (this.isTouch) {
      return this.collection.nextPage();
    } else {
      this.hideTooltips();
      this.$paginationLoader.show();
      return this.collection.nextPage(this.$reviewFilter.val());
    }
  },
  resortReviews: function() {
    this.resetNotifications();
    this.hideTooltips();
    this.$reviewList.hide();
    this.$paginationLoader.show();
    return this.collection.resortReviews(this.$reviewFilter.val());
  },
  updatePagination: function() {
    var displayedReviewCount, reviewsLength;
    reviewsLength = this.collection.length;
    displayedReviewCount = {
      formatted: I18n.toNumber(reviewsLength),
      value: reviewsLength
    };
    if (this.isTouch) {
      if (displayedReviewCount.value >= this.totalReviewCount) {
        return this.stopListening(this.collection, 'sync', this.paginationListener);
      }
    } else {
      this.$el.find('#product-reviews-display-count span').text(I18n.t('js.modules.product_reviews.pagination.showing_count', {
        formattedDisplayedReviewCount: displayedReviewCount.formatted,
        formattedReviewCount: this.reviewCount.formatted
      }));
      if (displayedReviewCount.value < this.reviewCount.value) {
        return this.$paginationButton.show();
      } else {
        return this.$paginationButton.hide();
      }
    }
  },
  reloadBindings: function() {
    if ($('#product-reviews-login-required-tooltip').length || $('#product-reviews-pending-tooltip').length || $('#product-reviews-share-tooltip').length) {
      GIG.Tooltip.reloadBindings(this.$el);
    }
    if ($('#login-modal').length) {
      return IframeLogin.reloadBindings(this.$el);
    }
  },
  findReview: function(placement, id) {
    if (placement === 'helpful') {
      return this.helpfulCollection.get(id);
    } else {
      return this.collection.get(id);
    }
  },
  showPaginationError: function(action) {
    if (this.isTouch) {
      return this.stopListening(this.collection, 'sync', this.paginationListener);
    }
    this.$paginationLoader.hide();
    this.$reviewList.show();
    this.$reviewFilter.val(this.collection.sortBy);
    if (action === 'nextPage') {
      return this.$paginationNotification.show();
    } else {
      return this.$sortNotification.show();
    }
  },
  updateRatingDescriptionText: function(star) {
    if (!this.$ratingDescription) {
      $('#product-reviews-product-info').append($("<span id='rating-description'/>"));
      this.$ratingDescription = this.$el.find('#rating-description');
    }
    return this.$ratingDescription.text(star ? "\"" + (I18n.t("js.modules.product_reviews.review_form.rating_description.rating_" + star)) + "\"" : '');
  },
  hoverStar: function(e) {
    var i, rating, star, x;
    this.$userStars.removeClass('selected-star');
    rating = $(e.currentTarget).data('star-rating');
    for (x = i = 1; i <= 5; x = ++i) {
      star = $("#review-star-" + x);
      if (x <= rating) {
        star.addClass('hovered-star');
      } else {
        star.removeClass('hovered-star').addClass('empty-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  clearHoverStar: function() {
    var i, rating, star, x;
    this.$userStars.removeClass('hovered-star');
    rating = this.model.get('rating');
    for (x = i = 1; i <= 5; x = ++i) {
      star = $("#review-star-" + x);
      if (x <= rating) {
        star.addClass('selected-star');
      } else {
        star.addClass('empty-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  clickStar: function(e) {
    if (!this.reviewable) {
      return this.httpsRedirect('#product-reviews');
    }
    this.model.set('rating', $(e.currentTarget).data('star-rating'));
    return this.$reviewFormExtension.slideDown('slow');
  },
  updateStars: function() {
    var i, rating, star, x;
    rating = this.model.get('rating');
    for (x = i = 1; i <= 5; x = ++i) {
      star = $("#review-star-" + x);
      if (x <= rating) {
        star.removeClass('empty-star').addClass('selected-star');
      } else {
        star.addClass('empty-star').removeClass('selected-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  submitReview: function() {
    this.resetNotifications();
    this.model.set('text', $('#product-reviews-form-extension textarea').val());
    this.$reviewSubmit.attr('disabled', 'disabled').addClass('btn-secondary');
    this.$reviewCancel.hide();
    return this.model.review();
  },
  showReviewSuccess: function(userReview) {
    this.resetForm();
    userReview.render();
    this.$reviewSubmit.hide();
    this.$ratingDescription.hide();
    this.$userReviewNotification.removeClass('error').addClass('success').text(I18n.t('js.modules.product_reviews.create_review.success')).show();
    this.reloadBindings();
    return this.disableStarButton();
  },
  showReviewError: function() {
    this.$userReviewNotification.removeClass('success').addClass('error').text(I18n.t('js.modules.product_reviews.create_review.error')).show();
    this.enableSubmit();
    return this.$reviewCancel.show();
  },
  enableSubmit: function() {
    return this.$reviewSubmit.removeAttr('disabled').removeClass('btn-secondary').html('Submit');
  },
  disableStarButton: function() {
    this.$userRating.removeClass('allow-submission').hide();
    return this.$userStars.removeClass('hovered-star');
  },
  resetForm: function() {
    this.model.set('rating', 0);
    this.$reviewFormExtension.slideUp('slow');
    this.enableSubmit();
    return this.$reviewCancel.show();
  },
  voteReview: function(e) {
    var $target, anchor, review;
    if (this.isTouch && !this.reviewable) {
      return this.httpsRedirect();
    }
    $target = $(e.currentTarget);
    if (!this.reviewable) {
      anchor = $target.data('review-placement') === 'helpful' ? '#product-reviews-helpful-reviews' : '#product-reviews-list';
      return this.httpsRedirect(anchor);
    }
    review = this.findReview($target.data('review-placement'), $target.data('review-id'));
    $target.attr('disabled', 'disabled');
    this.resetNotifications();
    review.view = this;
    if ($target.hasClass('upvoted')) {
      return review.unvote();
    } else {
      return review.upvote();
    }
  },
  showVoteSuccess: function(model) {
    var helpfulUpvote, reviewIds, successMessage, voteButton;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    voteButton = $("#" + reviewIds.vote);
    if (helpfulUpvote.buttonClass === 'upvoted') {
      voteButton.addClass('upvoted');
      successMessage = I18n.t('js.modules.product_reviews.upvote_review.success');
    } else {
      voteButton.removeClass('upvoted');
      successMessage = I18n.t('js.modules.product_reviews.unvote_review.success');
    }
    voteButton.text(helpfulUpvote.buttonText).removeAttr('disabled');
    this.$el.find("#" + reviewIds.voteText).text(helpfulUpvote.text);
    return this.$el.find("#" + reviewIds.notification).removeClass('error').addClass('success').text(successMessage).show();
  },
  showVoteError: function(model) {
    var errorMessage, helpfulUpvote, reviewIds;
    reviewIds = model.get('reviewIds');
    $("#" + reviewIds.vote).removeAttr('disabled');
    helpfulUpvote = model.get('helpfulUpvote');
    if (helpfulUpvote.buttonClass === 'upvoted') {
      errorMessage = I18n.t('js.modules.product_reviews.unvote_review.error');
    } else {
      errorMessage = I18n.t('js.modules.product_reviews.upvote_review.error');
    }
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(errorMessage).show();
  },
  deleteReview: function(e) {
    if (this.isTouch) {
      this.$addReviewButton.hide();
      return this.userReviewModel["delete"]();
    }
    if (!this.reviewable) {
      return this.httpsRedirect('#product-reviews');
    }
    this.resetNotifications();
    $("#user-review-notification-" + this.model.id).hide();
    return this.model["delete"]();
  },
  showDeleteSuccess: function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    this.$el.find('#review-delete').hide();
    return this.$el.find("#" + reviewIds.notification).removeClass('error').addClass('success').text(I18n.t('js.modules.product_reviews.delete_review.success')).show();
  },
  showDeleteError: function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    this.$el.find('#review-delete').hide();
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(I18n.t('js.modules.product_reviews.delete_review.error')).show();
  },
  hideTouchReviewsPane: function() {
    this.$el.hide();
    this.$mainTouchPane.show();
    return this.$body.animate({
      scrollTop: this.$productRatings.position().top
    }, 'slow');
  }
});

module.exports = ProductReviews.Views.Main;



},{"../models/product_review":54,"./product_reviews_add_review":57,"./product_reviews_histogram":58,"./product_reviews_review_list":60,"./product_reviews_user_review":62}],57:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Views.AddReview = Backbone.View.extend({
  el: '#product-reviews-add-pane',
  touch: {
    productReviewsPane: '#product-reviews-pane',
    dealData: '.deal-data',
    starRating: '#add-review-rating',
    ratingHint: '#rating-hint',
    addReviewText: '#add-review-text',
    addUserReviewButton: '#product-reviews-add-review',
    addReviewNotification: '#add-review-notification',
    submitReviewButton: '#submit-review'
  },
  events: {
    'click .t-back-link': 'hideAddReviewPane',
    'click #add-review-rating ul li': 'addUserRating',
    'click #submit-review': 'submitUserReview'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    this.$productReviewsPane = $(this.touch.productReviewsPane);
    this.$dealData = $(this.touch.dealData);
    this.$starRating = $(this.touch.starRating);
    this.$ratingHint = $(this.touch.ratingHint);
    this.$addReviewText = $(this.touch.addReviewText);
    this.$addUserReviewButton = $(this.touch.addUserReviewButton);
    this.$addReviewNotification = $(this.touch.addReviewNotification);
    return this.$submitReviewButton = $(this.touch.submitReviewButton);
  },
  addUserRating: function(e) {
    var i, rating, star, x;
    this.$selectedRating = $(e.currentTarget).children();
    rating = this.$selectedRating.data('star-rating');
    for (x = i = 1; i <= 5; x = ++i) {
      star = $("#review-star-" + x);
      if (x <= rating) {
        star.removeClass('empty-star').addClass('selected-star');
      } else {
        star.addClass('empty-star').removeClass('selected-star');
      }
    }
    this.$ratingHint.text("" + (I18n.t("js.modules.product_reviews.review_form.rating_description.rating_" + rating)));
    return this.showReviewText();
  },
  showReviewText: function() {
    this.$starRating.addClass('move-up');
    this.$ratingHint.addClass('move-up');
    this.$addReviewNotification.addClass('move-up');
    this.$addReviewText.addClass('fadein move-up');
    return this.$dealData.addClass('fadeout');
  },
  hideAddReviewPane: function() {
    this.$el.hide();
    return this.$productReviewsPane.show();
  },
  submitUserReview: function() {
    if (!this.$selectedRating) {
      return;
    }
    this.addReviewModel.set('rating', this.$selectedRating.data('star-rating'));
    this.addReviewModel.set('text', this.$addReviewText.children('textarea').val());
    this.$submitReviewButton.prop('disabled', true);
    return this.addReviewModel.review();
  },
  showReviewSuccess: function(userReview) {
    userReview.render();
    this.$addUserReviewButton.addClass('review-submitted success');
    this.$addUserReviewButton.text(I18n.t('js.modules.product_reviews.create_review.success'));
    userReview.model.view = this.productReviewsView;
    this.productReviewsView.userReviewModel = userReview.model;
    return this.hideAddReviewPane();
  },
  showReviewError: function() {
    this.$submitReviewButton.prop('disabled', false);
    this.$addReviewNotification.addClass('review-submitted error');
    return this.$addReviewNotification.text(I18n.t('js.modules.product_reviews.create_review.error'));
  }
});

module.exports = ProductReviews.Views.AddReview;



},{}],58:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Helpers = require('../../common/helpers');

ProductReviews.Templates['product_review_histogram'] = require('../../histogram.html.mustache');

ProductReviews.Templates['product_reviews_histogram_star'] = require('../../histogram_star.html.mustache');

ProductReviews.Views.Histogram = Backbone.View.extend({
  el: '#product-reviews-histogram',
  template: ProductReviews.Templates['product_review_histogram'],
  partials: {
    product_reviews_histogram_star: ProductReviews.Templates['product_reviews_histogram_star']
  },
  render: function() {
    var data, i18n, product;
    i18n = I18n.scoped();
    i18n.scope = ['js', 'modules', 'product_reviews'];
    product = ProductReviews.Helpers.extractStats(this.options, i18n);
    data = {
      averageRating: ProductReviews.Helpers.averageRatingText(product.averageRating, product.ratingCount, product.reviewCount, product.reviewsSorting, i18n),
      histogram: ProductReviews.Helpers.buildHistogram(product.ratingCount, product.ratingDistribution, i18n)
    };
    return this.$el.html(this.template.render(data, this.partials));
  }
});

module.exports = ProductReviews.Views.Histogram;



},{"../../common/helpers":52,"../../histogram.html.mustache":65,"../../histogram_star.html.mustache":66}],59:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_card'] = require('../../review_card.html.mustache');

ProductReviews.Views.ReviewCard = Backbone.View.extend({
  render: function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      displayOptions: this.model.displayOptions,
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    return this.$el.append(ProductReviews.Templates['product_reviews_review_card'].render(data));
  }
});

module.exports = ProductReviews.Views.ReviewCard;



},{"../../review_card.html.mustache":67}],60:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_list'] = require('../../review_list.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.ReviewList = Backbone.View.extend({
  el: "#product-reviews-list",
  render: function() {
    var fetchedReviews, i, len, results, review;
    fetchedReviews = this.collection.fetchedReviews();
    if (this.collection.page === 1) {
      this.$el.html(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    } else {
      this.$el.append(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    }
    results = [];
    for (i = 0, len = fetchedReviews.length; i < len; i++) {
      review = fetchedReviews[i];
      (new ProductReviews.Views.ReviewCard({
        model: review,
        el: "#review-card-" + review.id
      })).render();
      results.push((new ProductReviews.Views.ReviewRating({
        model: review,
        el: "#review-rating-" + review.id
      })).render());
    }
    return results;
  }
});

module.exports = ProductReviews.Views.ReviewList;



},{"../../review_list.html.mustache":68,"./product_reviews_review_card":59,"./product_reviews_review_rating":61}],61:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_stars'] = require('../../stars.html.mustache');

ProductReviews.Views.ReviewRating = Backbone.View.extend({
  render: function() {
    return this.$el.append(ProductReviews.Templates['product_reviews_stars'].render(this.model.attributes));
  }
});

module.exports = ProductReviews.Views.ReviewRating;



},{"../../stars.html.mustache":69}],62:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_user_review'] = require('../../user_review.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.UserReview = Backbone.View.extend({
  el: "#user-review-card",
  render: function() {
    $('#product-reviews-form-extension').after(ProductReviews.Templates['product_reviews_user_review'].render({
      userReview: this.model.attributes
    }));
    this.setElement($('#user-review-card'));
    (new ProductReviews.Views.ReviewCard({
      model: this.model,
      el: "#user-review-card"
    })).render();
    return (new ProductReviews.Views.ReviewRating({
      model: this.model,
      el: "#user-review-card .review-rating"
    })).render();
  }
});

module.exports = ProductReviews.Views.UserReview;



},{"../../user_review.html.mustache":70,"./product_reviews_review_card":59,"./product_reviews_review_rating":61}],63:[function(require,module,exports){
var ProductReviews, base;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_widget_review_rating'] = require('../../widget_review_rating.html.mustache');

ProductReviews.Views.Widget.Review = (function() {
  function Review(arg) {
    this.data = arg.data, this.uuid = arg.uuid, this.$el = arg.$el;
  }

  Review.prototype.prepareData = function() {
    var bhc, i, position, rating, ref, starType, stars;
    if (!(((ref = this.data) != null ? ref.averageRating : void 0) && this.data.ratingCount)) {
      return;
    }
    rating = this.data.averageRating;
    stars = [];
    bhc = "deal-review-rating:" + rating;
    for (position = i = 1; i <= 5; position = ++i) {
      starType = (function() {
        switch (false) {
          case !(rating > 7 / 8):
            return 'full-star';
          case !(rating > 5 / 8):
            return 'three-fourth-star';
          case !(rating > 3 / 8):
            return 'half-star';
          case !(rating > 1 / 8):
            return 'fourth-star';
          default:
            return 'empty-star';
        }
      })();
      stars.push("<span class='" + starType + " icon-star-filled'></span>");
      rating--;
    }
    return {
      productRating: {
        bhc: {
          rating: "review-rating:" + this.uuid + "_" + (this.data.averageRating.toFixed(1)),
          ratingCount: "rating-count:" + this.uuid + "_" + this.data.ratingCount
        },
        count: I18n.toNumber(this.data.ratingCount),
        stars: stars
      }
    };
  };

  Review.prototype.render = function() {
    return this.$el.find('.deal-title').after(ProductReviews.Templates['product_reviews_widget_review_rating'].render(this.prepareData()));
  };

  return Review;

})();

module.exports = ProductReviews.Views.Widget.Review;



},{"../../widget_review_rating.html.mustache":71}],64:[function(require,module,exports){
var ProductReviews, base,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.Widget.Review = require('./product_reviews_widget_review');

ProductReviews.Views.Widget.ReviewRating = (function() {
  function ReviewRating(arg) {
    var productReviews;
    productReviews = arg.productReviews;
    this.fetchSuccess = bind(this.fetchSuccess, this);
    if (productReviews) {
      this.rootUrl = productReviews.rootUrl, this.locale = productReviews.locale, this.showWidgetReview = productReviews.showWidgetReview;
    }
    if (!(this.rootUrl && this.locale && this.showWidgetReview)) {
      return {};
    }
    this.fetchProductReviews();
  }

  ReviewRating.prototype.fetchProductReviews = function() {
    var csrf;
    this.deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid]');
    if (this.deals.length) {
      csrf = $('meta[name=csrf-token]').attr('content');
      return $.ajax({
        url: this.rootUrl + "/product_review_proxy/products.json?locale=" + this.locale + "&_csrf=" + csrf,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(this.prepareData()),
        success: this.fetchSuccess
      });
    }
  };

  ReviewRating.prototype.prepareData = function() {
    return {
      deal_uuid: this.extractDealUuids().join()
    };
  };

  ReviewRating.prototype.extractDealUuids = function() {
    var dealUuids;
    dealUuids = [];
    this.deals.each(function() {
      var uuid;
      uuid = $(this).data('uuid');
      if (uuid.length) {
        return dealUuids.push(uuid);
      }
    });
    return dealUuids;
  };

  ReviewRating.prototype.fetchSuccess = function(data) {
    var products;
    if (!(products = data.products)) {
      return;
    }
    return this.deals.each(function() {
      var $el, params, uuid;
      $el = $(this);
      uuid = $el.data('uuid');
      params = {
        $el: $el,
        data: products[uuid],
        uuid: uuid
      };
      if (params.data) {
        return (new ProductReviews.Views.Widget.Review(params)).render();
      }
    });
  };

  return ReviewRating;

})();

module.exports = ProductReviews.Views.Widget.ReviewRating;



},{"./product_reviews_review_card":59,"./product_reviews_review_rating":61,"./product_reviews_widget_review":63}],65:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("averageRating",c,p,1),c,p,0,20,427,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <h1 data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);_.b("    <a href=\"#product-reviews\" class=\" product-reviews-anchor\" data-bhw=\"ProductReviewsQuickViewTooltipReadReviews\">");_.b("\n" + i);_.b("      <div class=\"product-reviews-average-rating\">");_.b(_.v(_.f("rating",c,p,0)));_.b("</div>");_.b("\n" + i);if(!_.s(_.d("displayOptions.hideReviewsByOthers",c,p,1),c,p,1,0,0,"")){_.b("        <div class=\"read-reviews\">");_.b(_.t(_.f("readReview",c,p,0)));_.b("</div>");_.b("\n");};_.b("    </a>");_.b("\n" + i);_.b("  </h1>");_.b("\n" + i);_.b("  <p>");_.b(_.v(_.f("text",c,p,0)));_.b("</p>");_.b("\n");});c.pop();}_.b("<table>");_.b("\n" + i);if(_.s(_.f("histogram",c,p,1),c,p,0,474,519,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.rp("product_reviews_histogram_star",c,p,"    "));});c.pop();}_.b("</table>");_.b("\n");return _.fl();;},"{{# averageRating }}\n  <h1 data-bhc=\"{{ bhc }}\">\n    <a href=\"#product-reviews\" class=\" product-reviews-anchor\" data-bhw=\"ProductReviewsQuickViewTooltipReadReviews\">\n      <div class=\"product-reviews-average-rating\">{{ rating }}</div>\n      {{^ displayOptions.hideReviewsByOthers }}\n        <div class=\"read-reviews\">{{{ readReview }}}</div>\n      {{/ displayOptions.hideReviewsByOthers }}\n    </a>\n  </h1>\n  <p>{{ text }}</p>\n{{/ averageRating }}\n<table>\n  {{# histogram }}\n    {{> product_reviews_histogram_star }}\n  {{/ histogram }}\n</table>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],66:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<tr data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  <td class=\"star-label\">");_.b(_.v(_.f("label",c,p,0)));_.b("</td>");_.b("\n" + i);_.b("  <td class=\"star-meter\">");_.b("\n" + i);_.b("    <div><span style=\"width:");_.b(_.v(_.f("widthPercentage",c,p,0)));_.b("%\"></span></div>");_.b("\n" + i);_.b("  </td>");_.b("\n" + i);_.b("  <td class=\"star-count\">(");_.b(_.v(_.f("count",c,p,0)));_.b(")</td>");_.b("\n" + i);_.b("</tr>");_.b("\n");return _.fl();;},"<tr data-bhc=\"{{ bhc }}\">\n  <td class=\"star-label\">{{ label }}</td>\n  <td class=\"star-meter\">\n    <div><span style=\"width:{{ widthPercentage }}%\"></span></div>\n  </td>\n  <td class=\"star-count\">({{ count }})</td>\n</tr>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],67:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"review-header\">");_.b("\n" + i);_.b("  <div class=\"review-header-line\">");_.b("\n" + i);_.b("    <span class=\"review-display-name should-truncate\" data-display-name=\"");_.b(_.v(_.f("displayName",c,p,0)));_.b("\">");_.b(_.v(_.f("username",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("    <span class=\"review-rating\" id=\"");_.b(_.v(_.d("reviewIds.rating",c,p,0)));_.b("\">");_.b("\n" + i);_.b(_.rp("product_reviews_stars",c,p,"      "));_.b("    </span>");_.b("\n" + i);if(_.s(_.f("isPending",c,p,1),c,p,0,305,614,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,497,547,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.review_pending");});c.pop();}_.b("<span class=\"icon-question\"></span>");_.b("\n" + i);_.b("      </a>");_.b("\n");});c.pop();}if(_.s(_.f("isRejected",c,p,1),c,p,0,652,1108,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <span class=\"review-status");if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,708,724,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" tooltip-trigger");});c.pop();}_.b("\" ");if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,772,892,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-tooltip-id=\"product-reviews-rejected-tooltip\" data-bhw=\"ProductReviewsRejectedTooltipTrigger\" data-position=\"right\"");});c.pop();}_.b(">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,941,992,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.review_rejected");});c.pop();}if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,1031,1066,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<span class=\"icon-question\"></span>");});c.pop();}_.b("\n" + i);_.b("      </span>");_.b("\n");});c.pop();}_.b("    <span class=\"review-date\">");_.b(_.v(_.f("date",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("</div>");_.b("\n" + i);_.b("<div class=\"review-text ");if(_.s(_.f("isRatingOnly",c,p,1),c,p,0,1233,1251,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("rating-only-review");});c.pop();}_.b("\">");_.b(_.v(_.f("text",c,p,0)));_.b("</div>");_.b("\n" + i);_.b("<div class=\"review-actions\">");_.b("\n" + i);if(_.s(_.f("helpfulUpvote",c,p,1),c,p,0,1340,2147,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("buttonText",c,p,1),c,p,0,1362,2127,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <div class=\"review-vote\">");_.b("\n" + i);if(!_.s(_.d("displayOptions.isTouch",c,p,1),c,p,1,0,0,"")){_.b("          <span>");if(_.s(_.f("translate",c,p,1),c,p,0,1465,1515,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.helpful.prompt");});c.pop();}_.b("</span>");_.b("\n");};_.b("        <button");_.b("\n" + i);_.b("          id=\"");_.b(_.v(_.d("reviewIds.vote",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          class=\"btn-secondary btn-small ");_.b(_.v(_.d("displayOptions.loginRequired.triggerClass",c,p,0)));_.b(" ");_.b(_.v(_.f("buttonClass",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          ");_.b(_.t(_.d("displayOptions.loginRequired.triggerData.vote",c,p,0)));_.b("\n" + i);_.b("          ");if(_.s(_.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,1858,1884,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-login-required=\"true\"");});c.pop();}_.b("\n" + i);_.b("          data-review-id=\"");_.b(_.v(_.f("uuid",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          data-review-placement=\"");_.b(_.v(_.f("placement",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          data-bhw=\"ProductReviewsVote\">");_.b("\n" + i);_.b("            ");_.b(_.v(_.f("buttonText",c,p,0)));_.b("\n" + i);_.b("          </button>");_.b("\n" + i);_.b("      </div>");_.b("\n");});c.pop();}});c.pop();}if(_.s(_.f("isUserReview",c,p,1),c,p,0,2189,2642,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <a");_.b("\n" + i);_.b("      id=\"review-delete\"");_.b("\n" + i);_.b("      class=\"");_.b(_.v(_.d("displayOptions.loginRequired.triggerClass",c,p,0)));_.b("\"");_.b("\n" + i);_.b("      ");_.b(_.t(_.d("displayOptions.loginRequired.triggerData.review",c,p,0)));_.b("\n" + i);_.b("      ");if(_.s(_.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,2399,2425,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-login-required=\"true\"");});c.pop();}_.b("\n" + i);_.b("      data-review-id=\"");_.b(_.v(_.f("uuid",c,p,0)));_.b("\"");_.b("\n" + i);_.b("      data-bhw=\"ProductReviewsDelete\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,2570,2612,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.delete");});c.pop();}_.b("\n" + i);_.b("      </a>");_.b("\n");});c.pop();}if(_.s(_.d("displayOptions.showShare",c,p,1),c,p,0,2695,3028,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">");_.b("\n" + i);_.b("      <span class=\"icon-share\"></span><span class=\"share-text\">");if(_.s(_.f("translate",c,p,1),c,p,0,2950,2991,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.share");});c.pop();}_.b("</span>");_.b("\n" + i);_.b("    </div>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n" + i);if(_.s(_.f("helpfulUpvote",c,p,1),c,p,0,3087,3167,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div id=\"");_.b(_.v(_.d("reviewIds.voteText",c,p,0)));_.b("\" class=\"review-vote-text\">");_.b(_.v(_.f("text",c,p,0)));_.b("</div>");_.b("\n");});c.pop();}_.b("<div id=\"");_.b(_.v(_.d("reviewIds.notification",c,p,0)));_.b("\" class=\"notification review-notification\"></div>");_.b("\n");return _.fl();;},"<div class=\"review-header\">\n  <div class=\"review-header-line\">\n    <span class=\"review-display-name should-truncate\" data-display-name=\"{{ displayName }}\">{{ username }}</span>\n    <span class=\"review-rating\" id=\"{{ reviewIds.rating }}\">\n      {{> product_reviews_stars }}\n    </span>\n    {{# isPending }}\n      <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">\n        {{# translate }}modules.product_reviews.review_card.review_pending{{/ translate }}<span class=\"icon-question\"></span>\n      </a>\n    {{/ isPending }}\n    {{# isRejected }}\n      <span class=\"review-status{{# rejectionReasons }} tooltip-trigger{{/ rejectionReasons }}\" {{# rejectionReasons }}data-tooltip-id=\"product-reviews-rejected-tooltip\" data-bhw=\"ProductReviewsRejectedTooltipTrigger\" data-position=\"right\"{{/ rejectionReasons }}>\n        {{# translate }}modules.product_reviews.review_card.review_rejected{{/ translate }}{{# rejectionReasons }}<span class=\"icon-question\"></span>{{/ rejectionReasons }}\n      </span>\n    {{/ isRejected }}\n    <span class=\"review-date\">{{ date }}</span>\n  </div>\n</div>\n<div class=\"review-text {{# isRatingOnly }}rating-only-review{{/ isRatingOnly }}\">{{ text }}</div>\n<div class=\"review-actions\">\n  {{# helpfulUpvote }}\n    {{# buttonText }}\n      <div class=\"review-vote\">\n        {{^ displayOptions.isTouch }}\n          <span>{{# translate }}modules.product_reviews.review_card.helpful.prompt{{/ translate }}</span>\n        {{/ displayOptions.isTouch }}\n        <button\n          id=\"{{ reviewIds.vote }}\"\n          class=\"btn-secondary btn-small {{ displayOptions.loginRequired.triggerClass }} {{ buttonClass }}\"\n          {{{ displayOptions.loginRequired.triggerData.vote }}}\n          {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n          data-review-id=\"{{ uuid }}\"\n          data-review-placement=\"{{ placement }}\"\n          data-bhw=\"ProductReviewsVote\">\n            {{ buttonText }}\n          </button>\n      </div>\n    {{/ buttonText }}\n  {{/ helpfulUpvote }}\n  {{# isUserReview }}\n    <a\n      id=\"review-delete\"\n      class=\"{{ displayOptions.loginRequired.triggerClass }}\"\n      {{{ displayOptions.loginRequired.triggerData.review }}}\n      {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n      data-review-id=\"{{ uuid }}\"\n      data-bhw=\"ProductReviewsDelete\">\n        {{# translate }}modules.product_reviews.review_card.delete{{/ translate }}\n      </a>\n  {{/ isUserReview }}\n  {{# displayOptions.showShare }}\n    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">\n      <span class=\"icon-share\"></span><span class=\"share-text\">{{# translate }}modules.product_reviews.review_card.share{{/ translate }}</span>\n    </div>\n  {{/ displayOptions.showShare }}\n</div>\n{{# helpfulUpvote }}\n  <div id=\"{{ reviewIds.voteText }}\" class=\"review-vote-text\">{{ text }}</div>\n{{/ helpfulUpvote }}\n<div id=\"{{ reviewIds.notification }}\" class=\"notification review-notification\"></div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],68:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("reviews",c,p,1),c,p,0,14,181,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"review-card\" id=\"");_.b(_.v(_.d("reviewIds.card",c,p,0)));_.b("\" data-bhc=\"product-review:");_.b(_.v(_.f("uuid",c,p,0)));_.b("\" data-bh-viewport=\"respect\">");_.b("\n" + i);_.b(_.rp("product_reviews_review_card",c,p,"    "));_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{# reviews }}\n  <div class=\"review-card\" id=\"{{ reviewIds.card }}\" data-bhc=\"product-review:{{ uuid }}\" data-bh-viewport=\"respect\">\n    {{> product_reviews_review_card }}\n  </div>\n{{/ reviews }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],69:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("ratingStars",c,p,1),c,p,0,18,170,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <ul class=\"product-reviews-rating\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("stars",c,p,1),c,p,0,94,149,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <li class=\"icon-star-filled\">");_.b(_.t(_.d(".",c,p,0)));_.b("</li>");_.b("\n");});c.pop();}_.b("  </ul>");_.b("\n");});c.pop();}return _.fl();;},"{{# ratingStars }}\n  <ul class=\"product-reviews-rating\" data-bhc=\"{{ bhc }}\">\n    {{# stars }}\n      <li class=\"icon-star-filled\">{{{ . }}}</li>\n    {{/ stars }}\n  </ul>\n{{/ ratingStars }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],70:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("userReview",c,p,1),c,p,0,17,216,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div id=\"user-review-card\" class=\"review-card\" data-bhw=\"ProductReviewsUserReview\" data-bhc=\"product-review:");_.b(_.v(_.f("uuid",c,p,0)));_.b("\" data-bh-viewport=\"respect\">");_.b("\n" + i);_.b(_.rp("product_reviews_review_card",c,p,"    "));_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{# userReview }}\n  <div id=\"user-review-card\" class=\"review-card\" data-bhw=\"ProductReviewsUserReview\" data-bhc=\"product-review:{{ uuid }}\" data-bh-viewport=\"respect\">\n    {{> product_reviews_review_card }}\n  </div>\n{{/ userReview }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],71:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"deal-product-review\">");_.b("\n" + i);if(_.s(_.f("productRating",c,p,1),c,p,0,56,271,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <ul class=\"rating\" data-bhc=\"");_.b(_.v(_.d("bhc.rating",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("stars",c,p,1),c,p,0,127,161,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        <li>");_.b(_.t(_.d(".",c,p,0)));_.b("</li>");_.b("\n");});c.pop();}_.b("    </ul>");_.b("\n" + i);_.b("    <span class=\"rating-count\" data-bhc=\"");_.b(_.v(_.d("bhc.ratingCount",c,p,0)));_.b("\">(");_.b(_.v(_.f("count",c,p,0)));_.b(")</span>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"deal-product-review\">\n  {{# productRating }}\n    <ul class=\"rating\" data-bhc=\"{{ bhc.rating }}\">\n      {{# stars }}\n        <li>{{{ . }}}</li>\n      {{/ stars }}\n    </ul>\n    <span class=\"rating-count\" data-bhc=\"{{ bhc.ratingCount }}\">({{ count }})</span>\n  {{/ productRating }}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],72:[function(require,module,exports){
var ProductVideo;

ProductVideo = window.ProductVideo != null ? window.ProductVideo : window.ProductVideo = {};

ProductVideo.init = function(arg, done) {
  var productVideo;
  productVideo = arg.productVideo;
  if (!productVideo) {
    return done();
  }
  return $((function(_this) {
    return function() {
      window.webyclip = {};
      window.webyclip.input_params = productVideo;
      if ('https:' === document.location.protocol) {
        $.getScript('https://6bf746ad5bc91a240a3d-1d8fbdf7ecdc2b67730d7c561f0d1dfd.ssl.cf2.rackcdn.com/webyclip-groupon-pdp-default-loader.min.js');
      } else {
        $.getScript('http://code.webyclip.com/webyclip-groupon-pdp-default-loader.min.js');
      }
      return done();
    };
  })(this));
};

module.exports = ProductVideo;



},{}],73:[function(require,module,exports){
if (window.FacebookPromNight == null) {
  window.FacebookPromNight = {};
}

FacebookPromNight.init = function(payload, done) {
  return $(function() {
    $(".share-links .icon-facebook").on({
      click: function(e) {
        e.preventDefault();
        return window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436');
      }
    });
    return done();
  });
};

module.exports = FacebookPromNight;



},{}],74:[function(require,module,exports){
var FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

FreeShipping.View = require('./views/free_shipping');

FreeShipping.init = function(arg, done) {
  var freeShippingAvailable;
  freeShippingAvailable = arg.freeShippingAvailable;
  if (!(freeShippingAvailable != null ? freeShippingAvailable.hasOneFreeShipping : void 0)) {
    return done();
  }
  return $(function() {
    var freeShippingValues, view;
    freeShippingValues = freeShippingAvailable.freeShippingValues;
    view = new FreeShipping.View({
      el: '.free-shipping-container',
      freeShippingValues: freeShippingValues
    });
    return done();
  });
};

module.exports = FreeShipping;



},{"./views/free_shipping":75}],75:[function(require,module,exports){
var DealEventPipe, FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

FreeShipping.View = Backbone.View.extend({
  initialize: function() {
    this.$message = $('.free-shipping-container');
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateFreeShipping(priceData);
      };
    })(this));
  },
  updateFreeShipping: function(arg) {
    var uuid;
    uuid = arg.uuid;
    if (this.options.freeShippingValues[uuid]) {
      return this.$message.show();
    } else {
      return this.$message.hide();
    }
  }
});

module.exports = FreeShipping.View;



},{"../../../deal/frontend/event_pipe":12}],76:[function(require,module,exports){
var safeInit;

if (window.Tracking == null) {
  window.Tracking = {};
}

safeInit = function(obj, payload, cb) {
  var err;
  try {
    return obj.init(payload, cb);
  } catch (_error) {
    err = _error;
    OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Error", {
      error: err
    });
    return cb();
  }
};

Tracking.Initializer = function(timeoutInMs) {
  var finished, inFlight;
  if (timeoutInMs == null) {
    timeoutInMs = 30 * 1000;
  }
  inFlight = 0;
  this._hasRun = false;
  finished = false;
  return {
    run: function(modules, payload, cb) {
      var i, len, module;
      for (i = 0, len = modules.length; i < len; i++) {
        module = modules[i];
        inFlight++;
        safeInit(module, payload, (function(_this) {
          return function() {
            inFlight--;
            if (inFlight === 0 && _this._hasRun && !finished) {
              finished = true;
              return cb();
            }
          };
        })(this));
      }
      this._hasRun = true;
      if (inFlight === 0 && !finished) {
        finished = true;
        cb();
      }
      return setTimeout((function() {
        if (!finished) {
          OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Timeout", {
            numberInFlight: inFlight
          });
          finished = true;
          return cb();
        }
      }), timeoutInMs);
    }
  };
};

module.exports = Tracking.Initializer;



},{}],77:[function(require,module,exports){
var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, ignoreCap) {
  if (ignoreCap == null) {
    ignoreCap = false;
  }
  switch (false) {
    case !(timeLeft.days >= 15 && !ignoreCap):
      return "";
    case !(timeLeft.days > 1):
      return ".countdown_time_many_days";
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.UrgencyTimer == null) {
    window.UrgencyTimer = {};
  }
  if (UrgencyTimer.Helpers == null) {
    UrgencyTimer.Helpers = {};
  }
  UrgencyTimer.Helpers.timeRemaining = timeRemaining;
  UrgencyTimer.Helpers.millisRemaining = millisRemaining;
  UrgencyTimer.Helpers.countdownTimeKey = countdownTimeKey;
  UrgencyTimer.Helpers.countdownTimestamp = countdownTimestamp;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp
  };
}



},{}],78:[function(require,module,exports){
var base;

if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

if ((base = window.UrgencyTimer).current == null) {
  base.current = {};
}

UrgencyTimer.Model = require('./models/countdown_timer');

UrgencyTimer.View = require('./views/countdown_timer');

UrgencyTimer.init = function(arg, done) {
  var endAt, ref, timerModel, umsData;
  umsData = arg.umsData;
  if (done == null) {
    done = function() {};
  }
  endAt = umsData != null ? (ref = umsData.urgencyTimer) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new UrgencyTimer.Model({
    endAt: endAt
  });
  window.UrgencyTimer.current.timerModel = timerModel;
  window.UrgencyTimer.current.timerView = new UrgencyTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: umsData != null ? umsData.el : void 0
  });
  return $(function() {
    window.UrgencyTimer.current.timerView.render();
    return done();
  });
};

module.exports = UrgencyTimer.init;



},{"./models/countdown_timer":79,"./views/countdown_timer":81}],79:[function(require,module,exports){
if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

UrgencyTimer.Helpers = require('../../common/helpers');

UrgencyTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = UrgencyTimer.Helpers.millisRemaining(this.get('endAt'));
    return UrgencyTimer.Helpers.timeRemaining(millisLeft);
  }
});

module.exports = UrgencyTimer.Model;



},{"../../common/helpers":77}],80:[function(require,module,exports){
var ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, POPUP_SWITCH_MESSAGE_TIMEOUT, PRIMARY_MESSAGE_TIMEOUT, PRIMARY_MESSAGE_TIMEOUT_TOUCH, UrgencyMessaging;

UrgencyMessaging = window.UrgencyMessaging != null ? window.UrgencyMessaging : window.UrgencyMessaging = {};

PRIMARY_MESSAGE_TIMEOUT = 5000;

ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;

PRIMARY_MESSAGE_TIMEOUT_TOUCH = PRIMARY_MESSAGE_TIMEOUT - ACTIVATE_PRIMARY_MESSAGE_TIMEOUT;

POPUP_SWITCH_MESSAGE_TIMEOUT = 500;

UrgencyMessaging.inlineUrgencyMessaging = function(touchRequest) {
  var inlineSwitchMessageTimeout, primaryMessage, secondaryMessage, switchMessage, urgencyMessages;
  urgencyMessages = $('.urgency-messaging.inline .urgency-message');
  primaryMessage = urgencyMessages.find('.primary');
  secondaryMessage = urgencyMessages.find('.secondary');
  switchMessage = function() {
    primaryMessage.addClass('fade-out');
    secondaryMessage.children('span').removeClass('hide');
    return secondaryMessage.addClass('fade-in');
  };
  if (!touchRequest) {
    urgencyMessages.addClass('visible');
    primaryMessage.addClass('fade-in');
  }
  inlineSwitchMessageTimeout = touchRequest ? PRIMARY_MESSAGE_TIMEOUT_TOUCH : PRIMARY_MESSAGE_TIMEOUT;
  if (secondaryMessage.length) {
    return window.setTimeout(switchMessage, inlineSwitchMessageTimeout);
  }
};

UrgencyMessaging.popupUrgencyMessaging = function() {
  var addSecondaryMessage, addXIconHandler, isMessageSwitched, primaryMessage, secondaryMessage, switchMessage, urgencyMessages;
  urgencyMessages = $('.urgency-messaging.popup');
  primaryMessage = urgencyMessages.find('.primary');
  secondaryMessage = urgencyMessages.find('.secondary');
  isMessageSwitched = false;
  addSecondaryMessage = function() {
    return secondaryMessage.addClass('pop-in');
  };
  switchMessage = function() {
    if (isMessageSwitched) {
      return;
    }
    isMessageSwitched = true;
    primaryMessage.addClass('pop-out');
    return window.setTimeout(addSecondaryMessage, POPUP_SWITCH_MESSAGE_TIMEOUT);
  };
  addXIconHandler = function() {
    var popup;
    popup = $(this).parent('.ums-text');
    if (popup.hasClass('primary')) {
      return switchMessage();
    } else {
      return popup.addClass('pop-out');
    }
  };
  urgencyMessages.find('.icon-x').click(addXIconHandler);
  primaryMessage.addClass('pop-in');
  if (secondaryMessage.length) {
    return setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT);
  }
};

UrgencyMessaging.init = function(arg, done) {
  var activateUrgencyMessaging, inlineTreatment, isActivated, realTimeMessaging, scrollHandler, showPopups, touchRequest, umsData;
  umsData = arg.umsData;
  realTimeMessaging = umsData.realTimeMessaging;
  touchRequest = realTimeMessaging.touchRequest, showPopups = realTimeMessaging.showPopups, inlineTreatment = realTimeMessaging.inlineTreatment;
  isActivated = false;
  activateUrgencyMessaging = function() {
    if (isActivated) {
      return;
    }
    isActivated = true;
    if (inlineTreatment) {
      return UrgencyMessaging.inlineUrgencyMessaging(touchRequest);
    } else if (showPopups) {
      return UrgencyMessaging.popupUrgencyMessaging();
    }
  };
  scrollHandler = function(e) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      return activateUrgencyMessaging();
    }
  };
  return $(function() {
    window.setTimeout(activateUrgencyMessaging, ACTIVATE_PRIMARY_MESSAGE_TIMEOUT);
    $(window).on('scroll', scrollHandler);
    return done();
  });
};

module.exports = UrgencyMessaging;



},{}],81:[function(require,module,exports){
var DEFAULT_EL;

DEFAULT_EL = '.urgency-message > .timer #timer-clock';

if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

UrgencyTimer.Helpers = require('../../common/helpers');

UrgencyTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    return this.el = this.options.el || DEFAULT_EL;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("js.modules.urgency_messaging" + (UrgencyTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timestamp: UrgencyTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});

module.exports = UrgencyTimer.View;



},{"../../common/helpers":77}],82:[function(require,module,exports){
var VariationsWidget, base;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if ((base = VariationsWidget.Collections).Option == null) {
  base.Option = {};
}

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = require('./option');

VariationsWidget.Collections.Option = Backbone.Collection.extend({
  model: VariationsWidget.Models.Option,
  chosen: function(value) {
    return this.find(function(trait) {
      return trait.get('traitValue') === value;
    });
  },
  selected: function() {
    return this.find(function(trait) {
      return trait.get('selected');
    });
  },
  setSelected: function(id) {
    this.selected().set('selected', false);
    return this.get(id).set('selected', true);
  }
});

VariationsWidget.Collections.Option.create = function(traits) {
  var data, i, len, option, results, trait;
  results = [];
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    data = (function() {
      var j, len1, ref, results1;
      ref = trait.data;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        option = ref[j];
        results1.push({
          traitValue: option.value,
          disabled: false,
          forceDisplay: false,
          traitIndex: option.traitIndex,
          traitName: option.name,
          id: option.optionIndex,
          isSoldOut: option.isSoldOut,
          optionPrice: false,
          selected: option.optionIndex === 0
        });
      }
      return results1;
    })();
    results.push(new VariationsWidget.Collections.Option(data));
  }
  return results;
};

module.exports = VariationsWidget.Collections.Option;



},{"./option":83}],83:[function(require,module,exports){
var VariationsWidget;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = Backbone.Model.extend({
  initialize: function() {}
});

module.exports = VariationsWidget.Models.Option;



},{}],84:[function(require,module,exports){
var Cart, DealEventPipe, VariationsWidget,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

Cart = window.Cart != null ? window.Cart : window.Cart = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

Cart.Helpers = require('../../cart/common/helpers');

VariationsWidget.Controller = (function() {
  function Controller() {
    this.findSelectedCollections = bind(this.findSelectedCollections, this);
    this.findDefaultCollections = bind(this.findDefaultCollections, this);
    this.isSelectionDefault = bind(this.isSelectionDefault, this);
    var ref;
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '7.0') {
      this.ie7 = true;
    }
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.updateSelectElements("", true);
    this.availableOptions = this.getAvailableOptions();
    this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
    this.lastImage = "";
    this.clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection;
    this.$selectElements = $('#variation-traits').find('.variation-trait');
    if ((ref = VariationsWidget.preSelectTraits) != null ? ref.length : void 0) {
      this.makeSelectionsViaPreselection();
    } else {
      this.updateSelectionsToDefault();
    }
  }

  Controller.prototype.render = function(latestSelection, updateCarousel) {
    if (updateCarousel == null) {
      updateCarousel = true;
    }
    if (latestSelection.selection != null) {
      this.updateSelections(latestSelection);
      this.updateSelectElements(latestSelection.trait);
      this.availableOptions = this.getAvailableOptions();
      this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
      this.updatePricing(this.cheapestOption, this.availableOptions.length);
      if (updateCarousel) {
        this.updateCarousel();
      }
      this.removeErrorMessages();
    }
  };

  Controller.prototype.updateSelectionsToDefault = function() {
    var i, len, ref, results, selectElement;
    ref = this.$selectElements || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      selectElement = ref[i];
      results.push($(selectElement).find('option:eq(0)').prop('selected', true));
    }
    return results;
  };

  Controller.prototype.updateSelections = function(latestSelection) {
    var collection, i, len, ref;
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      if (collection.models[0].get('traitName') === latestSelection.trait) {
        collection.setSelected(latestSelection.id);
        break;
      }
    }
  };

  Controller.prototype.updateSelectElements = function(latestSelection, updateAll) {
    var collection, conditions, enabledOptions, enabledValues, i, j, k, l, lastSelection, len, len1, len2, len3, len4, m, model, notSoldOut, option, ref, ref1, ref2, trait, traitName, unavailableOptions, unavailableValues, value;
    if (updateAll == null) {
      updateAll = false;
    }
    if (VariationsWidget.printOptionPrice) {
      updateAll = true;
    }
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      traitName = collection.models[0].get('traitName');
      if (traitName !== latestSelection || updateAll) {
        conditions = this.getConditions(collection.selected());
        lastSelection = _.keys(conditions).length === VariationsWidget.collections.length - 1;
        enabledOptions = [];
        unavailableOptions = [];
        if (!$.isEmptyObject(conditions)) {
          enabledOptions = _.where(VariationsWidget.options, conditions);
        } else {
          enabledOptions = VariationsWidget.options;
        }
        enabledValues = _.pluck(enabledOptions, traitName);
        unavailableValues = _.uniq(enabledValues);
        notSoldOut = [];
        for (j = 0, len1 = enabledOptions.length; j < len1; j++) {
          option = enabledOptions[j];
          for (k = 0, len2 = unavailableValues.length; k < len2; k++) {
            value = unavailableValues[k];
            if (value === option[traitName] && !option.isSoldOut) {
              notSoldOut.push(value);
            }
          }
        }
        unavailableValues = _.difference(unavailableValues, notSoldOut);
        enabledValues.unshift((this.i18n.t('js.modules.variations.selector')) + " " + traitName);
        ref1 = VariationsWidget.collections;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          trait = ref1[l];
          if (trait.models[0].get('traitName') === traitName) {
            ref2 = trait.models;
            for (m = 0, len4 = ref2.length; m < len4; m++) {
              model = ref2[m];
              this.setOptionState(model, enabledValues, unavailableValues);
              if (lastSelection && (conditions[traitName] == null)) {
                this.setOptionPrice(model, enabledValues, enabledOptions);
              } else if (conditions[traitName] == null) {
                this.setOptionFromPrice(model, enabledValues, enabledOptions);
              } else {
                model.set('optionPrice', false);
              }
            }
          }
        }
      }
    }
    if (this.ie7) {
      $('option').removeClass("ie7-color");
      return $('option[disabled]').addClass("ie7-color");
    }
  };

  Controller.prototype.setOptionState = function(model, enabledValues, unavailableValues) {
    var printSoldOut;
    printSoldOut = VariationsWidget.printSoldOut;
    if (model.id === 0 || (_.contains(enabledValues, model.get('traitValue')))) {
      if (model.get('isSoldOut') || ((unavailableValues != null) && (_.contains(unavailableValues, model.get('traitValue'))))) {
        model.set('disabled', true);
        if (printSoldOut) {
          model.set('forceDisplay', true);
        }
      } else {
        model.set('disabled', false);
        if (printSoldOut) {
          model.set('forceDisplay', false);
        }
      }
    } else {
      model.set('disabled', true);
      if (printSoldOut) {
        model.set('forceDisplay', false);
      }
    }
  };

  Controller.prototype.setOptionFromPrice = function(model, enabledValues, enabledOptions) {
    var cheapestOption, modelID, name, printOptionPrice, selected, traitOptions, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    traitOptions = _.filter(enabledOptions, (function(item) {
      return item[name] === value;
    }));
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      cheapestOption = this.getCheapestAvailableOption(traitOptions);
      if (cheapestOption != null) {
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {
          minPrice: cheapestOption.newPrice
        }));
      }
    }
  };

  Controller.prototype.setOptionPrice = function(model, enabledValues, enabledOptions) {
    var i, len, modelID, name, option, printOptionPrice, selected, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      for (i = 0, len = enabledOptions.length; i < len; i++) {
        option = enabledOptions[i];
        if (value === option[name]) {
          model.set('optionPrice', option.newPrice);
        }
      }
    }
  };

  Controller.prototype.getConditions = function(selected) {
    var conditions, i, len, ref, tempCollection, tempSelected, tempSelectedTraitValue;
    conditions = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      tempCollection = ref[i];
      tempSelected = tempCollection.selected();
      tempSelectedTraitValue = tempSelected.get('traitValue');
      if (tempSelectedTraitValue !== selected.get('traitValue') && !this.isSelectionDefault(tempSelectedTraitValue)) {
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue;
      }
    }
    return conditions;
  };

  Controller.prototype.getAvailableOptions = function() {
    var collection, i, len, options, properties, ref, selectedTrait, selectedTraitValue;
    properties = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitValue = selectedTrait.get('traitValue');
      if (!this.isSelectionDefault(selectedTraitValue)) {
        properties[selectedTrait.get('traitName')] = selectedTraitValue;
      }
    }
    if ($.isEmptyObject(properties)) {
      options = VariationsWidget.options;
    } else {
      options = _.where(VariationsWidget.options, properties);
    }
    return options;
  };

  Controller.prototype.getCheapestAvailableOption = function(availableOptions) {
    var currentCheapest, i, len, option;
    currentCheapest = void 0;
    for (i = 0, len = availableOptions.length; i < len; i++) {
      option = availableOptions[i];
      if (!option.isSoldOut && (currentCheapest === void 0 || (option.amount < currentCheapest.amount))) {
        currentCheapest = option;
      }
    }
    return currentCheapest || availableOptions[0];
  };

  Controller.prototype.overridePriceDataWithSaleInfo = function(priceData, option) {
    var i, len, offer, ref, ref1, ref2, ref3, ref4, sale;
    if (!(((option != null ? option.regularPrice : void 0) != null) || (((ref = VariationsWidget.offerCollections) != null ? ref.offerOptions : void 0) != null))) {
      return;
    }
    sale = {};
    if (option.regularPrice) {
      _.extend(sale, {
        urgencyPricing: {
          regularPrice: option.regularPrice,
          newPrice: option.newPrice,
          pricingMetadata: option.pricingMetadata
        }
      });
    }
    ref2 = ((ref1 = VariationsWidget.offerCollections) != null ? ref1.offerOptions : void 0) || [];
    for (i = 0, len = ref2.length; i < len; i++) {
      offer = ref2[i];
      if (offer.uuid === option.uuid) {
        if (((offer != null ? offer.buyUrl : void 0) != null) && !((ref3 = VariationsWidget.offerCollections) != null ? (ref4 = ref3.offerModal) != null ? ref4.isSoldOut : void 0 : void 0)) {
          priceData.buyUrl = offer.buyUrl;
        }
        _.extend(sale, {
          offer: offer
        });
      }
    }
    if (sale !== {}) {
      return _.extend(priceData, {
        sale: sale
      });
    }
  };

  Controller.prototype.updatePricing = function(cheapestOption, length) {
    var priceData;
    priceData = {
      value: cheapestOption.oldPrice,
      percent: cheapestOption.discount,
      savings: cheapestOption.savePrice,
      price: cheapestOption.newPrice,
      lengthClass: cheapestOption.lengthClass,
      buyUrl: this.buyButtonUrl(cheapestOption),
      uuid: cheapestOption.uuid,
      variationsSelected: length === 1 && !this.areAnySelectionsDefault(VariationsWidget.collections),
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount
    };
    this.overridePriceDataWithSaleInfo(priceData, cheapestOption);
    return DealEventPipe.trigger("priceUpdate", priceData);
  };

  Controller.prototype.buyButtonUrl = function(cheapestOption) {
    var ref;
    if ((ref = cheapestOption.externalUrl) != null ? ref.length : void 0) {
      return cheapestOption.externalUrl;
    }
    if (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0) {
      return Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid);
    } else {
      return cheapestOption.url;
    }
  };

  Controller.prototype.updateCarousel = function() {
    var currentImage, foundMatch, imageUrl, ref, valuesHash;
    if (this.areSelectionsDefault(VariationsWidget.collections)) {
      DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(DealCarousel.dealMedia[payload.carousel.dealId].models[0]);
    } else {
      ref = VariationsWidget.mappings;
      for (imageUrl in ref) {
        valuesHash = ref[imageUrl];
        foundMatch = _.every(VariationsWidget.collections, (function(_this) {
          return function(collection) {
            var selectedTrait, selectedTraitValue;
            selectedTrait = collection.selected();
            selectedTraitValue = selectedTrait.get('traitValue');
            if (_this.isSelectionDefault(selectedTraitValue)) {
              return true;
            } else {
              return _.contains(valuesHash[selectedTrait.get('traitName')], selectedTraitValue);
            }
          };
        })(this));
        currentImage = DealCarousel.carouselViews[payload.carousel.dealId].currentFeatured.baseURL;
        if (foundMatch && currentImage !== imageUrl) {
          this.changeToMatchingImage(imageUrl);
          break;
        }
      }
    }
  };

  Controller.prototype.changeToMatchingImage = function(imgPath) {
    var image;
    this.lastImage = imgPath;
    image = DealCarousel.dealMedia[payload.carousel.dealId].findWhere({
      thumb: imgPath + "t100x100" + payload.carousel.imageQuality + ".jpg"
    });
    return DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(image);
  };

  Controller.prototype.findMatchingTraits = function(img) {
    var key, ref, selections, value;
    this.lastImage = img;
    selections = [];
    if (VariationsWidget.mappings[img] != null) {
      ref = VariationsWidget.mappings[img];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections.push({
            trait: key,
            selection: value[0]
          });
        }
      }
    }
    return this.makeSelectionsViaCarousel(selections);
  };

  Controller.prototype.makeSelectionsViaCarousel = function(selections) {
    if ((selections != null ? selections.length : void 0) < 1 && !this.clearTraitsOnCarouselSelection) {
      return;
    }
    this.clearSelections();
    return this.makeSelections(selections);
  };

  Controller.prototype.makeSelectionsViaPreselection = function() {
    var collection, i, j, len, len1, option, ref, ref1, selections, trait;
    option = _.findWhere(VariationsWidget.options, {
      uuid: VariationsWidget.dealOptionUuid
    });
    if ((option == null) || option.isSoldOut) {
      return;
    }
    selections = [];
    ref = VariationsWidget.preSelectTraits || [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get("traitName") === trait) {
          selections.push({
            trait: trait,
            selection: option[trait]
          });
          break;
        }
      }
    }
    return this.makeSelections(selections);
  };

  Controller.prototype.clearSelections = function() {
    var collection, data, i, len, ref, results, selectedTrait, selectedTraitName, selection;
    ref = VariationsWidget.collections || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitName = selectedTrait.get('traitName');
      if (!this.isSelectionDefault(selectedTrait.get('traitValue'))) {
        selection = this.i18n.t('js.modules.variations.select', {
          name: selectedTraitName
        });
        data = {
          trait: selectedTraitName,
          selection: selection,
          id: 0
        };
        $("#trait-" + (selectedTrait.get('traitIndex'))).val(selection);
        if ($("#trait-" + (selectedTrait.get('traitIndex'))).val() == null) {
          $("#trait-" + (selectedTrait.get('traitIndex'))).prop('selectedIndex', 0);
        }
        results.push(this.render(data, false));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  Controller.prototype.makeSelections = function(selections) {
    var collection, element, i, j, len, len1, ref, ref1, trait;
    ref = selections || [];
    for (i = 0, len = ref.length; i < len; i++) {
      element = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get('traitName') === element.trait) {
          trait = collection.findWhere({
            traitValue: element.selection
          });
          if (!trait.get('disabled')) {
            element['id'] = trait.get('id');
            $('#trait-' + collection.models[0].get('traitIndex')).val(element.selection);
            this.render(element, false);
            break;
          }
        }
      }
    }
  };

  Controller.prototype.showErrorMessages = function() {
    var defaultCollections, i, index, len, results;
    VariationsWidget.error.show();
    VariationsWidget.error.$el.addClass("icon-circle-alert");
    defaultCollections = this.findDefaultCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = defaultCollections.length; i < len; i++) {
      index = defaultCollections[i];
      results.push($('#trait-' + index).addClass('select-error'));
    }
    return results;
  };

  Controller.prototype.removeErrorMessages = function() {
    var i, index, len, results, selectedCollections;
    if (!this.areAnySelectionsDefault(VariationsWidget.collections)) {
      VariationsWidget.error.hide();
    }
    selectedCollections = this.findSelectedCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = selectedCollections.length; i < len; i++) {
      index = selectedCollections[i];
      results.push($('#trait-' + index).removeClass('select-error'));
    }
    return results;
  };

  Controller.prototype.areSelectionsDefault = function(collections) {
    return _.every(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.areAnySelectionsDefault = function(collections) {
    return _.some(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.isSelectionDefault = function(selection) {
    return RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(selection);
  };

  Controller.prototype.findDefaultCollections = function(collections) {
    var collection, defaultCollections, i, index, len;
    defaultCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        defaultCollections.push(index);
      }
    }
    return defaultCollections;
  };

  Controller.prototype.findSelectedCollections = function(collections) {
    var collection, i, index, len, selectedCollections;
    selectedCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (!RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        selectedCollections.push(index);
      }
    }
    return selectedCollections;
  };

  return Controller;

})();

module.exports = VariationsWidget.Controller;



},{"../../cart/common/helpers":7,"../../deal/frontend/event_pipe":12}],85:[function(require,module,exports){
var DealEventPipe, VariationsWidget, _scrollToBuyButton;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Collections.Option = require('./models/option-collection');

VariationsWidget.Views.OptionCollection = require('./views/option-collection');

VariationsWidget.Views.Error = require('./views/error');

VariationsWidget.Controller = require('./variations-widget-controller');

DealEventPipe = require('../../deal/frontend/event_pipe');

_scrollToBuyButton = function() {
  var top;
  if ($('#purchase-cluster .buy.fixed').length || $('.header-row-sticked').length || $('.header-row-sticky').length) {
    top = $('.main').position().top - 100;
    return $('body,html').animate({
      scrollTop: top
    }, 500);
  }
};

VariationsWidget.init = function(arg, done) {
  var offer, stickyHeader, variations;
  variations = arg.variations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (variations == null) {
    return done();
  }
  this.options = variations.options, this.traits = variations.traits, this.mappings = variations.mappings, this.uuid = variations.uuid, this.dealOptionUuid = variations.dealOptionUuid, this.preSelectTraits = variations.preSelectTraits, this.printSoldOut = variations.printSoldOut, this.printOptionPrice = variations.printOptionPrice, this.clearTraitsOnCarouselSelection = variations.clearTraitsOnCarouselSelection;
  this.collections = VariationsWidget.Collections.Option.create(this.traits);
  this.offerCollections = offer;
  BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
    return function() {
      if (BuyButton.view.variationsSelected) {
        return;
      }
      _this.controller.showErrorMessages();
      if (stickyHeader) {
        _scrollToBuyButton();
      }
      BuyButton.view.enableBuyButton();
      return {
        stopTheBus: true
      };
    };
  })(this));
  return $((function(_this) {
    return function() {
      var ref;
      _this.views = VariationsWidget.Views.OptionCollection.create(_this.collections);
      _this.error = new VariationsWidget.Views.Error({
        el: '#variation-error'
      });
      _this.controller = new VariationsWidget.Controller();
      if ((ref = _this.options) != null ? ref[0].hideOriginalPriceAndDiscount : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html("");
      }
      $(document.body).on("carouselUpdate", function(e, data) {
        if (data.image !== _this.controller.lastImage) {
          return _this.controller.findMatchingTraits(data.image);
        }
      });
      return done();
    };
  })(this));
};

module.exports = VariationsWidget;



},{"../../deal/frontend/event_pipe":12,"./models/option-collection":82,"./variations-widget-controller":84,"./views/error":86,"./views/option-collection":87}],86:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Error = Backbone.View.extend({
  show: function() {
    return this.$el.show();
  },
  hide: function() {
    return this.$el.hide();
  }
});

module.exports = VariationsWidget.Views.Error;



},{}],87:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = require('./option');

VariationsWidget.Views.OptionCollection = Backbone.View.extend({
  events: {
    "change": "selectionChanged"
  },
  initialize: function() {
    var optionElementModel;
    _.bindAll(this, 'selectionChanged', 'render');
    return this.optionElementViews = (function() {
      var i, len, ref, results;
      ref = this.collection.models;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        optionElementModel = ref[i];
        results.push(new VariationsWidget.Views.Option({
          el: "#trait-" + optionElementModel.get('traitIndex') + "-" + optionElementModel.get('id'),
          model: optionElementModel
        }));
      }
      return results;
    }).call(this);
  },
  render: function() {
    var i, len, optionElementView, ref, results;
    ref = this.optionElementViews;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      optionElementView = ref[i];
      results.push(optionElementView.render());
    }
    return results;
  },
  isSelectedOptionDisabled: function(selectElement) {
    return selectElement != null ? selectElement.options[selectElement.selectedIndex].disabled : void 0;
  },
  selectionChanged: function(e) {
    var $currentElement, model, value;
    $currentElement = $(e.currentTarget)[0];
    if (VariationsWidget.controller.ie7 && this.isSelectedOptionDisabled($currentElement)) {
      $currentElement.selectedIndex = 0;
    }
    value = $(e.currentTarget).val();
    model = this.collection.chosen(value);
    return VariationsWidget.controller.render({
      trait: this.collection.models[0].get('traitName'),
      selection: value,
      id: model.get('id')
    });
  }
});

VariationsWidget.Views.OptionCollection.create = function(collections) {
  var i, index, len, results, trait;
  results = [];
  for (index = i = 0, len = collections.length; i < len; index = ++i) {
    trait = collections[index];
    results.push(new VariationsWidget.Views.OptionCollection({
      collection: trait,
      el: "#trait-" + index
    }));
  }
  return results;
};

module.exports = VariationsWidget.Views.OptionCollection;



},{"./option":88}],88:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = Backbone.View.extend({
  initialize: function() {
    _.bindAll(this, 'render');
    this.model.bind('change:disabled', this.render);
    if (VariationsWidget.printSoldOut) {
      this.model.bind('change:forceDisplay', this.render);
    }
    if (VariationsWidget.printOptionPrice) {
      this.model.bind('change:optionPrice', this.render);
      this.model.bind('change:selected', this.render);
    }
    return this.rtl = $('body').hasClass('rtl');
  },
  render: function() {
    this.$el.attr('disabled', this.model.get('disabled'));
    if (VariationsWidget.printSoldOut) {
      this.renderSoldOut();
    }
    if (VariationsWidget.printOptionPrice) {
      return this.renderPrintOptionPrice();
    }
  },
  renderSoldOut: function() {
    var soldOutText, string;
    soldOutText = typeof I18n !== "undefined" && I18n !== null ? I18n.t('js.modules.variations.sold_out') : void 0;
    string = "<span class=\"sold-out-text\">" + soldOutText + "</span>";
    this.$el.removeClass('force-display');
    this.$el.find('.sold-out-text').remove();
    if (this.model.get('forceDisplay')) {
      this.$el.addClass('force-display');
      if (this.rtl) {
        return this.$el.append(string);
      } else {
        return this.$el.prepend(string);
      }
    }
  },
  renderPrintOptionPrice: function() {
    var isSelected, optionPrice, string;
    optionPrice = this.model.get('optionPrice');
    isSelected = this.model.get('selected');
    string = "<span class=\"option-price\">(" + optionPrice + ")</span>";
    this.$el.find('.option-price').remove();
    if (optionPrice && !isSelected) {
      if (this.rtl) {
        return this.$el.prepend(string);
      } else {
        return this.$el.append(string);
      }
    }
  }
});

module.exports = VariationsWidget.Views.Option;



},{}],89:[function(require,module,exports){
var DealEventPipe, WishlistButton;

WishlistButton = window.WishlistButton != null ? window.WishlistButton : window.WishlistButton = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

WishlistButton = function() {
  var $wishlistButton, $wishlistButtonTextAdd, $wishlistButtonTextRemove, _checkMultiOptionSelection, addItemToWishlist, csrfToken, dealId, init, listenToOptionSelection, onAddItemSuccess, removeItemFromWishlist, selectedOptionUUID, toggleWishlistButtonStyle, updateRemoveItemUrl, updateWishlistedNotifier, wishlistButtonClicked, wishlistPayload;
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null;
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null;
  init = function(arg, done) {
    var carousel, csrf, wishlist;
    carousel = arg.carousel, csrf = arg.csrf, wishlist = arg.wishlist;
    $wishlistButton = $("#add-to-wishlist-btn");
    $wishlistButtonTextAdd = $("#add-to-wishlist-btn-text-add");
    $wishlistButtonTextRemove = $("#add-to-wishlist-btn-text-remove");
    wishlistPayload = wishlist;
    dealId = carousel != null ? carousel.dealId : void 0;
    if (wishlistPayload.singleOptionId) {
      selectedOptionUUID = wishlistPayload.singleOptionId;
    }
    csrfToken = csrf;
    listenToOptionSelection();
    return $(function() {
      $wishlistButton.on("click", wishlistButtonClicked);
      return done();
    });
  };
  updateWishlistedNotifier = function(optionUUID) {
    var optionUUIDFilter;
    $wishlistButton.removeClass("wishlisted");
    $wishlistButtonTextAdd.removeClass("hidden");
    $wishlistButtonTextRemove.addClass("hidden");
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID && _.filter(wishlistPayload.items, optionUUIDFilter).length > 0) {
      $wishlistButton.addClass("wishlisted");
      $wishlistButtonTextAdd.addClass("hidden");
      return $wishlistButtonTextRemove.removeClass("hidden");
    }
  };
  updateRemoveItemUrl = function(optionUUID) {
    var optionUUIDFilter, ref, ref1;
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID) {
      return wishlistPayload.removeItemUrl = (ref = _.filter(wishlistPayload.items, optionUUIDFilter)) != null ? (ref1 = ref[0]) != null ? ref1.removeItemUrl : void 0 : void 0;
    }
  };
  listenToOptionSelection = function() {
    return DealEventPipe.on("priceUpdate", function(priceData) {
      var $tooltip;
      $tooltip = $('#select-option-tooltip');
      GIG.Tooltip.close($tooltip);
      selectedOptionUUID = priceData.variationsSelected && priceData.uuid;
      updateWishlistedNotifier(selectedOptionUUID);
      return updateRemoveItemUrl(selectedOptionUUID);
    });
  };
  toggleWishlistButtonStyle = function() {
    $wishlistButton.toggleClass("wishlisted");
    $wishlistButtonTextAdd.toggleClass("hidden");
    return $wishlistButtonTextRemove.toggleClass("hidden");
  };
  onAddItemSuccess = function(data) {
    var updateWishlistItems;
    updateWishlistItems = function(newItem) {
      var addedItem;
      addedItem = {
        dealId: dealId,
        itemId: newItem.itemId,
        listId: newItem.listId,
        removeItemUrl: "/deals/wishlists_proxy/remove/" + newItem.listId + "/" + newItem.itemId
      };
      if (selectedOptionUUID) {
        addedItem.optionId = selectedOptionUUID;
      }
      return wishlistPayload.items.push(addedItem);
    };
    wishlistPayload.removeItemUrl = "/deals/wishlists_proxy/remove/" + data.listId + "/" + data.itemId;
    toggleWishlistButtonStyle();
    return updateWishlistItems(data);
  };
  _checkMultiOptionSelection = function() {
    return wishlistPayload.isMultiOptionsAvailable && !selectedOptionUUID;
  };
  addItemToWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.addItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        dealId: dealId,
        optionId: selectedOptionUUID ? selectedOptionUUID : void 0,
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $("#wishlist-add-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, status, xhr) {
        return onAddItemSuccess(data);
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  removeItemFromWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.removeItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $("#wishlist-remove-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, textStatus, error) {
        toggleWishlistButtonStyle();
        return wishlistPayload.items = _.filter(wishlistPayload.items, function(i) {
          return i.optionId !== selectedOptionUUID;
        });
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  wishlistButtonClicked = function(e) {
    e.preventDefault();
    if (_checkMultiOptionSelection()) {
      return $wishlistButton.trigger("show-tooltip");
    }
    if ($wishlistButton.hasClass("wishlisted")) {
      return removeItemFromWishlist();
    } else {
      return addItemToWishlist();
    }
  };
  return {
    init: init,
    onAddItemSuccess: onAddItemSuccess
  };
};

window.WishlistButton = WishlistButton();

module.exports = WishlistButton;



},{"../../deal/frontend/event_pipe":12}],90:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],91:[function(require,module,exports){
var TEMPLATES;

TEMPLATES = {
  modal: require('../modal.html.mustache')
};

window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  getTemplate: function(args) {
    return TEMPLATES.modal.render(args);
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref;
    if (path == null) {
      path = window.location.href;
    }
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    try {
      return (ref = frames[this.iframeName]) != null ? ref.IframeLogin.iframeView.resetHeight() : void 0;
    } catch (_error) {
      return window.location.assign(path);
    }
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  module.exports = IframeLogin;
}



},{"../modal.html.mustache":92}],92:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(!_.s(_.f("authenticated",c,p,1),c,p,1,0,0,"")){_.b("  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">");_.b("\n" + i);_.b("    <div class=\"modal-body\">");_.b("\n" + i);_.b("      <a class=\"close-modal icon-x\"></a>");_.b("\n" + i);_.b("      <iframe name=\"modal-login\" src=\"");_.b(_.v(_.f("iframeSrc",c,p,0)));_.b("\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>");_.b("\n" + i);_.b("    </div>");_.b("\n" + i);_.b("  </div>");_.b("\n");};return _.fl();;},"{{^ authenticated }}\n  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">\n    <div class=\"modal-body\">\n      <a class=\"close-modal icon-x\"></a>\n      <iframe name=\"modal-login\" src=\"{{ iframeSrc }}\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>\n    </div>\n  </div>\n{{/ authenticated }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":95}],93:[function(require,module,exports){
var ARROW_KEY_LEFT, ARROW_KEY_RIGHT, NTH_CHILD_FIRST_PANEL,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ARROW_KEY_RIGHT = 39;

ARROW_KEY_LEFT = 37;

NTH_CHILD_FIRST_PANEL = 1;

if (window.instagramPhotoWidget == null) {
  window.instagramPhotoWidget = {};
}

instagramPhotoWidget.init = function(payload, done) {
  if (done == null) {
    done = function() {};
  }
  if ($('.instagram-widget').length) {
    $(window).load(function() {
      return new Groupon.InstagramPhotoWidget(payload);
    });
  }
  return done();
};

Groupon.InstagramPhotoWidget = (function() {
  function InstagramPhotoWidget(arg) {
    var mostPopularContainer;
    this.rootUrl = arg.rootUrl, this.csrf = arg.csrf;
    this.onClickPhotoReport = bind(this.onClickPhotoReport, this);
    this.onImageClick = bind(this.onImageClick, this);
    OptimizeSuite.TrackingHub.add('page-with-instagram-widget', {
      url: window.url
    });
    this.$instagramWidget = $('.instagram-widget');
    this.$photoContainers = this.$instagramWidget.find('.photo-columns');
    this.$loadMorePhotos = this.$instagramWidget.find('.load-more-photos-link');
    this.$showLess = this.$instagramWidget.find('.less-photos');
    this.$reportModal = this.$instagramWidget.find('#reportModal');
    mostPopularContainer = this.$photoContainers[0];
    this.$photoRow = $('.instagram-widget-photo-row', mostPopularContainer);
    this.totalRows = this.$photoRow.length;
    if (this.totalRows > 1) {
      OptimizeSuite.TrackingHub.add("instagram-photo-load-more-link-displayed", {
        totalRows: this.totalRows
      });
    }
    this.lazyLoadImages();
    this.setLoadMorePhotos();
    this.initBindings();
  }

  InstagramPhotoWidget.prototype.lazyLoadImages = function() {
    return this.$instagramWidget.find('.lazy-loaded-image').each(function(position, imageElement) {
      var $image;
      $image = $(imageElement);
      return $image.attr('src', $image.attr('lazy-load-src'));
    });
  };

  InstagramPhotoWidget.prototype.setLoadMorePhotos = function() {
    this.rowsShowing = 1;
    if (this.rowsShowing === this.$photoRow.length) {
      return this.$loadMorePhotos.hide();
    } else {
      this.$showLess.hide();
      return this.$loadMorePhotos.show();
    }
  };

  InstagramPhotoWidget.prototype.initBindings = function() {
    this.$instagramWidget.find('.image-and-caption').hover((function() {
      return $('.instagram-widget-caption', this).fadeIn();
    }), (function() {
      return $('.instagram-widget-caption', this).fadeOut();
    }));
    this.$loadMorePhotos.on('click', (function(_this) {
      return function(e) {
        var $rowsContainer, nthChild;
        OptimizeSuite.TrackingHub.add("instagram-photo-load-more-clicked", {
          rowsShowing: _this.rowsShowing,
          totalRows: _this.totalRows
        });
        $rowsContainer = $(e.currentTarget).closest('.photo-columns');
        nthChild = _this.rowsShowing + NTH_CHILD_FIRST_PANEL;
        _this.$instagramWidget.find(".photo-columns .instagram-widget-photo-row:nth-child(" + nthChild + ")").fadeIn(100);
        _this.rowsShowing += 1;
        if (_this.rowsShowing === $rowsContainer.find('.instagram-widget-photo-row').length) {
          _this.$loadMorePhotos.hide();
          return _this.$showLess.show();
        }
      };
    })(this));
    this.$showLess.on('click', (function(_this) {
      return function() {
        var nthChild;
        nthChild = 1 + NTH_CHILD_FIRST_PANEL;
        return _this.$instagramWidget.find(".instagram-widget-photo-row:nth-child(n+" + nthChild + ")").fadeOut(100, function() {
          _this.$showLess.hide();
          _this.rowsShowing = 1;
          return _this.$loadMorePhotos.show();
        });
      };
    })(this));
    this.$instagramWidget.find('.report-link').on('click', this.onClickPhotoReport);
    this.$instagramWidget.find('.image-and-caption').on('click', this.onImageClick);
    this.$instagramWidget.find('.report-link').on('click', function(e) {
      return e.stopPropagation();
    });
    this.$instagramWidget.find('.user-profile').on('click', function(e) {
      return e.stopPropagation();
    });
    return this.$instagramWidget.find('.report-modal').on('click', function(e) {
      return e.stopPropagation();
    });
  };

  InstagramPhotoWidget.prototype.onImageClick = function(e) {
    var $imageModal, $mainImage, $modalContents, $profileImage, $reportLink, applyNextClickEvent, applyPrevClickEvent, debouncedResize, displayNextPhotoModalContents, getNextImage, getPrevImage, hideShowArrows, onArrowClick, onClosePhotoModal, resize;
    $modalContents = $(e.currentTarget).find('.photo-modal');
    $mainImage = $modalContents.find('.main-image');
    $mainImage.attr('src', $mainImage.attr('lazy-load-modal-src'));
    $profileImage = $modalContents.find('.profile-photo');
    $profileImage.attr('src', $profileImage.attr('lazy-load-modal-src'));
    $imageModal = this.$instagramWidget.find('#instagram-photo-modal');
    $imageModal.html($modalContents.clone());
    onArrowClick = function(e) {
      if (e.which === e.data.key) {
        return e.data.func();
      }
    };
    getNextImage = function($curEl) {
      var $nextEl, ref, ref1;
      if ((ref = $curEl.next()) != null ? ref.hasClass('image-and-caption') : void 0) {
        $nextEl = $curEl.next();
      } else if ((ref1 = $curEl.parent().next()) != null ? ref1.hasClass('instagram-widget-photo-row') : void 0) {
        $nextEl = $('.image-and-caption', $curEl.parent().next()).first();
      } else {
        $nextEl = null;
      }
      return $nextEl;
    };
    getPrevImage = function($curEl) {
      var $prevEl, ref, ref1;
      if ((ref = $curEl.prev()) != null ? ref.hasClass('image-and-caption') : void 0) {
        $prevEl = $curEl.prev();
      } else if ((ref1 = $curEl.parent().prev()) != null ? ref1.hasClass('instagram-widget-photo-row') : void 0) {
        $prevEl = $('.image-and-caption', $curEl.parent().prev()).last();
      } else {
        $prevEl = null;
      }
      return $prevEl;
    };
    onClosePhotoModal = function() {
      return $(document).off('keyup', onArrowClick);
    };
    hideShowArrows = (function(_this) {
      return function($curEl, $curDiv) {
        var $nextEl, $photoModal, $photoModals, $prevEl, imageHeight;
        $nextEl = getNextImage($curEl);
        $prevEl = getPrevImage($curEl);
        $photoModals = $('.instagram-widget .photo-modal');
        $photoModal = $('#instagram-photo-modal .photo-modal');
        $(document).off('keyup', onArrowClick);
        if ($prevEl) {
          $photoModal.append("<a class='prev-slide'><span class='prev' data-bhw='InstagramImageModalPrev'><img src='https://img.grouponcdn.com/asset/37wwmCNCjCCduzJvfmRF/qC-14x23'></span></a>");
          applyPrevClickEvent($prevEl);
        } else {
          $curDiv.find('.photo-modal .prev-slide').hide();
        }
        if ($nextEl) {
          $photoModal.append("<a class='next-slide'><span class='next' data-bhw='InstagramImageModalNext'><img src='https://img.grouponcdn.com/asset/9SPMsC9kXRQjYTVi8uWA/nW-13x22'></span></a>");
          applyNextClickEvent($nextEl);
        } else {
          $curDiv.find('.photo-modal .next-slide').hide();
        }
        imageHeight = _this.$instagramWidget.find('#instagram-photo-modal .main-image').height();
        $photoModals.find('.next').css('top', imageHeight / 2);
        $photoModals.find('.prev').css('top', imageHeight / 2);
        return GIG.Modal.onClose(onClosePhotoModal, 'instagram-photo-modal', true);
      };
    })(this);
    displayNextPhotoModalContents = (function(_this) {
      return function(el) {
        var $image, $newBody, $reportLink;
        $image = $('.photo-modal .main-image', el);
        $image.attr('src', $image.attr('lazy-load-modal-src'));
        $profileImage = $('.photo-modal .profile-photo', el);
        $profileImage.attr('src', $profileImage.attr('lazy-load-modal-src'));
        $newBody = $('.photo-modal', el).clone();
        $newBody.show();
        $('#instagram-photo-modal .photo-modal').replaceWith($newBody);
        $reportLink = $imageModal.find('.report-link');
        return $reportLink.click(_this.onClickPhotoReport);
      };
    })(this);
    applyNextClickEvent = (function(_this) {
      return function(el) {
        var $nextSlide, nextSlideHandler;
        $nextSlide = _this.$instagramWidget.find('.next-slide');
        nextSlideHandler = function(e) {
          displayNextPhotoModalContents(el);
          hideShowArrows(el, el);
          return $nextSlide.mousedown(function(e) {
            return e.preventDefault();
          });
        };
        $nextSlide.on('click', nextSlideHandler);
        return $(document).keyup({
          func: nextSlideHandler,
          key: ARROW_KEY_RIGHT
        }, onArrowClick);
      };
    })(this);
    applyPrevClickEvent = (function(_this) {
      return function(el) {
        var $prevSlide, prevSlideHandler;
        $prevSlide = _this.$instagramWidget.find('.prev-slide');
        prevSlideHandler = function(e) {
          displayNextPhotoModalContents(el);
          hideShowArrows(el, el);
          return $prevSlide.mousedown(function(e) {
            return e.preventDefault();
          });
        };
        $prevSlide.on('click', prevSlideHandler);
        return $(document).keyup({
          func: prevSlideHandler,
          key: ARROW_KEY_LEFT
        }, onArrowClick);
      };
    })(this);
    hideShowArrows($(e.currentTarget), $imageModal);
    $imageModal.find('.photo-modal').show();
    $reportLink = $imageModal.find('.report-link');
    $reportLink.click(this.onClickPhotoReport);
    GIG.Modal.open({
      id: 'instagram-photo-modal'
    });
    resize = (function(_this) {
      return function() {
        var $photoModal, actualTopMargin, calculatedTopMargin, imageHeight, modalHeight;
        modalHeight = _this.$instagramWidget.find('#instagram-photo-modal .photo-modal').height();
        imageHeight = _this.$instagramWidget.find('#instagram-photo-modal .main-image').height();
        $photoModal = _this.$instagramWidget.find('.photo-modal');
        calculatedTopMargin = (window.innerHeight - modalHeight) * 0.5;
        actualTopMargin = Math.max(10, calculatedTopMargin);
        $photoModal.css('margin-top', actualTopMargin);
        $photoModal.find('.next').css('top', imageHeight / 2);
        return $photoModal.find('.prev').css('top', imageHeight / 2);
      };
    })(this);
    resize();
    debouncedResize = _.debounce(resize, 300);
    return $(window).resize(function() {
      return debouncedResize();
    });
  };

  InstagramPhotoWidget.prototype.onClickPhotoReport = function(e) {
    var $reportContents, $reportLink, $reportModalBody, $reportRadioButtons, $reportReasonError, $reportResponseError, $reportRightsLink, actualTopMargin, calculatedTopMargin, errorHandler, imageTile, modalHeight, onPhotoReport, photoId;
    photoId = $(e.currentTarget).attr('data-contentid');
    $reportLink = $(".instagram-widget-caption .report-link[data-contentid=" + photoId + "]:first");
    $reportContents = $reportLink.parents('.image-and-caption').find('.report-modal').clone();
    this.$reportModal.empty();
    this.$reportModal.append($reportContents);
    $reportModalBody = this.$reportModal.find('.report-modal');
    $reportModalBody.show();
    GIG.Modal.open({
      id: 'reportModal'
    });
    modalHeight = $('#reportModal .modal-body').height();
    calculatedTopMargin = (window.innerHeight - modalHeight) * 0.5;
    actualTopMargin = Math.max(10, calculatedTopMargin);
    $reportModalBody.css('margin-top', actualTopMargin);
    imageTile = $reportLink.parents('.image-and-caption');
    $reportRadioButtons = this.$reportModal.find('.report-item');
    $reportReasonError = this.$reportModal.find('.report-reason-error');
    $reportResponseError = this.$reportModal.find('.report-response-error');
    $reportRightsLink = this.$reportModal.find('.report-rights-link');
    errorHandler = function() {
      $reportReasonError.hide();
      return $reportResponseError.show();
    };
    onPhotoReport = (function(_this) {
      return function(e) {
        var $reportContainer, obj, reason;
        $reportRadioButtons.show();
        $reportReasonError.hide();
        $reportResponseError.hide();
        $reportRightsLink.hide();
        $reportContainer = $(e.target).parent().parent();
        photoId = $reportContainer.data('instagramId');
        reason = $reportContainer.find('input:checked').data('reportReason');
        if (reason != null) {
          OptimizeSuite.TrackingHub.add('instagram-photo-reported', {
            photoId: photoId,
            reason: reason
          });
          obj = {
            _csrf: _this.csrf,
            contentId: photoId,
            reason: reason,
            contentProvider: 'instagram',
            agentKey: window.location.href
          };
          return $.ajax({
            url: _this.rootUrl + "/instagram_photo_widget/image_report",
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(obj),
            success: function(res) {
              var images, url;
              if (res.response !== 'ok') {
                return errorHandler();
              }
              $('.report-reason-error').hide();
              url = $('.image-thumb', e.data.imageTile).attr('src');
              images = $("img.image-thumb[src='" + url + "']").parent();
              $('.instagram-widget-caption .report .report-link', images).hide();
              $('.instagram-widget-caption .report .reported-photo', images).show();
              $('.photo-modal .report .report-link', images).hide();
              $('.photo-modal .report .reported-photo', images).show();
              if (reason === 'report-rights') {
                $reportRadioButtons.hide();
                return $reportRightsLink.show();
              } else {
                return GIG.Modal.close();
              }
            }
          });
        } else {
          return $reportReasonError.show();
        }
      };
    })(this);
    return $('.report-submit').click({
      imageTile: imageTile
    }, onPhotoReport);
  };

  return InstagramPhotoWidget;

})();



},{}],94:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      tagTypes = {
        '#': 1, '^': 2, '/': 3,  '!': 4, '>': 5,
        '<': 6, '=': 7, '_v': 8, '{': 9, '&': 10
      };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push(new String(buf));
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (tokens[j].tag && tagTypes[tokens[j].tag] < tagTypes['_v']) ||
          (!tokens[j].tag && tokens[j].match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (!tokens[j].tag) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = tagTypes[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - ctag.length : i + otag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        token = null;

    while (tokens.length > 0) {
      token = tokens.shift();
      if (token.tag == '#' || token.tag == '^' || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
        instructions.push(token);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else {
        instructions.push(token);
      }
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  Hogan.generate = function (tree, text, options) {
    var code = 'var _=this;_.b(i=i||"");' + walk(tree) + 'return _.fl();';
    if (options.asString) {
      return 'function(c,p,i){' + code + ';}';
    }

    return new Hogan.Template(new Function('c', 'p', 'i', code), text, Hogan, options);
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function walk(tree) {
    var code = '';
    for (var i = 0, l = tree.length; i < l; i++) {
      var tag = tree[i].tag;
      if (tag == '#') {
        code += section(tree[i].nodes, tree[i].n, chooseMethod(tree[i].n),
                        tree[i].i, tree[i].end, tree[i].otag + " " + tree[i].ctag);
      } else if (tag == '^') {
        code += invertedSection(tree[i].nodes, tree[i].n,
                                chooseMethod(tree[i].n));
      } else if (tag == '<' || tag == '>') {
        code += partial(tree[i]);
      } else if (tag == '{' || tag == '&') {
        code += tripleStache(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag == '\n') {
        code += text('"\\n"' + (tree.length-1 == i ? '' : ' + i'));
      } else if (tag == '_v') {
        code += variable(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag === undefined) {
        code += text('"' + esc(tree[i]) + '"');
      }
    }
    return code;
  }

  function section(nodes, id, method, start, end, tags) {
    return 'if(_.s(_.' + method + '("' + esc(id) + '",c,p,1),' +
           'c,p,0,' + start + ',' + end + ',"' + tags + '")){' +
           '_.rs(c,p,' +
           'function(c,p,_){' +
           walk(nodes) +
           '});c.pop();}';
  }

  function invertedSection(nodes, id, method) {
    return 'if(!_.s(_.' + method + '("' + esc(id) + '",c,p,1),c,p,1,0,0,"")){' +
           walk(nodes) +
           '};';
  }

  function partial(tok) {
    return '_.b(_.rp("' +  esc(tok.n) + '",c,p,"' + (tok.indent || '') + '"));';
  }

  function tripleStache(id, method) {
    return '_.b(_.t(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function variable(id, method) {
    return '_.b(_.v(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function text(id) {
    return '_.b(' + id + ');';
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  },

  Hogan.cache = {};

  Hogan.compile = function(text, options) {
    // options
    //
    // asString: false (default)
    //
    // sectionTags: [{o: '_foo', c: 'foo'}]
    // An array of object with o and c fields that indicate names for custom
    // section tags. The example above allows parsing of {{_foo}}{{/foo}}.
    //
    // delimiters: A string that overrides the default delimiters.
    // Example: "<% %>"
    //
    options = options || {};

    var key = text + '||' + !!options.asString;

    var t = this.cache[key];

    if (t) {
      return t;
    }

    t = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = t;
  };
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],95:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
module.exports = Hogan; 
},{"./compiler":94,"./template":96}],96:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan, useArrayBuffer) {
  Hogan.Template = function (renderFunc, text, compiler, options) {
    this.r = renderFunc || this.r;
    this.c = compiler;
    this.options = options;
    this.text = text || '';
    this.buf = (useArrayBuffer) ? [] : '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // tries to find a partial in the curent scope and render it
    rp: function(name, context, partials, indent) {
      var partial = partials[name];

      if (!partial) {
        return '';
      }

      if (this.c && typeof partial == 'string') {
        partial = this.c.compile(partial, this.options);
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ls(val, ctx, partials, inverted, start, end, tags);
      }

      pass = (val === '') || !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        return ctx[ctx.length - 1];
      }

      for (var i = 1; i < names.length; i++) {
        if (val && typeof val == 'object' && names[i] in val) {
          cx = val;
          val = val[names[i]];
        } else {
          val = '';
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.lv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        if (v && typeof v == 'object' && key in v) {
          val = v[key];
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.lv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ho: function(val, cx, partials, text, tags) {
      var compiler = this.c;
      var options = this.options;
      options.delimiters = tags;
      var text = val.call(cx, text);
      text = (text == null) ? String(text) : text.toString();
      this.b(compiler.compile(text, options).render(cx, partials));
      return false;
    },

    // template result buffering
    b: (useArrayBuffer) ? function(s) { this.buf.push(s); } :
                          function(s) { this.buf += s; },
    fl: (useArrayBuffer) ? function() { var r = this.buf.join(''); this.buf = []; return r; } :
                           function() { var r = this.buf; this.buf = ''; return r; },

    // lambda replace section
    ls: function(val, ctx, partials, inverted, start, end, tags) {
      var cx = ctx[ctx.length - 1],
          t = null;

      if (!inverted && this.c && val.length > 0) {
        return this.ho(val, cx, partials, this.text.substring(start, end), tags);
      }

      t = val.call(cx);

      if (typeof t == 'function') {
        if (inverted) {
          return true;
        } else if (this.c) {
          return this.ho(t, cx, partials, this.text.substring(start, end), tags);
        }
      }

      return t;
    },

    // lambda replace variable
    lv: function(val, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = val.call(cx);

      if (typeof result == 'function') {
        result = coerceToString(result.call(cx));
        if (this.c && ~result.indexOf("{\u007B")) {
          return this.c.compile(result, this.options).render(cx, partials);
        }
      }

      return coerceToString(result);
    }

  };

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos =/\'/g,
      rQuot = /\"/g,
      hChars =/[&<>\"\']/;


  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp,'&amp;')
        .replace(rLt,'&lt;')
        .replace(rGt,'&gt;')
        .replace(rApos,'&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);


},{}],97:[function(require,module,exports){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var MagicEventBus;
  MagicEventBus = function () {
    function MagicEventBus() {
      this.handlers = {};
      this.statuses = {};
    }
    MagicEventBus.prototype.board = function (eventName, callback, errorHandler) {
      var position;
      if (null != this.handlers[eventName])
        this.handlers[eventName];
      else
        this.handlers[eventName] = [];
      position = this._pushHandler(eventName, callback, errorHandler);
      return function (this$) {
        return function (zIndex) {
          return this$.handlers[eventName][position].zIndex = zIndex;
        };
      }(this);
    };
    MagicEventBus.prototype.go = function (eventName) {
      var handler, sortedHandlers;
      if (!(null != this.handlers[eventName]))
        return false;
      this.statuses[eventName] = 'going';
      sortedHandlers = this.handlers[eventName].slice().sort(function (a, b) {
        return (a.zIndex || 0) - (b.zIndex || 0);
      });
      for (var i$ = 0, length$ = sortedHandlers.length; i$ < length$; ++i$) {
        handler = sortedHandlers[i$];
        if (this.statuses[eventName] === 'stopTheBus')
          break;
        this._callback(eventName, handler);
      }
      return this.statuses[eventName] = 'stopped';
    };
    MagicEventBus.prototype._callback = function (eventName, param$) {
      var cache$, callback, errorHandler, results;
      {
        cache$ = param$;
        callback = cache$.callback;
        errorHandler = cache$.errorHandler;
      }
      results = function () {
        var error;
        try {
          return callback();
        } catch (e$) {
          error = e$;
          if ('undefined' !== typeof TrackingHub && null != TrackingHub)
            TrackingHub.add('MagicEventBus ' + eventName + ' Error', { error: error });
          if ('function' === typeof errorHandler)
            return errorHandler();
        }
      }.call(this);
      if (null != results ? results.stopTheBus : void 0)
        return this.statuses[eventName] = 'stopTheBus';
    };
    MagicEventBus.prototype._pushHandler = function (eventName, callback, errorHandler) {
      this.handlers[eventName].push({
        callback: callback,
        errorHandler: errorHandler
      });
      return this.handlers[eventName].length - 1;
    };
    return MagicEventBus;
  }();
  if ('undefined' !== typeof window && null != window)
    window.MagicEventBus = MagicEventBus;
  if ('undefined' !== typeof module && null != module)
    module.exports = MagicEventBus;
}.call(this);

},{}],98:[function(require,module,exports){
//! moment.js
//! version : 2.11.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')$', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')$', 'i');
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             if (this.isValid() && other.isValid()) {
                 return other < this ? this : other;
             } else {
                 return valid__createInvalid();
             }
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this > +localInput;
        } else {
            return +localInput < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this < +localInput;
        } else {
            return +this.clone().endOf(units) < +localInput;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return +this === +localInput;
        } else {
            inputMs = +localInput;
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // JSON.stringify(new Date(NaN)) === 'null'
        return this.isValid() ? this.toISOString() : 'null';
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        // console.log("got", weekYear, week, weekday, "set", date.toISOString());
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = local__createLocal([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = getSet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = getSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto._months           = defaultLocaleMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto._monthsRegex      = defaultMonthsRegex;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.11.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],99:[function(require,module,exports){
var CountdownTimerView, FourPackCarouselView, FullWidthCarousel, GoodsCarouselView, ResponsiveCarouselView, RightRailView, VideoWidgetView, base,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FourPackCarouselView = (function(superClass) {
  extend(FourPackCarouselView, superClass);

  function FourPackCarouselView() {
    return FourPackCarouselView.__super__.constructor.apply(this, arguments);
  }

  FourPackCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  FourPackCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.currentPosition = 0;
    this.currentPage = 1;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.visibleCards = 4;
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  FourPackCarouselView.prototype._buildNavigation = function() {
    var i, lastPage, page, ref;
    lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards);
    for (page = i = 1, ref = lastPage; 1 <= ref ? i <= ref : i >= ref; page = 1 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "'></li>");
    }
    return this.$('.page-1').addClass('active');
  };

  FourPackCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  FourPackCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    this.currentPage -= 1;
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    this.currentPage += 1;
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards > this.maxPosition) {
      return this.animate(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  FourPackCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  FourPackCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  FourPackCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  FourPackCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * 239)
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * 239)
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  FourPackCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return FourPackCarouselView;

})(Backbone.View);

RightRailView = (function(superClass) {
  extend(RightRailView, superClass);

  function RightRailView() {
    this.setFixPoint = bind(this.setFixPoint, this);
    this.shouldFix = bind(this.shouldFix, this);
    this.atBottom = bind(this.atBottom, this);
    this.floatView = bind(this.floatView, this);
    return RightRailView.__super__.constructor.apply(this, arguments);
  }

  RightRailView.prototype.initialize = function() {
    this.container = $(window);
    this.document = $(document);
    this.header = $(".header");
    this.banner = $(".in-app-msg-banner");
    this.bannerCloseBtn = $(".in-app-msg-banner .hide-link");
    this.footer = $(".footer-i18n");
    this.fixedTopMargin = 50;
    this.fixPoint = 0;
    this.setFixPoint();
    this.floatView();
    this.container.scroll(this.floatView);
    return this.bannerCloseBtn.click(this.setFixPoint);
  };

  RightRailView.prototype.floatView = function() {
    this.$el.removeClass('fixed top bottom');
    if (this.shouldFix()) {
      return this.$el.addClass('fixed');
    } else if (this.atBottom()) {
      return this.$el.addClass('bottom');
    } else {
      return this.$el.addClass('top');
    }
  };

  RightRailView.prototype.atBottom = function() {
    return this.container.scrollTop() + this.$el.outerHeight() + this.fixedTopMargin > this.document.height() - this.footer.outerHeight();
  };

  RightRailView.prototype.shouldFix = function() {
    return this.container.scrollTop() > this.fixPoint && !this.atBottom();
  };

  RightRailView.prototype.setFixPoint = function() {
    return this.fixPoint = this.header.position().top + this.outerHeightWithMargin(this.header) + this.outerHeightWithMargin(this.banner) - this.fixedTopMargin;
  };

  RightRailView.prototype.outerHeightWithMargin = function(element) {
    if (!element.is(':visible')) {
      return 0;
    }
    return element.outerHeight(true);
  };

  return RightRailView;

})(Backbone.View);

VideoWidgetView = (function(superClass) {
  extend(VideoWidgetView, superClass);

  function VideoWidgetView() {
    this.resetVideoPlayer = bind(this.resetVideoPlayer, this);
    this.onCreate = bind(this.onCreate, this);
    return VideoWidgetView.__super__.constructor.apply(this, arguments);
  }

  VideoWidgetView.prototype.events = {
    'click .image-container': 'playVideo'
  };

  VideoWidgetView.videoIsloaded = false;

  VideoWidgetView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.video = this.$('.video-container');
    this.imageContainer = this.$('.image-container');
    this.previewImageAndPlayButton = this.$('.image-container img');
    this.videoId = this.video.data('video-id');
    if (!this.videoIsloaded) {
      return this.loadVideoPlayer();
    }
  };

  VideoWidgetView.prototype.onCreate = function(player) {
    return player.subscribe('played', 'myPage', this.resetVideoPlayer);
  };

  VideoWidgetView.prototype.resetVideoPlayer = function() {
    this.imageContainer.removeClass('hidden');
    this.previewImageAndPlayButton.animate({
      opacity: 0.8,
      duration: 100
    });
    return this.videoPlayer.seek(0);
  };

  VideoWidgetView.prototype.fetchVideoPlayer = function() {
    return OO.ready((function(_this) {
      return function() {
        var options;
        options = {
          flashParams: {
            hide: 'info,endscreen'
          },
          onCreate: _this.onCreate
        };
        return _this.videoPlayer = OO.Player.create('ooyala-player', _this.videoId, options);
      };
    })(this));
  };

  VideoWidgetView.prototype.loadVideoPlayer = function() {
    var script;
    script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388";
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          this.videoIsloaded = true;
        }
      };
    } else {
      script.onload = function() {
        this.videoIsloaded = true;
      };
    }
    $("head").append(script);
  };

  VideoWidgetView.prototype.playVideo = function() {
    if (!this.videoPlayer) {
      this.fetchVideoPlayer();
    }
    this.videoPlayer.play();
    this.imageContainer.addClass('hidden');
    return this.previewImageAndPlayButton.css({
      opacity: 0
    });
  };

  return VideoWidgetView;

})(Backbone.View);

CountdownTimerView = (function(superClass) {
  extend(CountdownTimerView, superClass);

  function CountdownTimerView() {
    this.getNewTimeStamp = bind(this.getNewTimeStamp, this);
    this.updateCountdown = bind(this.updateCountdown, this);
    return CountdownTimerView.__super__.constructor.apply(this, arguments);
  }

  CountdownTimerView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.offerEndTime = $('.steals-timer').data('offer-end-time');
    this.tick = 1000;
    this.getNewTimeStamp();
    return this.updateCountdown();
  };

  CountdownTimerView.prototype.updateCountdown = function() {
    return setInterval(this.getNewTimeStamp, this.tick);
  };

  CountdownTimerView.prototype.timeRemaining = function(timeRemainingMilliseconds) {
    var days, hours, millisecondsLeft, minutes, seconds;
    if (timeRemainingMilliseconds == null) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
    millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
    hours = Math.floor(millisecondsLeft / (1000 * 3600));
    millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
    minutes = Math.floor(millisecondsLeft / (1000 * 60));
    millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
    seconds = Math.floor(millisecondsLeft / 1000);
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };

  CountdownTimerView.prototype.millisRemaining = function(endTime) {
    var millsRemaining, rightNow;
    if (endTime == null) {
      return 0;
    }
    rightNow = new Date().getTime();
    millsRemaining = endTime - rightNow;
    if (millsRemaining < 0) {
      return 0;
    } else {
      return millsRemaining;
    }
  };

  CountdownTimerView.prototype.countdownTimestamp = function(timeLeft) {
    var hh, mm, ss;
    hh = this.addLeadingZero(timeLeft.hours);
    mm = this.addLeadingZero(timeLeft.minutes);
    ss = this.addLeadingZero(timeLeft.seconds);
    return " " + hh + ":" + mm + ":" + ss;
  };

  CountdownTimerView.prototype.addLeadingZero = function(number) {
    if (number < 0) {
      return;
    }
    if (number < 10) {
      return "0" + number;
    } else {
      return "" + number;
    }
  };

  CountdownTimerView.prototype.getNewTimeStamp = function() {
    var endTime, millisLeft, newTimeStamp, ref;
    if (((ref = this.offerEndTime) != null ? ref.length : void 0) < 1) {
      this.offerEndTime = this.getEndOfDayTime();
    }
    endTime = Date.parse(this.offerEndTime);
    millisLeft = this.millisRemaining(endTime);
    newTimeStamp = this.countdownTimestamp(this.timeRemaining(millisLeft));
    return this.$el.html(newTimeStamp);
  };

  CountdownTimerView.prototype.getEndOfDayTime = function() {
    var date;
    date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  };

  return CountdownTimerView;

})(Backbone.View);

GoodsCarouselView = (function(superClass) {
  extend(GoodsCarouselView, superClass);

  function GoodsCarouselView() {
    this.start = bind(this.start, this);
    return GoodsCarouselView.__super__.constructor.apply(this, arguments);
  }

  GoodsCarouselView.prototype.events = {
    "click .goods-carousel-navbar .icon-arrow-left-large": "slideLeft",
    "click .goods-carousel-navbar .icon-arrow-right-large": "slideRight",
    "click .goods-carousel-navbar .icon-circle": "navigateToNavItem"
  };

  GoodsCarouselView.prototype.initialize = function() {
    this.interval = 6000;
    this.size = this.$(".carousel-slide").length;
    this.fadeDuration = 20;
    if (this.size > 1) {
      this.position = 1;
      this.$slides = this.$('.carousel-slide');
      this.$navs = this.$('.goods-carousel-navbar .icon-circle');
      return setTimeout(this.start, this.interval);
    }
  };

  GoodsCarouselView.prototype.slideLeft = function() {
    this.stop();
    return this.slide('left');
  };

  GoodsCarouselView.prototype.slideRight = function() {
    this.stop();
    return this.slide();
  };

  GoodsCarouselView.prototype.navigateToNavItem = function(e) {
    var position;
    position = $(e.currentTarget).data('position');
    this.stop();
    return this.updateCarousel(position);
  };

  GoodsCarouselView.prototype.start = function() {
    this.slide();
    return this.slider = setTimeout(this.start, this.interval);
  };

  GoodsCarouselView.prototype.stop = function() {
    return window.clearTimeout(this.slider);
  };

  GoodsCarouselView.prototype.slide = function(direction) {
    if (direction == null) {
      direction = 'right';
    }
    return this.updateCarousel(this.nextPosition(direction));
  };

  GoodsCarouselView.prototype.nextPosition = function(direction) {
    if (direction === 'right') {
      if (this.position < this.size) {
        return this.position + 1;
      } else {
        return 1;
      }
    } else {
      if (this.position > 1) {
        return this.position - 1;
      } else {
        return this.size;
      }
    }
  };

  GoodsCarouselView.prototype.updateCarousel = function(nextPosition) {
    if (this.position === nextPosition) {
      return;
    }
    this.updateSlide(nextPosition);
    this.updateNav(nextPosition);
    return this.position = nextPosition;
  };

  GoodsCarouselView.prototype.updateSlide = function(nextPosition) {
    var currentSlide, nextSlide;
    currentSlide = this.$slides.filter('.current-slide');
    nextSlide = this.$slides.filter("[data-position='" + nextPosition + "']");
    currentSlide.fadeTo(this.fadeDuration, 0);
    currentSlide.hide().removeClass("current-slide");
    return nextSlide.show().fadeTo(this.fadeDuration, 1).addClass("current-slide");
  };

  GoodsCarouselView.prototype.updateNav = function(nextPosition) {
    var currentNav, nextNav;
    currentNav = this.$navs.filter('.current-slide');
    nextNav = this.$navs.filter("[data-position='" + nextPosition + "']");
    currentNav.removeClass("current-slide");
    return nextNav.addClass("current-slide");
  };

  return GoodsCarouselView;

})(Backbone.View);

FullWidthCarousel = (function(superClass) {
  extend(FullWidthCarousel, superClass);

  function FullWidthCarousel() {
    this._setGutters = bind(this._setGutters, this);
    return FullWidthCarousel.__super__.constructor.apply(this, arguments);
  }

  FullWidthCarousel.prototype.events = {
    'click .full-width-carousel-prev': 'triggerPrev',
    'click .full-width-carousel-next': 'triggerNext',
    'click .full-width-carousel-dot': 'triggerNavDot'
  };

  FullWidthCarousel.prototype.initialize = function() {
    this.$listbox = this.$el.find('[role=listbox]');
    this.pixelsToMove = this._pixelsToMove();
    this.centeredViewportLeft = this.$listbox.css('left');
    this._initalizeGutters();
    this._animationDuration = 200;
    this._numberNavDots = this.$el.find('.full-width-carousel-dot').length;
    this._lazyLoadAllImages();
    return this._updateSelectedDeals();
  };

  FullWidthCarousel.prototype._lazyLoadAllImages = function() {
    var container;
    container = this.$('.full-width-carousel-container');
    return this.$('.lazy-load').lazyload({
      container: container,
      threshold: this.$listbox.width()
    });
  };

  FullWidthCarousel.prototype.triggerNavDot = function(event) {
    var newPosition, oldPosition;
    event.preventDefault();
    newPosition = $(event.currentTarget).data('index');
    oldPosition = this.$el.find('.full-width-carousel-dot-selected').data('index');
    this._updateNavDotSelected(newPosition);
    switch (false) {
      case !(oldPosition < newPosition):
        return this._moveRight(newPosition - oldPosition);
      case !(newPosition < oldPosition):
        return this._moveLeft(oldPosition - newPosition);
    }
  };

  FullWidthCarousel.prototype.triggerNext = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected + 1);
    this._updateNavDotSelected(newPosition);
    return this._moveRight();
  };

  FullWidthCarousel.prototype.triggerPrev = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected - 1);
    this._updateNavDotSelected(newPosition);
    return this._moveLeft();
  };

  FullWidthCarousel.prototype._initalizeGutters = function() {
    var throttledGutters;
    throttledGutters = _.throttle(this._setGutters, 300);
    throttledGutters();
    return $(window).on("resize", throttledGutters);
  };

  FullWidthCarousel.prototype._setGutters = function() {
    return $(".full-width-carousel-viewport").css("left", this._gutterWidth());
  };

  FullWidthCarousel.prototype._gutterWidth = function() {
    var carouselViewport, carouselViewportWidth, windowWidth;
    windowWidth = $(window).width();
    carouselViewport = this.$el.find(".full-width-carousel-viewport");
    carouselViewportWidth = carouselViewport.width();
    return (windowWidth - carouselViewportWidth) / 2;
  };

  FullWidthCarousel.prototype._wrapPosition = function(index) {
    return (index + this._numberNavDots) % this._numberNavDots;
  };

  FullWidthCarousel.prototype._moveRight = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(0, 3);
    this.$listbox.append($images);
    this.$listbox.css('left', -960);
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveRight(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(-this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._moveLeft = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(-3);
    this.$listbox.prepend($images);
    this.$listbox.css('left', -(960 * 3));
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveLeft(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._transition = function(movePixels, nextAnimation) {
    var completionCallback;
    completionCallback = (function(_this) {
      return function() {
        if (nextAnimation) {
          nextAnimation();
        }
        return _this._updateSelectedDeals();
      };
    })(this);
    return this.$listbox.stop().animate({
      left: "+=" + movePixels
    }, {
      easing: 'linear',
      duration: this._animationDuration,
      complete: completionCallback
    });
  };

  FullWidthCarousel.prototype._updateSelectedDeals = function() {
    var items;
    items = this.$listbox.find('.full-width-carousel-item');
    items.removeClass('full-width-carousel-item-selected');
    return items.slice(6, 9).addClass('full-width-carousel-item-selected');
  };

  FullWidthCarousel.prototype._pixelsToMove = function() {
    var activeItems, fullWidthItemFinalWidth, includeMargin;
    activeItems = 3;
    includeMargin = true;
    fullWidthItemFinalWidth = $(".full-width-carousel-item").first().outerWidth(includeMargin);
    return fullWidthItemFinalWidth * activeItems;
  };

  FullWidthCarousel.prototype._updateNavDotSelected = function(indexToSelect) {
    this.$el.find('.full-width-carousel-dot').removeClass('full-width-carousel-dot-selected');
    return this.$el.find(".full-width-carousel-dot[data-index=" + indexToSelect + "]").addClass('full-width-carousel-dot-selected');
  };

  return FullWidthCarousel;

})(Backbone.View);

ResponsiveCarouselView = (function(superClass) {
  extend(ResponsiveCarouselView, superClass);

  function ResponsiveCarouselView() {
    this.recalculate = bind(this.recalculate, this);
    return ResponsiveCarouselView.__super__.constructor.apply(this, arguments);
  }

  ResponsiveCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  ResponsiveCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.$header = this.$('.section-head');
    this.containerWidth = this.$el.outerWidth();
    this.currentPosition = 0;
    this.currentPage = 0;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.gap = 70;
    this.cardSize = 240;
    this.mainContentWidth = 960;
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    $(window).resize(this, this.recalculate);
    this._alignTitle();
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  ResponsiveCarouselView.prototype._buildNavigation = function() {
    var i, page, ref;
    this.lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards) - 1;
    for (page = i = 0, ref = this.lastPage; 0 <= ref ? i <= ref : i >= ref; page = 0 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "' data-page='" + page + "' data-bhc='control:circle" + page + "'></li>");
    }
    $('.page-count').on('click', (function(_this) {
      return function(e) {
        _this.currentPage = $(e.currentTarget).data('page');
        if (_this.currentPage === _this.lastPage) {
          return _this.animateLastRight(_this.maxPosition - (_this.visibleCards - 1));
        } else {
          return _this.animate(_this.currentPage * _this.visibleCards);
        }
      };
    })(this));
    return this._calculateCurrentPage();
  };

  ResponsiveCarouselView.prototype._calculateCurrentPage = function() {
    this.currentPage = Math.floor(this.currentPosition / this.visibleCards);
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.currentPage === this.lastPage) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    }
  };

  ResponsiveCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  ResponsiveCarouselView.prototype._alignTitle = function() {
    if (this.containerWidth > this.mainContentWidth) {
      return this.$header.css({
        'margin-left': Math.floor((this.containerWidth - this.mainContentWidth) / 2)
      });
    }
  };

  ResponsiveCarouselView.prototype.recalculate = function() {
    this.containerWidth = this.$el.outerWidth();
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    this._alignTitle();
    this.$pagesList.empty();
    return this._buildNavigation();
  };

  ResponsiveCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage > 0) {
      this.currentPage -= 1;
    }
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage < this.lastPage) {
      this.currentPage += 1;
    }
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards >= this.maxPosition) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  ResponsiveCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  ResponsiveCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  ResponsiveCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  ResponsiveCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.gap
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.gap
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.animateLastRight = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return ResponsiveCarouselView;

})(Backbone.View);

if (window.WLS == null) {
  window.WLS = {};
}

if ((base = window.WLS).Views == null) {
  base.Views = {};
}

window.WLS.Views.FourPackCarousel = FourPackCarouselView;

window.WLS.Views.RightRail = RightRailView;

window.WLS.Views.VideoWidget = VideoWidgetView;

window.WLS.Views.CountdownTimer = CountdownTimerView;

window.WLS.Views.GoodsCarouselView = GoodsCarouselView;

window.WLS.Views.FullWidthCarousel = FullWidthCarousel;

window.WLS.Views.ResponsiveCarousel = ResponsiveCarouselView;

WLS.init = function($el) {
  if ($el == null) {
    $el = $(document.body);
  }
  $el.find('.right-rail').each(function(index, el) {
    return new WLS.Views.RightRail({
      el: el
    });
  });
  $el.find('.carousel-widget').each(function(index, el) {
    return new WLS.Views.FourPackCarousel({
      el: el
    });
  });
  $el.find('.video-widget').each(function(index, el) {
    return new WLS.Views.VideoWidget({
      el: el
    });
  });
  $el.find('.steals-timer').each(function(index, el) {
    return new WLS.Views.CountdownTimer({
      el: el
    });
  });
  $el.find('.goods-carousel').each(function(index, el) {
    return new WLS.Views.GoodsCarouselView({
      el: el
    });
  });
  $('.full-width-carousel').each(function(index, el) {
    return new WLS.Views.FullWidthCarousel({
      el: el
    });
  });
  return $el.find('.responsive-carousel-widget').each(function(index, el) {
    return new WLS.Views.ResponsiveCarousel({
      el: el
    });
  });
};

$(window).load(function() {
  return WLS.init();
});



},{}]},{},[2])

